<template>
  <div>
    <choose-store-modal @copyStore="copyStore" :option="storeOption" tooltip="此操作將會覆蓋該門市原有的設定內容"></choose-store-modal>
    <m-modal :option="delExceptionOption" @trigger="trigger"></m-modal>
    <div class="box text-center">
      <h1
        v-if="storeInfo.brand_name"
        style="position: absolute; top: -74px; left: 165px; font-size: 18px;"
      >
      {{ storeInfo.brand_name }} - {{ storeInfo.name_short }}
    </h1>
    <div class="box-body">
      <ul class="nav nav-tabs">
        <li
          role="presentation"
          :class="{'active': storeMethod == 1}"
          @click="changeTab(1)"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">基本資訊</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 2}"
          @click="changeTab(2)"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">細部設定</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 3}"
          @click="changeTab(3)"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">預訂/訂購時間</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 4}"
          @click="changeTab(4)"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">付款方式</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 5}"
          @click="changeTab(5)"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">製作/取餐時間</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 6}"
          @click="changeTab(6)"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">取餐方式/門檻</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 7}"
          @click="changeTab(7)"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">營業/公休時間</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 8}"
          @click="changeTab(8)"
          v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10"
          >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">塑膠袋</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 10}"
          @click="changeTab(10)"
          v-if="info && getRoleType === 99"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">出單機</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 11}"
          @click="changeTab(11)"
          v-if="$route.name !== 'crStore'"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">網址設定</a>
        </li>
        <!--確認陣列中是否有900數值-->
        <li
          role="presentation"
          :class="{'active': storeMethod == 12}"
          @click="changeTab(12)"
          v-if="getRoleType === 99 && hasCommissionPermission"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">計費方式設定</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 13}"
          @click="storeMethod = 13"
          v-if="getRoleType === 99"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">物流設定</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 14}"
          @click="changeTab(14)"
          v-if="getRoleType === 99"
        >
          <a :class="{'cursor-none' : $route.name === 'crStore'}">服務費設定</a>
        </li>
        <li
          role="presentation"
          :class="{'active': storeMethod == 15}"
          @click="storeMethod = 15"
          v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10"
          >
          <a>特殊需求</a>
        </li>
      </ul>
    </div>

    <!-- 店家資訊 -->
    <div
      class="box-body form"
      v-show="storeMethod === 1"
    >
      <div v-if="getRoleType === 99">
        <div>
          <h3>店家資訊</h3>
        </div>

        <!-- 店名 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              店名
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.name"
              maxlength="20"
            />
          </div>
          <br>
        </div>
        <!-- End 店名 -->

        <!-- 店名縮寫 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              店名縮寫
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.name_short"
              maxlength="20"
            />
          </div>
          <br>
        </div>
        <!-- End 店名縮寫 -->

        <!-- 群組 -->
        <div v-if="$route.name !== 'upStore'">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              群組
            </span>
            <div class="form-group">
              <select class="form-control" v-model="groupSelect">
                <option
                  v-for="(group, i) in groupList"
                  :key="i"
                  :value="group.id"
                >
                  {{ group.name }}
                </option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 群組 -->

        <!-- 城市 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              城市
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。
                </span>
              </span>
            </span>
            <div class="form-group">
              <select class="form-control" v-model="citySelect">
                <option
                  v-for="(city, i) in cityOption"
                  :key="i"
                  :value="city.value"
                >
                  {{ city.name }}
                </option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 城市 -->

        <!-- 區域 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              區域
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。
                </span>
              </span>
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="areaSelect"
              >
                <option
                  v-for="(area, i) in areaOption"
                  :key="i"
                  :value="area.value"
                >
                  {{ area.name }}
                </option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 區域 -->

        <!-- 地址 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              地址
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。
                </span>
              </span>
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.address_short"
              maxlength="120"
            />
          </div>
          <br />
        </div>
        <!-- End 地址 -->

        <!-- 地址備註 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              地址備註
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.address_remark"
              maxlength="45"
            />
          </div>
          <br />
        </div>
        <!-- End 地址備註 -->

        <!-- 電話1 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              電話1
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.tel"
              maxlength="15"
              @keyup="verityTel"
              ref="tel"
            />
          </div>
          <br />
        </div>
        <!-- End 電話1 -->

        <!-- 電話2 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              電話2
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.tel2"
              maxlength="15"
              @keyup="verityTel2"
              ref="tel2"
            />
          </div>
          <br />
        </div>
        <!-- End 電話2 -->

        <!-- 電子信箱 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              電子信箱
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.email"
              maxlength="50"
            />
          </div>
          <br />
        </div>
        <!-- End 電子信箱 -->

        <!-- 描述 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              描述
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.description"
              maxlength="100"
            />
          </div>
          <br />
        </div>
        <!-- End 描述 -->

        <!-- 描述(搜尋引擎顯示) -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              描述(搜尋引擎顯示)
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.search_description"
              maxlength="100"
            />
          </div>
          <br />
        </div>
        <!-- End 描述(搜尋引擎顯示) -->

        <!-- 品牌頁介紹 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              品牌頁介紹
            </span>
            <textarea
              class="w-100-p form-control"
              name="introduction"
              v-model="storeInfo.introduction"
              cols="30"
              rows="10"
              maxlength="65535"
            />
          </div>
          <br />
        </div>
        <!-- End 品牌頁介紹 -->

        <!-- Youtube影片代碼 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              Youtube影片代碼
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.youtube_video_code"
              maxlength="50"
            />
          </div>
          <br />
        </div>
        <!-- End Youtube影片代碼 -->

        <!-- 店家公告 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              店家公告
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.comment"
              maxlength="20"
            />
          </div>
          <br />
        </div>
        <!-- End 店家公告 -->

        <!-- 統一編號 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              統一編號
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.ein"
              maxlength="8"
              @keyup="verityEin"
              ref="ein"
            />
          </div>
          <br />
        </div>
        <!-- End 統一編號 -->

        <!-- 抬頭 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              抬頭
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.bl_name"
              maxlength="45"
            />
          </div>
          <br />
        </div>
        <!-- End 抬頭 -->

        <!-- 食品業者登錄字號 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              食品業者登錄字號
            </span>
            <input
              class="form-control"
              ref="foodBusinessNo"
              type="text"
              maxlength="19"
              placeholder="範例：F-123456789-00000-0"
              v-model="storeInfo.food_business_no"
            />
          </div>
          <br />
        </div>
        <!-- End 食品業者登錄字號 -->

        <!-- 肉品產地說明 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              肉品產地說明
            </span>
            <textarea
              class="form-control"
              rows="5"
              maxlength="500"
              placeholder="範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
              v-model="storeInfo.meat_origin_description"
            />
          </div>
          <br />
        </div>
        <!-- End 肉品產地說明 -->

        <!-- 圖片 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              LOGO
            </span>
            <div
              class="input-group-addon w-100-p text-center p-all-0 bg-white"
              style="border-right: none;"
            >
              <span class="inline-block h-auto m-t-5">
                <div v-if="!storeInfo.image_name" class="text-black" v-text="'沒有圖片'" />
                <img
                  :src="storeInfo.image_name"
                  class="h-auto img-responsive"
                  v-if="storeInfo.image_name"
                  data-toggle="modal"
                />
              </span>
            </div>
            <div class="form-control h-100">
              <div
                v-if="imgLogoOption.length"
                class="pull-left"
              >
                <select
                  class="form-control"
                  v-model="imgLogoSelect"
                >
                  <option
                    v-for="(img, i) in imgLogoOption"
                    :key="i"
                    :value="img.name"
                  >
                    {{ img.name }}
                  </option>
                </select>
              </div>
              <div class="pull-left">
                <label
                  class="btn-upload btn btn-default"
                  style="margin-top: 8px;"
                  for="brand-img-load"
                  :class="{'m-t-25': !imgLogoOption.length}"
                >
                  選擇圖片
                </label>
                <input
                  class="form-control"
                  type="file"
                  style="display: none;"
                  @change="onFileChange"
                  id="brand-img-load"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-right text-15 text-red">
          (圖片大小為200x200)
          <br />
        </div>
        <!-- End 圖片 -->

        <!-- 底圖照片 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              底圖照片
            </span>
            <div
              class="input-group-addon w-100-p text-center p-all-0 bg-white"
              style="border-right: none;"
            >
              <span class="inline-block h-auto m-t-5">
                <div
                  v-if="!storeInfo.photo_name"
                  class="text-black"
                  v-text="'沒有圖片'"
                />
                <img
                  :src="storeInfo.photo_name"
                  class="h-auto img-responsive"
                  v-if="storeInfo.photo_name"
                  data-toggle="modal"
                />
              </span>
            </div>
            <div class="form-control h-100">
              <label
                class="btn-upload btn btn-default"
                style="margin-top: 25px;"
                for="brand-photo-load"
              >
                選擇圖片
              </label>
              <input
                class="form-control"
                type="file"
                style="display: none;"
                @change="onPhotoFileChange"
                id="brand-photo-load"
              />
            </div>
          </div>
        </div>
        <div
          class="text-right text-15 text-red"
        >
          (圖片大小為800x460)
          <br />
        </div>
        <!-- End 底圖照片 -->

        <!-- 餐點種類 -->
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              餐點種類
            </span>
            <div>
              <multiselect
                v-model="storeInfo.binding_meal_tag_ids"
                tag-placeholder="餐點種類"
                placeholder="餐點種類"
                label="label"
                track-by="value"
                :options="mealTagList"
                :multiple="true"
              />
            </div>
          </div>
          <br />
        </div>
        <!-- End 餐點種類 -->

        <!-- 品牌下店家代碼 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              品牌下店家代碼
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.branch_code"
            />
          </div>
          <br />
        </div>
        <!-- End 品牌下店家代碼 -->

        <!-- POS店家代碼 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              POS店家代碼
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.pos_branch_code"
            />
          </div>
          <br />
        </div>
        <!-- End POS店家代碼 -->
      </div>

      <!-- 品牌權限和門市權限的部分 -->
      <div v-if="getRoleType === 10 || getRoleType === 30">
        <div>
          <h3>店家資訊</h3>
        </div>
        <br />

        <!-- 店家公告 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              店家公告
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.comment"
              maxlength="20"
            />
          </div>
          <br />
        </div>
        <!-- End 店家公告 -->

        <!-- 城市 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              城市
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。
                </span>
              </span>
            </span>
            <div class="form-group">
              <select class="form-control" v-model="citySelect">
                <option
                  v-for="(city, i) in cityOption"
                  :key="i"
                  :value="city.value"
                >
                  {{ city.name }}
                </option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 城市 -->

        <!-- 區域 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              區域
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。
                </span>
              </span>
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="areaSelect"
              >
                <option
                  v-for="(area, i) in areaOption"
                  :key="i"
                  :value="area.value"
                >
                  {{ area.name }}
                </option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 區域 -->

        <!-- 地址 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              地址
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。
                </span>
              </span>
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.address_short"
              maxlength="120"
            />
          </div>
          <br />
        </div>
        <!-- End 地址 -->

        <!-- 地址備註 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              地址備註
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.address_remark"
              maxlength="45"
            />
          </div>
          <br />
        </div>
        <!-- End 地址備註 -->

        <!-- 電話1 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              電話1
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.tel"
              maxlength="15"
              @keyup="verityTel"
              ref="tel"
            />
          </div>
          <br />
        </div>
        <!-- End 電話1 -->

        <!-- 電話2 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              電話2
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.tel2"
              maxlength="15"
              @keyup="verityTel2"
              ref="tel2"
            />
          </div>
          <br/>
        </div>
        <!-- End 電話2 -->

        <!-- 描述 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              描述
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.description"
              maxlength="100"
            />
          </div>
          <br />
        </div>
        <!-- End 描述 -->

        <!-- 描述(搜尋引擎顯示) -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              描述(搜尋引擎顯示)
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.search_description"
              maxlength="100"
            />
          </div>
          <br />
        </div>
        <!-- End 描述(搜尋引擎顯示) -->

        <!-- 品牌頁介紹 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              品牌頁介紹
            </span>
            <textarea
              class="w-100-p form-control"
              name="introduction"
              v-model="storeInfo.introduction"
              cols="30"
              rows="10"
              maxlength="65535"
            />
          </div>
          <br />
        </div>
        <!-- End 品牌頁介紹 -->

        <!-- Youtube影片代碼 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              Youtube影片代碼
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.youtube_video_code"
              maxlength="50"
            />
          </div>
          <br />
        </div>
        <!-- End Youtube影片代碼 -->

        <!-- 食品業者登錄字號 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              食品業者登錄字號
            </span>
            <input
              class="form-control"
              ref="foodBusinessNo"
              type="text"
              maxlength="19"
              placeholder="範例：F-123456789-00000-0"
              v-model="storeInfo.food_business_no"
            />
          </div>
          <br />
        </div>
        <!-- End 食品業者登錄字號 -->

        <!-- 肉品產地說明 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              肉品產地說明
            </span>
            <textarea
              class="form-control"
              rows="2"
              maxlength="500"
              placeholder="範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
              v-model="storeInfo.meat_origin_description"
            />
          </div>
          <br />
        </div>
        <!-- End 肉品產地說明 -->

        <!-- 圖片 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              LOGO
            </span>
            <div
              class="input-group-addon w-100-p text-center p-all-0 bg-white"
              style="border-right: none;"
            >
              <span class="inline-block h-auto m-t-5">
                <div v-if="!storeInfo.image_name" class="text-black" v-text="'沒有圖片'" />
                <img
                  :src="storeInfo.image_name"
                  class="h-auto img-responsive"
                  v-if="storeInfo.image_name"
                  data-toggle="modal"
                />
              </span>
            </div>
            <div class="form-control h-100">
              <div
                v-if="imgLogoOption.length"
                class="pull-left"
              >
                <select
                  class="form-control"
                  v-model="imgLogoSelect"
                >
                  <option
                    v-for="(img, i) in imgLogoOption"
                    :key="i"
                    :value="img.name"
                  >
                    {{ img.name }}
                  </option>
                </select>
              </div>
              <div class="pull-left">
                <label
                  class="btn-upload btn btn-default"
                  style="margin-top: 8px;"
                  for="brand-img-load"
                  :class="{'m-t-25': !imgLogoOption.length}"
                >
                  選擇圖片
                </label>
                <input
                  class="form-control"
                  type="file"
                  style="display: none;"
                  @change="onFileChange"
                  id="brand-img-load"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-right text-15 text-red">
          (圖片大小為200x200)
          <br />
        </div>
        <!-- End 圖片 -->

        <!-- 底圖照片 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              底圖照片
            </span>
            <div
              class="input-group-addon w-100-p text-center p-all-0 bg-white"
              style="border-right: none;"
            >
              <span class="inline-block h-auto m-t-5">
                <div
                  v-if="!storeInfo.photo_name"
                  class="text-black"
                  v-text="'沒有圖片'"
                />
                <img
                  :src="storeInfo.photo_name"
                  class="h-auto img-responsive"
                  v-if="storeInfo.photo_name"
                  data-toggle="modal"
                />
              </span>
            </div>
            <div class="form-control h-100">
              <label
                class="btn-upload btn btn-default"
                style="margin-top: 25px;"
                for="brand-photo-load"
              >
                選擇圖片
              </label>
              <input
                class="form-control"
                type="file"
                style="display: none;"
                @change="onPhotoFileChange"
                id="brand-photo-load"
              />
            </div>
          </div>
        </div>
        <div
          class="text-right text-15 text-red"
        >
          (圖片大小為800x460)
          <br />
        </div>
        <!-- End 底圖照片 -->
      </div>
    </div>
    <!-- End 店家資訊 -->

    <!-- 細部設定 -->
    <div
      class="box-body form"
      v-show="storeMethod === 2"
    >
      <div>
        <div v-if="getRoleType !== 10">
          <h3>細部設定</h3>
          <br />
        </div>
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              API服務類型
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="apiTypeSelect"
              >
                <option value="1">專屬客製POS</option>
                <option value="2">公版POS</option>
                <option value="3">平板接單</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              門市類型
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  若尚未設定門市類型，將會影響加盟/直營對帳的計費功能
                </span>
              </span>
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="storeTypeSelect"
              >
                <option value="0">未分類</option>
                <option value="1">直營</option>
                <option value="2">加盟</option>
              </select>
            </div>
          </div>
          <br />
        </div>

        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              營業狀態
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="statusSelect"
              >
                <option value="0">尚未營業</option>
                <option value="1">籌備中</option>
                <option value="2">營業中(上架)</option>
                <option value="3">休息中</option>
                <option value="9">已歇業</option>
              </select>
            </div>
          </div>
          <br />
        </div>

        <!-- 距離計算模式 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              距離計算模式
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="disModeSelect"
              >
                <option value="11">走路模式(WALKING)</option>
                <option value="12">開車模式(DRIVING)</option>
                <option value="13">機車(SCOOTER)</option>
                <option value="14">大眾運輸(TRANSIT)</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 距離計算模式 -->

        <!-- 條碼類型 -->
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              條碼類型
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="barcodeSelect"
              >
                <option value="0">不支援</option>
                <option value="1">一維條碼</option>
                <option value="2">二維條碼(QRcode)</option>
                <option value="3">一維、二維都支援</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 條碼類型 -->

        <!-- 金額進位 -->
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              金額進位
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="roundingTypeSelect"
              >
                <option value="1">無條件進位</option>
                <option value="2">無條件捨去</option>
                <option value="3">四捨五入</option>
                <option value="99">保留小數點</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 金額進位 -->

        <!-- 優惠券形式 -->
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              優惠券形式
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="couponFormSelect"
              >
                <option value="1">依付款方式使用優惠券</option>
                <option value="2">依虛擬商品使用優惠券</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 優惠券形式 -->

        <!-- 自訂設定顯示方式 -->
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              自訂設定顯示方式
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="showProdSettingSelect"
              >
                <option value="0">別名跟描述不顯示</option>
                <option value="1">別名跟描述都顯示</option>
                <option value="2">只顯示別名</option>
                <option value="3">只顯示描述</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- End 自訂設定顯示方式 -->

        <!-- 店家是否開立發票 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              店家是否開立發票
            </span>
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="invoiceException"
                    :value="0"
                    v-model="isInvoiceException"
                    :disabled="!hasInvoiceSelected"
                  >
                  <span :class="{ 'radio-text--disabled': !hasInvoiceSelected }">
                    開發票
                  </span>
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="invoiceException"
                    :value="1"
                    v-model="isInvoiceException"
                    :disabled="hasInvoiceSelected"
                  >
                  <span :class="{ 'radio-text--disabled': hasInvoiceSelected }">
                    免開發票
                  </span>
                </label>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 店家是否開立發票 -->

        <!-- 開放紙本發票 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              開放紙本發票
            </span>
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="invoicePaperOption" :value="1" v-model="hasInvoicePaperSelect">開放
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="invoicePaperOption" :value="0" v-model="hasInvoicePaperSelect">停用
                </label>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 開放紙本發票 -->

        <!-- 開放電子載具 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              開放電子載具
            </span>
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="invoiceOption"
                    :value="1"
                    v-model="hasInvoiceCarrierSelect"
                  />
                  開放 (請確認POS端是否支援此功能)
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="invoiceOption"
                    :value="0"
                    v-model="hasInvoiceCarrierSelect"
                  />
                  停用
                </label>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 開放電子載具 -->

        

        <div v-if="hasInvoiceCarrierSelect">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              開放愛心捐贈發票
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  門市接單APP暫不支援
                </span>
              </span>
            </span>
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="invoiceNpobnaOption" :disabled="!hasInvoiceCarrierSelect" :value="1" v-model="hasInvoiceNpobnaSelect">開放
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input type="radio" :disabled="true" name="invoiceNpobnaOption" :value="0" v-model="hasInvoiceNpobnaSelect">停用
                </label>
              </div>
            </div>
          </div>
          <br />
        </div>

        <!-- 發票備註 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              發票備註
            </span>
            <textarea
              v-model="invoiceRemark"
              class="w-100-p form-control"
              name="invoiceRemark"
              cols="30"
              rows="3"
              maxlength="100"
            />
          </div>
          <div class="text-right">{{ invoiceRemark ? invoiceRemark.length : 0 }}/100</div>
          <br />
        </div>
        <!-- End 發票備註 -->

        <!-- 前端顯示此店家 -->
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              前端顯示此店家
            </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="showOption" value="1" v-model="isVisibleSelect">顯示
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="showOption" value="0" v-model="isVisibleSelect">隱藏
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 前端顯示此店家 -->

        <!-- 首頁是否搜尋的到店家 -->
        <div v-if="getRoleType === 99">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              首頁是否搜尋的到店家
            </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="searchOption" value="1" v-model="isSearchSelect">是
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="searchOption" value="0" v-model="isSearchSelect">否
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 首頁是否搜尋的到店家 -->

        <!-- 是否支援客製餐點貼紙 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>支援客製餐點貼紙
            </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="stickerOption" :value="1" v-model="isStickerSelect">支援 (請確認POS端是否支援此功能)
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="stickerOption" :value="0" v-model="isStickerSelect">不支援
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 是否支援客製餐點貼紙 -->

        <!-- 貼紙限制字數 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>貼紙限制字數
            </span>
            <input
              class="form-control"
              placeholder="僅可輸入數字"
              type="number"
              v-model.number.lazy.trim="storeInfo.custom_sticker_max_length"
              min="1"
              max="10"
            />
          </div>
          <br />
        </div>
        <!-- End 貼紙限制字數 -->

        <!-- 強制阻擋外送門檻 -->
        <div>
          <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            <span>強制阻擋外送門檻</span>
            <span class="nd-tooltip">
              <ion-icon name="help-circle" />
              <span class="nd-tooltip-text">
                若選擇強制阻擋外送門檻，消費者訂購時必須符合「取餐方式/門檻-消費金額與距離門檻」的設定才可下單。注意 : 無論是否強制阻擋外送門檻，外送訂單均須符合最低金額門檻才可下單。
              </span>
            </span>
          </span>
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="deliveryStageLimit" :value="1" v-model="storeInfo.delivery_stage_limit_type">不強制
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="deliveryStageLimit" :value="2" v-model="storeInfo.delivery_stage_limit_type">強制
                </label>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 強制阻擋外送門檻 -->

        <!-- 單品備註 -->
        <div>
          <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            單品備註
          </span>
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="customRemark" :value="1" v-model="storeInfo.is_support_custom_remark">開啟 (請確認POS端是否支援此功能)
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="customRemark" :value="0" v-model="storeInfo.is_support_custom_remark">停用
                </label>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 單品備註 -->

        <!-- 網址跳轉設定 -->
        <div v-if="getRoleType === 99">
          <div class="input-group">
          <span class="input-group-addon">
            <!-- <span class="text-red">＊</span> -->
            網址跳轉設定
          </span>
          <multiselect
            v-model="urlRedirection.new_store_info"
            :options="urlRedirection.stores"
            tag-placeholder="選擇網址跳轉門市"
            placeholder="選擇網址跳轉門市"
            label="name"
            track-by="store_id"
            :max="1"
            :multiple="true"
            :allow-empty="true"
          />
          </div>
          <br />
        </div>
        <!-- End 網址跳轉設定 -->

        <!-- 開通門市會員卡 -->
        <div v-if="getRoleType === 99 && membershipGroupType === 2">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>開通門市會員卡
            </span>
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="providerId" :value="providerId" v-model="storeInfo.membership_provider_parent_id">是
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="providerId" :value="0" v-model="storeInfo.membership_provider_parent_id">否
                </label>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 開通門市會員卡 -->

        <!-- 門市下訂金額限制 -->
        <div>
          <br />
          <h3>門市下訂金額限制</h3>
          <br />
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>單筆訂單最高上限(單位:元)
              </span>
              <input
                class="form-control"
                placeholder="單筆訂單最高上限"
                type="text"
                v-model="storeInfo.one_order_max_money"
                maxlength="6"
                @keyup="verityOneOrderMaxMoney"
                ref="oneOrderMaxMoney"
              />
            </div>
            <br />
          </div>
          <br />
        </div>
        <!-- End 門市下訂金額限制 -->

        <!-- 菜單設定 -->
        <div class="mb-5">
          <h3>菜單設定</h3>
          <br v-if="getRoleType === 30" />
          <!-- 菜單呈現 -->
          <div>
            <h4 class="text-left mb-3">菜單呈現</h4>
            <!-- 菜單版型 -->
            <div v-if="getRoleType === 99" class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>菜單版型
              </span>
              <div class="form-group">
                <select
                  class="form-control"
                  v-model="storeInfo.menu_layout_type"
                >
                  <option
                    v-for="layout in menuLayout"
                    :key="layout.value"
                    :value="layout.value"
                  >
                    {{ layout.label }}
                  </option>
                </select>
              </div>
            </div>
            <!-- End 菜單版型 -->

            <!-- 飲料溫度顯示(冷 熱 無溫度) -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>飲料溫度顯示(冷 熱 無溫度)
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="iconOption" value="0" v-model="showMenuIconSelect">全部顯示
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="iconOption" value="1" v-model="showMenuIconSelect">無溫度顯示冷
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="iconOption" value="2" v-model="showMenuIconSelect">皆顯示無溫度
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 飲料溫度顯示(冷 熱 無溫度) -->

            <!-- 菜單產品圖示顯示 -->
            <div v-if="getRoleType === 99" class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>菜單產品圖示顯示
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="prodIconOption" :value="1" v-model="storeInfo.show_menu_product_icon">顯示
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="prodIconOption" :value="0" v-model="storeInfo.show_menu_product_icon">隱藏
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 菜單產品圖示顯示 -->

            <!-- 菜單選項展開類型 -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>菜單選項展開類型
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuExpandType" :value="1" v-model="storeInfo.menu_expand_type">隱藏
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuExpandType" :value="2" v-model="storeInfo.menu_expand_type">展開
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 菜單選項展開類型 -->

            <!-- 菜單當日停賣樣式 -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>菜單當日停賣樣式
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuStopSaleTodayType" :value="1" v-model="storeInfo.menu_stop_sale_today_type">顯示當日停賣ICON
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuStopSaleTodayType" :value="2" v-model="storeInfo.menu_stop_sale_today_type">隱藏當日停賣商品
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 菜單當日停賣樣式 -->

            <!-- 菜單永久停賣樣式 -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>菜單永久停賣樣式
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuStopSaleType" :value="1" v-model="storeInfo.menu_stop_sale_type">顯示永久停賣ICON
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuStopSaleType" :value="2" v-model="storeInfo.menu_stop_sale_type">隱藏永久停賣商品
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 菜單永久停賣樣式 -->

            <!-- 菜單0元價格顯示 -->
            <div v-if="getRoleType === 99" class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                <span>菜單0元價格顯示</span>
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="show_menu_zero_money" :value="1" v-model="storeInfo.show_menu_zero_money">
                      開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="show_menu_zero_money" :value="0" v-model="storeInfo.show_menu_zero_money">
                      關閉
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 菜單0元價格顯示 -->

            <!-- 菜單編輯權限 -->
            <div v-if="getRoleType === 99" class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                <span>菜單編輯權限</span>
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="allow_update_menu" :value="1" v-model="storeInfo.allow_update_menu">
                      開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="allow_update_menu" :value="0" v-model="storeInfo.allow_update_menu">
                      關閉
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 菜單編輯權限 -->

            <!-- 菜單同步權限 -->
            <div v-if="getRoleType === 99" class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                <span>菜單同步權限</span>
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="allow_copy_menu" :value="1" v-model="storeInfo.allow_copy_menu">
                      開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="allow_copy_menu" :value="0" v-model="storeInfo.allow_copy_menu">
                      關閉
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 菜單同步權限 -->
          </div>
          <div class="mb-4">
            <!-- 紅配綠菜單分類顯示 -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                <span>銷售折扣組合(紅配綠)菜單分類顯示</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle" />
                  <span class="nd-tooltip-text">
                    若開啟，菜單分類會再新增「紅區」、「綠區」，提升活動能見度！
                  </span>
                </span>
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menu_ab_block_type" :value="1" v-model="storeInfo.menu_ab_block_type">
                      開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menu_ab_block_type" :value="0" v-model="storeInfo.menu_ab_block_type">
                      關閉
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- End 紅配綠菜單分類顯示 -->
          </div>
          <!-- End 菜單呈現 -->

          <!-- 菜單管理 -->
          <div v-if="getRoleType === 99 && $route.name === 'crStore'">
            <h4 class="text-left mb-3">菜單管理</h4>
            <!-- 自訂或複製店家的菜單 -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                自訂或複製店家的菜單
              </span>
              <div class="flex align-center">
                <div class="ml-md flex-shrink-0">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="copyInfo.menuStore"
                      />
                      自訂
                    </label>
                  </div>
                </div>
                <div class="ml-md flex-shrink-0">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        :value="true"
                        v-model="copyInfo.menuStore"
                      />
                      複製
                    </label>
                  </div>
                </div>
                <multiselect
                  :class="[
                    'flex-grow-1 ml-md',
                    { 'visibility-hidden': !copyInfo.menuStore }
                  ]"
                  v-model="copyInfo.menuStoreId"
                  placeholder="選擇店家"
                  label="label"
                  track-by="value"
                  :allow-empty="false"
                  :options="storeBrief"
                />
              </div>
            </div>
            <!-- End 自訂或複製店家的菜單 -->

            <!-- 自訂或複製店家的別名/描述/警語 -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                自訂或複製店家的別名/描述/警語
              </span>
              <div class="flex align-center">
                <div class="ml-md flex-shrink-0">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="copyInfo.productAlias"
                      />
                      自訂
                    </label>
                  </div>
                </div>
                <div class="ml-md flex-shrink-0">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        :value="true"
                        v-model="copyInfo.productAlias"
                      />
                      複製
                    </label>
                  </div>
                </div>
                <multiselect
                  :class="[
                    'flex-grow-1 ml-md',
                    { 'visibility-hidden': !copyInfo.productAlias }
                  ]"
                  v-model="copyInfo.productAliasStoreId"
                  placeholder="選擇店家"
                  label="label"
                  track-by="value"
                  :allow-empty="false"
                  :options="storeBrief"
                />
              </div>
            </div>
            <!-- End 自訂或複製店家的別名/描述/警語 -->

            <!-- 自訂或複製店家的圖片庫 -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                自訂或複製店家的圖片庫
              </span>
              <div class="flex align-center">
                <div class="ml-md flex-shrink-0">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="copyInfo.productImage"
                      />
                      自訂
                    </label>
                  </div>
                </div>
                <div class="ml-md flex-shrink-0">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        :value="true"
                        v-model="copyInfo.productImage"
                      />
                      複製
                    </label>
                  </div>
                </div>
                <multiselect
                  :class="[
                    'flex-grow-1 ml-md',
                    { 'visibility-hidden': !copyInfo.productImage }
                  ]"
                  v-model="copyInfo.productImageStoreId"
                  placeholder="選擇店家"
                  label="label"
                  track-by="value"
                  :allow-empty="false"
                  :options="storeBrief"
                />
              </div>
            </div>
            <!-- End 自訂或複製店家的圖片庫 -->

            <!-- 加入至門市群組 -->
            <div class="input-group mb-3">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                加入至門市群組
              </span>
              <div class="flex align-center">
                <div class="ml-md flex-shrink-0">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        :value="true"
                        v-model="storeInfo.binding_class"
                      />
                      是
                    </label>
                  </div>
                </div>
                <div class="ml-md flex-shrink-0">
                  <div class="radio">
                    <label>
                      <input
                        type="radio"
                        :value="false"
                        v-model="storeInfo.binding_class"
                      />
                      否
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="storeInfo.binding_class"
              class="text-left mb-3"
            >
              <span class="text-red">＊</span>
              請選擇要加入的門市群組，若後續需異動請至菜單建置-門市群組。
            </div>
            <div
              v-if="storeInfo.binding_class"
              class="input-group"
            >
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                選擇要加入的群組名稱
              </span>
              <multiselect
                v-model="storeInfo.binding_class_ids"
                tag-placeholder="選擇要加入的群組名稱"
                placeholder="選擇要加入的群組名稱"
                label="label"
                track-by="value"
                :options="bindingClassList"
                :multiple="true"
              />
            </div>
            <!-- End 加入至門市群組 -->
          </div>
          <!-- End 菜單管理 -->
        </div>
        <!-- End 菜單設定 -->
      </div>

      <div v-if="getRoleType === 99">
        <h3>POS帳號</h3>
        <br />
      </div>

      <br />

      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            綁定POS帳號
          </span>
          <div class="form-group text-left">
            <div class="radio inline-block">
              <label>
                <input
                  type="radio"
                  name="sexOption"
                  :value="1"
                  v-model="isPosAccount"
                />
                是
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input
                  type="radio"
                  name="sexOption"
                  :value="0"
                  v-model="isPosAccount"
                />
                否
              </label>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div v-if="parseInt(isPosAccount, 10) === 1 && getRoleType === 99">
        <div class="text-left">
          <button class="btn btn-success" @click="newPosAccount">綁定POS帳號</button>
          <div class=" table-responsive p-x-0">
            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
              <thead>
                <tr>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">POS帳號</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">密碼</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">POS廠商</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">角色類型</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">備註</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟用</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">動作</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in posList" class="even">
                <tr>
                  <td class="sorting_1">{{index + 1}}</td>
                  <td>
                    <div
                      :class="[
                        'input-group has-feedback',
                        item.account && !repeatPosAccount(item.account) && item.vaildSingleAccount ? 'has-success' : 'has-error'
                      ]">
                      <input v-model="item.account" type="text" class="form-control" @focusout="checkPosSingleAccount(item, index)" />
                      <span :class="['form-control-feedback', item.account && !repeatPosAccount(item.account) && item.vaildSingleAccount?'fa fa-check' : 'fa fa-times']"></span>
                    </div>
                  </td>
                  <td>
                    <div :class="[' input-group has-feedback', item.password ? 'has-success' : 'has-error']">
                      <input v-model="item.password" type="text" class="form-control" />
                      <span :class="['form-control-feedback', item.password?'fa fa-check' : 'fa fa-times']"></span>
                    </div>
                  </td>
                  <td>
                    <select
                      v-model="item.pos_vendor_id"
                      class="form-control"
                      :disabled="item.pos_account_id"
                    >
                      <option
                        v-for="(pos, k) in posBrief"
                        :key="k"
                        :value="pos.value"
                      >
                        {{ pos.label }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select
                      v-model="item.role_type"
                      class="form-control"
                      :disabled="item.pos_account_id"
                    >
                      <option value="10">公版</option>
                      <option value="1">特定POS</option>
                    </select>
                  </td>
                  <td><input v-model="item.remark" class="form-control" type="text" /></td>
                  <td>
                    <div class="form-group text-left">
                      <div class="radio inline-block">
                        <label>
                          <input
                            v-model="item.is_active"
                            type="radio"
                            :name="'active'+index"
                            :value="0"
                          />
                          關閉
                        </label>
                      </div>
                      <div class="radio inline-block">
                        <label>
                          <input
                            v-model="item.is_active"
                            type="radio"
                            :name="'active'+index"
                            :value="1"
                          />
                          啟用
                        </label>
                      </div>
                    </div>
                  </td>
                  <td>
                    <button v-if="!item.pos_account_id" class="btn btn-danger" @click="deletePosAccount(index)"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div  v-if="storeBrief.length && $route.name !== 'upStore'">
        <h3>廣告設定</h3>
        <br />
      </div>
      <div  v-if="storeBrief.length && $route.name !== 'upStore'">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            自訂或複製店家的廣告
          </span>
          <div class="form-group text-left">
            <div class="radio inline-block">
              <label>
                <input
                  type="radio"
                  name="copyOption"
                  value="1"
                  v-model="isCopy"
                />
                複製
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input
                  type="radio"
                  name="copyOption"
                  value="0"
                  v-model="isCopy"
                />
                自訂
              </label>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div v-if="isCopy == 1 && storeBrief.length && $route.name !== 'upStore'">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            複製廣告類型
          </span>
          <div class="form-group text-left">
            <div class="radio inline-block">
              <label>
                <input
                  type="radio"
                  name="copyBannerTypeList"
                  :value="[12]"
                  v-model="copyBannerTypeList"
                />
                橫幅廣告
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input
                  type="radio"
                  name="copyBannerTypeList"
                  :value="[41]"
                  v-model="copyBannerTypeList"
                />
                蓋板廣告
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input
                  type="radio"
                  name="copyBannerTypeList"
                  :value="[12,41]"
                  v-model="copyBannerTypeList"
                />
                兩者
              </label>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div v-if="isCopy === 1 || isCopy === '1'">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            選擇店家
          </span>
          <div class="form-group">
            <select
              class="form-control"
              v-model="copyStoreSelect"
            >
              <option
                v-for="(store, i) in storeBrief"
                :key="i"
                :value="store.value"
              >
                {{store.label}}
              </option>
            </select>
          </div>
        </div>
        <br />
      </div>
    </div>
    <!-- End 細部設定 -->

    <!-- 預定/訂購時間 -->
    <div
      class="box-body form"
      v-show="storeMethod === 3"
    >
      <div>
        <h3>預訂設定</h3>
      </div>
      <br />
      <div v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            開始預訂(距今日幾天，0為當日)
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="storeInfo.order_start_day"
          />
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            結束預訂(距開始預訂幾天，0為開始預訂日)
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="storeInfo.order_tolerance_day"
          />
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            自動拒絕預約單時間(單位:分鐘)
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="storeInfo.auto_reject_order_reserve_m"
          />
        </div>
        <br />
      </div>
      <br />
      <div>
        <h3>接單/送單設定</h3>
      </div>
      <br />
      <div v-if="(getDenyList.indexOf(331) < 0)">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊</span>
          接單狀態
        </span>
          <div class="form-group">
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="orderOption"
                    value="10"
                    v-model="orderStatusSelect"
                  />
                  接單中
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="orderOption"
                    value="20"
                    v-model="orderStatusSelect"
                  />
                  不接單
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div v-if="(getDenyList.indexOf(331) < 0)">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            暫停接單理由
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="storeInfo.order_status_reason"
            maxlength="10"
          />
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            自動拒單時間(單位:分鐘)
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="storeInfo.auto_reject_order_m"
            maxlength="4"
            @keyup="verityRejectTime"
            ref="rejectTime"
          />
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊</span>
          當日訂購時間前下單
        </span>
          <div class="form-group">
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="isPreparingAllow"
                    :value="1"
                    v-model="storeInfo.is_preparing_allow_order"
                  />
                  可下單
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="isPreparingAllow"
                    :value="0"
                    v-model="storeInfo.is_preparing_allow_order"
                  />
                  不可下單
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            結束訂購時間後下單
          </span>
          <div class="form-group">
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="isCloseAllow"
                    :value="1"
                    v-model="storeInfo.is_close_allow_order"
                  />
                  可下單
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="isCloseAllow"
                    :value="0"
                    v-model="storeInfo.is_close_allow_order"
                  />
                  不可下單
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            距營業時間多久方可訂購(單位:分鐘)
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="storeInfo.order_start_time_m"
            maxlength="4"
            @keyup="verityStartTime"
            ref="startTime"
          />
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            距打烊時間多久為最後訂購(單位:分鐘)
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="storeInfo.order_end_time_m"
            maxlength="4"
            @keyup="verityEndTime"
            ref="endTime"
          />
        </div>
        <br />
      </div>
    </div>
    <!-- End 預定/訂購時間 -->

    <!-- 付款方式 -->
    <div
      class="box-body form"
      v-show="storeMethod === 4"
    >
      <div>
        <h3>付款方式</h3>
      </div>
      <br />
      <div class="table-responsive" style="overflow-x: auto;">
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td style="min-width: 200px;">付款類型</td>
              <td v-if="getRoleType === 99" style="min-width: 100px;">支援與否</td>
              <td style="min-width: 100px;">
                開啟狀態
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    若無法調整開啟狀態表示門市尚未開通此支付別，如需啟用請洽你訂團隊。
                  </span>
                </span>
              </td>
              <template v-if="getRoleType === 99">
                <td style="min-width: 200px;">線上key (自取、外送)</td>
                <td style="min-width: 200px;">線下key (內用、內用-桌邊掃碼)</td>
                <td style="min-width: 150px;"></td>
                <td style="min-width: 150px;"></td>
              </template>
              <td style="min-width: 180px;">
                備註 (顯示在購物車頁面上，消費者可查看)
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    前台顯示畫面，如下方粉色備註區塊
                    <img src='/static/img/trade_remark_ex.png'>
                  </span>
                </span>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(tradeType, index) in tradeInfo"
              :key="index"
            >
            
              <td>
                <span class="text-red">＊</span>
                {{ tradeType.name }}
              </td>
              <!-- 支援與否 -->
              <td v-if="getRoleType === 99">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input
                        v-model="tradeType.is_support"
                        :disabled="getRoleType === 10"
                        type="radio"
                        value="1"
                      />
                      支援
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input
                        v-model="tradeType.is_support"
                        :disabled="getRoleType === 10"
                        type="radio"
                        value="0"
                        @change="clickClose('tradeType', tradeType.is_default, index)"
                      />
                      不支援
                    </label>
                  </div>
                </div>
              </td>
              <!-- End 支援與否 -->
              <td>
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input
                        type="radio"
                        value="1"
                        v-model="tradeType.is_enable"
                        @input="reload = true"
                        :disabled="tradeType.is_support == 0"
                      />
                      <span :class="{ 'radio-text--disabled': tradeType.is_support == 0 }">
                        開啟
                      </span>
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input
                        type="radio"
                        value="0"
                        v-model="tradeType.is_enable"
                        :disabled="tradeType.is_support == 0"
                        @change="clickClose('tradeType', tradeType.is_default, index)"
                      />
                      <span :class="{ 'radio-text--disabled': tradeType.is_support == 0 }">
                        關閉
                      </span>
                    </label>
                  </div>
                </div>
              </td>

              <!-- admin 控管 -->
              <template v-if="getRoleType === 99">
                <td v-for="(groupType, i) in ['online','offline']" :key="i">
                  <template v-if="tradeType.meta">
                    <div
                      class="text-danger"
                      v-if="tradeType.meta[groupType=='online'?'delete_key':'delete_offline_key']"
                    >
                      <small class="text-w-600">＊移除先前設定</small>
                    </div>
                    <div v-if="tradeType.meta[groupType=='online'?'use_key':'use_offline_key'] == 1 && !tradeType.meta[groupType=='online'?'delete_key':'delete_offline_key']">
                      已設定
                      <br>
                      <button
                        class="btn btn-default"
                        @click="tradeType.meta[groupType=='online'?'use_key':'use_offline_key'] = 2"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        class="btn btn-danger"
                        @click="
                        reload = true;
                        tradeType.meta[groupType=='online'?'delete_key':'delete_offline_key'] = 1;
                        tradeType.meta[groupType=='online'?'use_key':'use_offline_key'] = 2"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                    <div v-else>
                      <div
                        v-for="(value, key) in tradeType.meta.group[groupType]"
                        :key="key"
                      >
                        <span class="text-w-600">{{ key }}：</span>
                        <input
                          class="form-control"
                          placeholder=""
                          type="text"
                          :disabled="groupType == 'offline' && !tradeType.check_offline"
                          v-model="tradeType.meta.group[groupType][key]"
                          @input="reload = true; tradeType.meta[groupType=='online'?'use_key':'use_offline_key'] = 2"
                        />
                      </div>
                    </div>
                  </template>
                </td>

                <td>
                  <div v-if="tradeType.custom_config">
                    <div
                      v-for="(tradeValue, key) in tradeType.custom_config.key"
                      :key="key"
                    >
                      <span class="text-w-600">{{key}}：</span>
                      <input
                        class="form-control"
                        placeholder=""
                        type="text"
                        v-model="tradeType.custom_config.key[key]"
                        @input="reload = true"
                      />
                    </div>
                  </div>
                </td>

                <!-- 金流帳戶統一編號 -->
                <td>
                  <div v-if="tradeType.meta || tradeType.custom_config">
                    <span class="text-w-600">金流帳戶統一編號</span>
                    <input
                      class="form-control"
                      placeholder=""
                      type="text"
                      maxlength="8"
                      v-model="tradeType.ein"
                      @input="verityTradeEin(index)"
                    />
                  </div>
                </td>
                <!-- End 金流帳戶統一編號 -->
              </template>
              <!-- End admin 控管 -->

              <td>
                <textarea
                  v-model="tradeType.remark"
                  class="w-100-p form-control"
                  rows="2"
                  :maxlength="remarkMaxlength"
                />
                <div class="text-right">
                  {{ tradeType.remark ? tradeType.remark.length : 0 }}/{{remarkMaxlength}}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div>
        <h3>現金付款設定</h3>
      </div>
      <div>
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>取餐方式</td>
              <td>付款順序</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>內用-桌邊掃碼</td>
              <td>
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input
                        v-model="tableNumber.is_cash_pay_after_meal"
                        type="radio"
                        :value="0"
                      />
                      餐前付款
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input
                        v-model="tableNumber.is_cash_pay_after_meal"
                        type="radio"
                        :value="1"
                      />
                      餐後付款
                    </label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div v-if="info">
        <h3>付款方式與取餐金額</h3>
      </div>
      <div v-if="info" class="text-left">
        <button
          class="btn btn-success"
          @click="addExceptionTrade"
        >
          新增限制
        </button>
      </div>
      <br />
      <div v-if="exceptionTradeList.length">
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>取餐方式</td>
              <td>付款方式</td>
              <td>起始金額</td>
              <td>結束金額</td>
              <td>描述</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(exceptionTrade, eIndex) in exceptionTradeList"
              :key="eIndex"
            >
              <td>
                <select
                  v-model="exceptionTrade.delivery_type"
                  class="form-control"
                >
                  <option :value="0">全部</option>
                  <option
                    v-for="(delivery, i) in deliveryInfo"
                    :key="i"
                    :value="delivery.value"
                  >
                    {{ delivery.label }}
                  </option>
                  <option v-if="exceptionTrade.delivery" :value="exceptionTrade.delivery_type">{{ exceptionTrade.delivery }}</option>
                </select>
              </td>
              <td>
                <select
                  v-model="exceptionTrade.trade_type"
                  class="form-control"
                >
                  <option
                    v-for="(trade, i) in tradeList"
                    :key="i"
                    :value="trade.value"
                  >
                    {{ trade.label }}
                  </option>
                  <option v-if="exceptionTrade.trade" :value="exceptionTrade.trade_type">{{ exceptionTrade.trade }}</option>
                </select>
              </td>
              <td>
                <input
                  placeholder=""
                  type="text"
                  class="form-control w-90 inline-block"
                  v-model="exceptionTrade.start_money"
                />
              </td>
              <td>
                <input
                  v-model="exceptionTrade.end_money"
                  placeholder=""
                  type="text"
                  class="form-control w-90 inline-block"
                >
              </td>
              <td>
                {{exceptionTrade.delivery_type | deliveryName}}
                <span v-if="exceptionTrade.start_money">
                  {{exceptionTrade.start_money}} 元以上
                </span>
                <span v-if="exceptionTrade.start_money && exceptionTrade.end_money">
                  ～
                </span>
                <span v-if="exceptionTrade.end_money">
                  {{exceptionTrade.end_money}} 元以下
                </span>
                不可用{{ exceptionTrade.trade_type | tradeName }}付款
              </td>
              <td>
                <button class="btn btn-danger" @click="removeListItem(exceptionTradeList, eIndex)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- End 付款方式 -->

    <!-- 製作/取餐時間 -->
    <div class="box-body form" v-show="storeMethod === 5">
      <div>
        <h3>製作/取餐時間</h3>
        <div>
          準備時間需設定 3 分鐘以上，取餐時間間隔需設定 10 的倍數
        </div>
      </div>
      <br />
      <div class="table-responsive">
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>取餐類型</td>
              <td>準備時間</td>
              <td>取餐時間間隔</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(takeTime, i) in takeTimeInfo"
              :key="i"
              v-show="!hideDeliveryType.includes(takeTime.take_type)"
            >
              <td>
                <span class="text-red">＊</span>
                {{ takeTime.take_type | deliveryName }}
              </td>
              <td>
                <input
                  class="form-control w-90 inline-block"
                  placeholder=""
                  type="text"
                  v-model="takeTime.prepare_time_seg"
                  @keypress="returnNum"
                />
                分鐘
              </td>
              <td>
                <span v-if="takeTime.take_type < 3 && $route.name === 'upStore'">
                  不需設定
                </span>
                <span v-else-if="takeTime.take_type === 21">
                  不需設定
                </span>
                <div v-else class="flex align-center">
                  <div class="input-group-btn flex w-auto">
                    <button
                      class="btn btn-default w-36px"
                      :disabled="!takeTime.take_time_seg"
                      @click="setTakeTime('minus', takeTime)"
                    >
                      -
                    </button>
                    <input
                      class="form-control w-90 inline-block"
                      placeholder=""
                      type="text"
                      v-model="takeTime.take_time_seg"
                      @keypress="returnNum"
                    />
                    <button
                      class="btn btn-default w-36px"
                      @click="setTakeTime('add', takeTime)"
                    >
                      +
                    </button>
                  </div>
                  <div class="m-l-5">分鐘</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-left">
        <button
          class="btn btn-success"
          @click="addProcessTime"
        >
          新增某時段的製作時間
        </button>
      </div>
      <div
        v-for="(process, pIndex) in processTimeList"
        :key="pIndex"
        class="m-t-10 process-time-block"
      >
        <div class="text-right m-b-10">
          <button
            class="btn btn-danger"
            @click="removeListItem(processTimeList, pIndex)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              月份
            </span>
            <div>
              <multiselect
                v-model="process.month"
                placeholder="新增月份"
                label="label"
                track-by="value"
                :options="offdaySetting.options.month"
                :multiple="false"
                :allow-empty="true"
              />
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              時間類型
            </span>
            <div class="form-group">
              <select
                class="form-control"
                v-model="process.value_type"
                @change="clearProcess(process)"
              >
                <option :value="1">日期</option>
                <option :value="2">星期</option>
              </select>
            </div>
          </div>
          <br>
        </div>
        <div v-if="process.value_type === 2">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              開始
            </span>
            <div>
              <multiselect
                v-model="process.start_value"
                placeholder="新增星期"
                label="label"
                track-by="value"
                :options="offdaySetting.options.weekDay"
                :multiple="false"
                :allow-empty="true"
              />
            </div>
          </div>
          <br />
        </div>
        <div v-if="process.value_type === 1">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              開始
            </span>
            <div>
              <multiselect
                tag-placeholder="數字為1~31"
                v-model="process.start_value"
                placeholder="新增日期 (格式為數字1~31)"
                label="label"
                track-by="value"
                :options="offdaySetting.options.monthDay"
                :multiple="false"
                :taggable="true"
                @tag="addStartMonthDayTag"
                :id="'process-start-' + pIndex"
              />
            </div>
          </div>
          <br />
        </div>
        <div v-if="process.value_type === 2">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              結束
            </span>
            <div>
              <multiselect
                v-model="process.end_value"
                placeholder="新增星期"
                label="label"
                track-by="value"
                :options="offdaySetting.options.weekDay"
                :multiple="false"
                :allow-empty="true"
              />
            </div>
          </div>
          <br />
        </div>
        <div v-if="process.value_type === 1">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              結束
            </span>
            <div>
              <multiselect
                tag-placeholder="數字為1~31"
                v-model="process.end_value"
                placeholder="新增日期 (格式為數字1~31)"
                label="label"
                track-by="value"
                :options="offdaySetting.options.monthDay"
                :multiple="false"
                :taggable="true"
                @tag="addEndMonthDayTag"
              />
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              取餐類型
            </span>
            <div>
              <multiselect
                v-model="process.delivery_type"
                placeholder="選擇取餐類型"
                label="label"
                track-by="value"
                :options="deliveryTypeOption"
                :multiple="false"
                :allow-empty="true"
              />
            </div>
          </div>
          <br />
        </div>
        <div class="text-left">
          <button
            class="btn btn-primary"
            @click="addItemTime(process)"
          >
            加入時間
          </button>
        </div>
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>開始時間</td>
              <td>結束時間</td>
              <td>準備時間</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, iIndex) in process.item_list"
              :key="iIndex"
            >
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="" type="text" v-model="item.process_time" @keypress="returnNum">&nbsp;&nbsp;分鐘
              </td>
              <td>
                <button class="btn btn-danger" v-if="iIndex > 0" @click="removeListItem(process.item_list, iIndex)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- End 製作/取餐時間 -->

    <!-- 取餐方式/門檻 -->
    <div class="box-body form" v-show="storeMethod === 6">
      <div>
        <h3>取餐方式/門檻</h3>
      </div>
      <br />
      <p class="text-left"><span class="text-red">＊</span> 各列設定為群組功能，需將取餐類型的每個規則一併設定後才可進行修改。</p>

      <div v-if="getRoleType === 10" class="text-left m-b-15">
        <span class="text-red">*</span>
        <span>若要啟用特定取餐方式請按右上角聯絡客服</span>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>取餐類型</td>
              <td v-if="getRoleType === 99">支援與否</td>
              <td>開啟狀態</td>
              <td>
                預設
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text center">
                    購物車預設的取餐方式。開啟狀態為 "開啟" 的取餐方式才能設為預設。
                  </span>
                </span>
              </td>
              <td>
                <span>消費金額與距離門檻</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text text-align-left">
                    ．計算商品金額 (折扣後) ，不含塑膠袋。<br/>
                    ．0元為最低消費金額
                  </span>
                </span>
              </td>
              <td>
                <span>備註</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    顯示在購物車頁面上，消費者可查看，前台顯示畫面，如下方粉色備註區塊
                    <img alt="備註描述圖片" src='/static/img/delivery_memo_ex.png' />
                  </span>
                </span>
              </td>
              <td>
                <span>取餐提醒</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    顯示在訂單確認頁面上，消費者可查看，如預覽圖所示。
                    <img alt="取餐提醒圖片" src='/static/img/delivery_pickup_memo.png' />
                  </span>
                </span>
              </td>
            </tr>
          </thead>
          <tbody>
          <tr
            v-for="(deliveryWays, i) in deliveryWaysInfo"
            :key="i"
            v-show="!hideDeliveryType.includes(deliveryWays.take_type)"
          >
            <!-- 取餐類型 -->
            <td>
              <span class="text-red">＊</span>
              {{ deliveryWays.take_type | deliveryName }}
            </td>
            <!-- End 取餐類型 -->

            <!-- 支援與否 -->
            <td v-if="getRoleType === 99">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input
                      :disabled="getRoleType === 10"
                      type="radio"
                      value="1"
                      v-model="deliveryWays.is_support"
                    />
                    支援
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input
                      :disabled="getRoleType === 10"
                      type="radio"
                      value="0"
                      v-model="deliveryWays.is_support"
                      @change="clickClose('deliveryWays', true, deliveryWays.is_default, i)"
                    />
                    不支援
                  </label>
                </div>
              </div>
            </td>
            <!-- End 支援與否 -->

            <!-- 開啟狀態 -->
            <td>
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input
                      type="radio"
                      :disabled="deliveryWays.is_support === 0"
                      value="1"
                      v-model="deliveryWays.is_enable"
                    />
                    <span :class="{ 'radio-text--disabled': deliveryWays.is_support == 0 }">
                      開啟
                    </span>
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input
                      type="radio"
                      value="0"
                      v-model="deliveryWays.is_enable"
                      :disabled="deliveryWays.is_support === 0"
                      @change="clickClose('deliveryWays', false, deliveryWays.is_default, i)"
                    />
                    <span :class="{ 'radio-text--disabled': deliveryWays.is_support == 0 }">
                      關閉
                    </span>
                  </label>
                </div>
              </div>
            </td>
            <!-- End 開啟狀態 -->

            <!-- 預設 -->
            <td>
              <label v-if="deliveryWays.take_type !== 21">
                <input
                  type="radio"
                  value="1"
                  :disabled="parseInt(deliveryWays.is_support, 10) === 0 || parseInt(deliveryWays.is_enable, 10) === 0"
                  v-model="deliveryWays.is_default"
                  @change="checkDefault(deliveryWays.take_type)"
                />
              </label>
            </td>
            <!-- End 預設 -->

            <!-- 消費金額與距離門檻 -->
            <td v-if="deliveryWays.take_type !== 3">
              滿
              <input
                class="form-control w-90 inline-block"
                placeholder=""
                type="text"
                :disabled="getRoleType === 10 && deliveryWays.is_support === 0"
                v-model="deliveryWays.price"
                @keypress="returnNum"
              />
              元即可{{ deliveryWays.take_type | deliveryName }}
            </td>

            <td v-if="deliveryWays.take_type === 3">
              <delivery-limit
                  :store-info="storeInfo"
                  :delivery-ways="deliveryWays"
                  :delivery-ways-info="deliveryWaysInfo"
                  :delivery-other="deliveryOther"
                  @update:deliveryWaysInfo="deliveryWaysInfo = $event"
                  @update:deliveryOther="deliveryOther = $event"
                  @update:storeInfo="storeInfo = $event"
                  @update:deliveryWays="deliveryWays = $event"
                ></delivery-limit>
            </td>
            <!-- End 消費金額與距離門檻 -->

            <!-- 備註 -->
            <td>
              <textarea v-model="deliveryWays.memo" :disabled="getRoleType === 10 && deliveryWays.is_support === 0" class="w-100-p form-control" rows="2" :maxlength="remarkMaxlength"></textarea>
              <div class="text-right">{{ deliveryWays.memo.length || 0 }}/{{remarkMaxlength}}</div>
            </td>
            <!-- End 備註 -->
            
            <!-- 取餐提醒 -->
            <td>
              <textarea v-model="deliveryWays.pickup_memo" :disabled="getRoleType === 10 && deliveryWays.is_support === 0" class="w-100-p form-control" rows="2" :maxlength="remarkMaxlength"></textarea>
              <div class="text-right">{{ deliveryWays.pickup_memo.length || 0 }}/{{remarkMaxlength}}</div>
            </td>
            <!-- End 取餐提醒 -->
          </tr>
          </tbody>
        </table>
      </div>
      <br />
      
      <!-- 外送門檻排除指定商品 -->
      <div>
        <h3>外送門檻排除指定商品</h3>
      </div>
      <br />
      <p class="text-left">
        <div class="text-left"><span class="text-red">＊</span>新增排除商品/套餐後，該商品金額將不納入外送門檻金額計算</div>
        <div class="text-left"><span class="text-red">＊</span>商品、套餐當中存在相同商品，設定互不影響 (例如：若僅排除商品「珍珠奶茶」，未排除套餐「珍珠奶茶+雞排」，套餐仍會被計算於外送門檻費用中。)</div>
        <div class="text-left"><span class="text-red">＊</span>若您設定了多個相同商品名稱但商品料號不同的商品，前台將會合併顯示為一筆項目，以簡化消費者的瀏覽體驗</div>
        <div class="text-left"><span class="text-red">＊</span>所有排除項目皆需儲存後，才能使用複製功能</div>
      </p>
      <br />
      <div class="flex">
        <div class="text-left m-b-15">
          <button class="btn btn-success" @click="addProductItem('search')">
            搜尋商品
          </button>
          <button class="btn btn-default" @click="addProductItem('insert')">
            新增商品
          </button>
          <span class="grey darken-1 m-l-5">提示：若商品已在菜單中，請優先使用「搜尋商品」</span>
        </div>
        <div class="ml-auto m-b-15">
          <div v-if="!deliveryExceptionProductSelect" key="default-mode">
            <button class="btn btn-default" :disabled="!checkDeliveryExceptionProductList" data-toggle="modal" data-target="#copyModal">
              複製所有排除項目至其他店家
            </button>
            <button class="btn btn-default" @click="deliveryExceptionProductSelect = true">
              批次選取
            </button>
          </div>
          <div v-else key="select-mode">
            <button class="btn btn-default" @click="deliveryExceptionProductSelect = false">
              取消選取
            </button>
            <button :disabled="!deliveryExceptionProductSelectItems.length" class="btn btn-danger" data-toggle="modal" data-target="#delExceptionModal">
              批次刪除
            </button>
          </div>
        </div>
      </div>
      <div>
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td v-if="deliveryExceptionProductSelect">
                <input type="checkbox" v-model="deliveryExceptionProductSelectAll" @click="selectAllProducts()" />
              </td>
              <td>#</td>
              <td>類型</td>
              <td>商品名稱</td>
              <td>商品料號</td>
              <td>狀態</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr v-if="deliveryExceptionProductList.length === 0">
              <td colspan="7" class="text-center">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo"></img>
                <span style="margin-bottom: 80px; color: #696969;">無資料</span>
              </td>
            </tr>
            <tr v-for="(item, index) in deliveryExceptionProductList" :key="index">
              <td v-if="deliveryExceptionProductSelect">
                <input type="checkbox" v-model="item.selected" />
              </td>
              <td>{{ index + 1 }}</td>
              <td>
                <select v-model="item.product_type" class="form-control inline-block" :disabled="item.item_type === 'search' || item.updated">
                  <option :value="1">商品</option>
                  <option :value="3">套餐</option>
                </select>
              </td>
              <td>
                <multiselect
                  v-if="item.item_type === 'search'" 
                  v-model="item.search_result"
                  :options="optionsList"
                  :searchable="true"
                  :allow-empty="true"
                  :close-on-select="true"
                  placeholder="請輸入商品名稱"
                  :show-labels="false"
                  :multiple="false"
                  label="name"
                  track-by="id"
                  @input="handleProductSelect(item)"
                >
                  <template slot="option" slot-scope="props">
                    <span>{{ props.option.name }}</span>
                    <span>({{ props.option.id }})</span>
                  </template>
                </multiselect>
                <input v-else type="text" class="form-control inline-block deliveryExceptionInput" v-model="item.product_name" :disabled="item.updated" placeholder="請輸入商品名稱"></input>
              </td>
              <td>
                <multiselect
                  v-if="item.item_type === 'search'" 
                  v-model="item.search_result"
                  :options="optionsList"
                  :searchable="true"
                  :allow-empty="true"
                  :close-on-select="true"
                  placeholder="請輸入商品料號"
                  :show-labels="false"
                  :multiple="false"
                  label="id"
                  track-by="id"
                  @input="handleProductSelect(item)"
                >
                  <template slot="option" slot-scope="props">
                    <span>{{ props.option.name }}</span>
                    <span>({{ props.option.id }})</span>
                  </template>
                </multiselect>
                <input v-else type="text" class="form-control inline-block deliveryExceptionInput" v-model="item.vendor_custom_id" :disabled="item.item_type === 'search' || item.updated" placeholder="請輸入商品料號"></td>
              <td>
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" :name="'status_' + index" :value="1" v-model="item.is_enabled">開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" :name="'status_' + index" :value="0" v-model="item.is_enabled">關閉
                    </label>
                  </div>
                </div>
              </td>
              <td><button class="btn btn-danger" @click="deleteProductItem(index)"><i class="fa fa-trash"></i></button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      
      <!-- 外送門檻排除指定商品 -->

      <br>
      <!-- 運費設定 -->
      <shipping-form ref="shippingInfo" v-if="shippingInfo.is_support && shippingInfo.is_enable" :show-vendor-id="apiTypeSelect == 1" :store-info="storeInfo" @update:store-info="storeInfo = $event"></shipping-form>
      <!-- End 運費設定 -->
      <br>

      <!-- 桌號設定 -->
      <div v-if="isEnableOnSite">
        <h3>桌邊掃碼</h3>

        <!-- 送餐方式 -->
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            送餐方式
          </span>
          <div class="form-group">
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input v-model="tableNumber.sub_delivery_type" type="radio" :value="1">
                  叫號取餐
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input v-model="tableNumber.sub_delivery_type" type="radio" :value="2">
                  店家送餐
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
        <!-- End 送餐方式 -->

        <!-- 桌號必填 -->
        <div v-if="tableNumber.sub_delivery_type === 2">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              桌號必填
            </span>
            <div class="form-group">
              <select v-model="tableNumber.is_table_no_required" class="form-control">
                <option :value="0">非必填</option>
                <option :value="1">必填</option>
              </select>
            </div>
          </div>
          <br>
        </div>
        <!-- End 桌號必填 -->

        <!-- 桌號編輯 -->
        <div v-if="tableNumber.sub_delivery_type === 2">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              桌號編輯
            </span>
            <div class="form-group">
              <select v-model="tableNumber.is_table_no_editable" class="form-control">
                <option :value="0">不可編輯</option>
                <option :value="1">可編輯</option>
              </select>
            </div>
          </div>
          <br>
        </div>
        <!-- End 桌號編輯 -->

        <!-- 桌號顯示 -->
        <div v-if="tableNumber.sub_delivery_type === 2">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              桌號顯示
            </span>
            <div class="form-group">
              <select v-model="tableNumber.show_table_no" class="form-control">
                <option :value="0">隱藏</option>
                <option :value="1">顯示</option>
              </select>
            </div>
          </div>
          <br>
        </div>
        <!-- End 桌號顯示 -->

        <!-- 訪客下單 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              訪客下單
            </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div v-for="(deliveryWays, i) in deliveryWaysInfo" :key="i" v-if="deliveryWays.take_type === 21">
                  <div class="radio inline-block">
                    <label>
                      <input v-model="deliveryWays.is_allow_guest_order" type="radio" :value="1">
                      開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input v-model="deliveryWays.is_allow_guest_order" type="radio" :value="0">
                      關閉
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <!-- End 訪客下單 -->

        <!-- 預設登入方式 -->
        <div v-for="(deliveryWays, i) in deliveryWaysInfo" :key="i" v-if="deliveryWays.take_type === 21 && deliveryWays.is_allow_guest_order === 1">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              預設登入方式
            </span>
            <div class="form-group">
              <select v-model="tableNumber.default_login_type" class="form-control">
                <option :value="1">會員</option>
                <option :value="2">訪客</option>
              </select>
            </div>
          </div>
          <br>
        </div>
        <!-- End 預設登入方式 -->
      </div>
      <!-- End 桌號設定 -->

      <!-- 排除設定 -->
      <div v-if="info"><h3>排除設定</h3></div>
      <div v-if="info">
        <p>某時間(日期、星期、每月幾號)無法取餐(自取、外送、內用、桌邊掃碼)</p>
      </div>
      <br />
      <div class="text-left" v-if="info">
        <!-- <p class="text-left"><span class="text-red">＊</span>此區塊為群組功能，無法單獨設定</p> -->
        <button class="btn btn-success" @click="addExCalendar">新增店家排除時段設定</button>
      </div>
      <div class="m-t-10 process-time-block" v-for="(exCalendar, caIndex) in exceptionCalendar">
        <div class="text-right m-b-10">
          <button class="btn btn-danger" @click="removeListItem(exceptionCalendar, caIndex)"><i class="fa fa-trash"></i></button></div>
        <div>
          <div class="input-group">
            <span class="input-group-addon"><span class="text-red">＊ </span>排除取餐類型</span>
            <div class="form-group">
              <select class="form-control" v-model="exCalendar.delivery_type">
                <option :value="delivery.value" v-for="delivery in deliveryInfo">{{delivery.label}}</option>
              </select>
            </div>
          </div>
          <br>
        </div>
        <div class="text-left"><button class="btn btn-primary" @click="addExDate(exCalendar)">加入指定日期</button></div>
        <table class="table table-bordered table-striped dataTable" v-if="exCalendar.date_type.length">
          <thead class="bg-primary">
          <tr>
            <td>指定日期</td>
            <td>開始時間</td>
            <td>結束時間</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, daIndex) in exCalendar.date_type">
            <td>
              <input class="form-control inline-block" placeholder="YYYY-MM-DD" type="text" v-model="item.date">&nbsp;&nbsp;
            </td>
            <td>
              <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
            </td>
            <td>
              <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
            </td>
            <td>
              <button class="btn btn-danger" @click="removeListItem(exCalendar.date_type, daIndex)"><i class="fa fa-trash"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
        <br>
        <div class="text-left"><button class="btn btn-primary" @click="addExWeekDay(exCalendar)">加入星期</button></div>
        <table class="table table-bordered table-striped dataTable" v-if="exCalendar.week_day.length">
          <thead class="bg-primary">
          <tr>
            <td>星期</td>
            <td>開始時間</td>
            <td>結束時間</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, weIndex) in exCalendar.week_day">
            <td>
              <select class="form-control" v-model="item.day">
                <option :value="weekDay.value" v-for="weekDay in offdaySetting.options.weekDay" v-if="weekDay.value">
                  {{weekDay.label}}
                </option>
              </select>
            </td>
            <td>
              <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
            </td>
            <td>
              <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
            </td>
            <td>
              <button class="btn btn-danger" @click="removeListItem(exCalendar.week_day, weIndex)"><i class="fa fa-trash"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
        <br>
        <div class="text-left"><button class="btn btn-primary" @click="addExMonthDay(exCalendar)">加入每月幾號</button></div>
        <table class="table table-bordered table-striped dataTable" v-if="exCalendar.month_day.length">
          <thead class="bg-primary">
          <tr>
            <td>每月幾號</td>
            <td>開始時間</td>
            <td>結束時間</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, moIndex) in exCalendar.month_day">
            <td>
              每月<input class="form-control w-90 inline-block" placeholder="DD" type="text" v-model="item.day">&nbsp;&nbsp;日
            </td>
            <td>
              <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
            </td>
            <td>
              <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
            </td>
            <td>
              <button class="btn btn-danger" @click="removeListItem(exCalendar.month_day, moIndex)"><i class="fa fa-trash"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!-- End 排除設定 -->

      <!-- Start 取餐方式 關閉預設提醒 -->
      <button class="btn" ref="pickupWarnModal" v-show="false" data-toggle="modal" data-target="#pickupWarnModal"></button>
      <div class="modal fade text-left" role="dialog" id="pickupWarnModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">提醒</h4>
            </div>
            <div class="modal-body">
              預設項目不可關閉，請先調整預設的取餐類型
            </div>
            <div class="modal-footer">
              <button class="btn btn-default" data-dismiss="modal">確定</button>
            </div>
          </div>
        </div>
      </div>
      <!-- End 取餐方式 關閉預設提醒 -->
    </div>
    <!-- End 取餐方式/門檻 -->

    <!-- 營業時間 -->
    <div class="box-body form" v-show="storeMethod === 7">
      <div><h3>營業時間</h3></div>
      <br />
      <div class="table-responsive" style="overflow: inherit;">
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
          <tr>
            <td>星期</td>
            <td>營業時間</td>
            <td>打烊時間</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="weekDay in openingInfo">
            <td><span class="text-red">＊ </span>{{getWeekDayName(weekDay.week_day)}}</td>
            <td>
              <input class="form-control w-90 inline-block" placeholder="hh:mm" type="text" v-model="weekDay.start" @blur="validateTimeRange(weekDay, 'start', 'end')"/>
            </td>
            <td>
              <input class="form-control w-90 inline-block" placeholder="hh:mm" type="text" v-model="weekDay.end" @blur="validateTimeRange(weekDay, 'start', 'end')"/>
            </td>
          </tr>
          </tbody>
        </table>
        <br>
        <div class="text-left">
          <button class="btn btn-success" @click="addSpecialDay">新增指定日期</button>
        </div>
        <div class="m-t-10" v-if="selectSpecialDay.length">
          <p class="text-left"><span class="text-red">＊</span> 設定完成後，指定日期將套用此營業時間顯示，期間結束後即恢復預設營業時間。</p>
          <p class="text-left"><span class="text-red">＊</span> 若與公休日期重複，會優先顯示指定日期的營業時間。</p>
          <!-- TO DO: 本頁的 <FunctionalCalendar> 元件們的使用待開維運單，可能調整成 dialog 的形式或是找其他元件使用 （BatchSetupStore.vue）-->
          <div class="table-responsive specialDayCalendarTable-responsive">
            <table class="table table-bordered table-striped dataTable" >
              <thead class="bg-primary sticky-header">
              <tr>
                <td>指定日期</td>
                <td>營業時間</td>
                <td>打烊時間</td>
                <td>備註
                  <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    顯示在前台門市營業時間後方，如下範例：<br>
                    <img src='/static/img/specialDay_remark_tooltips.png'>
                  </span>
                </span>
                </td>
                <td></td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, daIndex) in selectSpecialDay">
                <td class="date-picker-cell">
                  <div class="calendar-container">
                    <div class="calendar" v-if="item.showSpecialDayCalendar" @blur="item.showSpecialDayCalendar=false">
                      <FunctionalCalendar
                        v-model="tempSpecialDayCalendar"
                        :is-multiple-date-picker='true'
                        :limits="calendarLimits"
                        @dayClicked="specialDayCalendarSelected(daIndex, $event)"
                      />
                      <div class="calenderClose"><button class="btn btn-primary btn-xs btn-close" @click="item.showSpecialDayCalendar=false">
                        關閉
                      </button></div>
                    </div>
                    <multiselect
                      class="calendar-multiselect"
                      v-model="item.calendar_list"
                      tag-placeholder="格式為YYYY-MM-DD"
                      placeholder="新增日期 (格式為YYYY-MM-DD)"
                      label="label"
                      track-by="value"
                      :options="offdaySetting.options.date"
                      :multiple="true"
                      :optionsLimit="0"
                      :hideSelected="true"
                      @remove="removeTag('specialDay', daIndex, val)"
                      @open="openSpecialDayCalendar(daIndex)"
                    >
                    </multiselect>
                  </div>
                </td>
                <td>
                  <input class="form-control w-90 inline-block" placeholder="hh:mm" type="text" v-model="item.start_time" @blur="validateTimeRange(item)" >
                </td>
                <td>
                  <input class="form-control w-90 inline-block" placeholder="hh:mm" type="text" v-model="item.end_time" @blur="validateTimeRange(item)" >
                </td>
                <td class="remark-cell">
                  <textarea v-model="item.remark" class="w-100-p form-control" rows="1" :maxlength="specialDayRemarkMaxlength"></textarea>
                  <div class="text-right">{{ (item.remark || '').length }}/{{ specialDayRemarkMaxlength }}</div>
                </td>
                <td>
                  <button class="btn btn-danger" @click="removeListItem(selectSpecialDay, daIndex)"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <br />
      <div><h3>公休時間</h3></div>
      <br />
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>公休時間下單
        </span>
          <div class="form-group">
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="isOffAllow" :value="1" v-model="storeInfo.is_off_allow_order">可下單
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="isOffAllow" :value="0" v-model="storeInfo.is_off_allow_order">不可下單
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            指定日期
          </span>
          <div class="calendar-container">
            <div class="calendar" v-if="showCalendar" @blur="showCalendar=false">
              <FunctionalCalendar
                v-model="selectDate"
                :is-multiple-date-picker='true'
                :limits="calendarLimits"
                @dayClicked="calendarSelected"
              />
              <div class="calenderClose"><button class="btn btn-primary btn-xs btn-close" v-if="info" @click="showCalendar=false">
                關閉
              </button></div>
            </div>
            <multiselect
              class="calendar-multiselect"
              v-model="offdaySetting.date"
              tag-placeholder="格式為YYYY-MM-DD"
              placeholder="新增日期 (格式為YYYY-MM-DD)"
              label="label" 
              track-by="value" 
              :options="offdaySetting.options.date"
              :multiple="true"
              :optionsLimit="0"
              :hideSelected="true"
              @remove="removeTag('date', 0, $event)"
              @open="openDateCalendar"
            >
            </multiselect>
          </div>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            每週幾
          </span>
          <div>
            <multiselect 
              v-model="offdaySetting.weekDay"
              placeholder="新增日期"
              label="label"
              track-by="value"
              :options="offdayWeekDayOptions"
              :multiple="true"
              :allow-empty="true"
            ></multiselect>
          </div>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            每月幾號
          </span>
          <div>
            <multiselect
              v-model="offdaySetting.monthDay"
              tag-placeholder="數字為1~31"
              placeholder="新增日期 (格式為數字1~31)"
              label="label"
              track-by="value"
              :options="offdayMonthDayOptions"
              :multiple="true"
              :taggable="true"
              @tag="addMonthDayTag"
            />
          </div>
        </div>
        <br />
      </div>
      <br />
    </div>
    <!-- End 營業時間 -->

    <!-- 塑膠袋設定 -->
    <div class="box-body form" v-show="storeMethod === 8">
      <div v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
        <div><h3>塑膠袋設定</h3></div>
        <br />

        <div>
          <div class="input-group">
            <span class="input-group-addon">
                塑膠袋功能
                <span class="nd-tooltip">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                  <span class="nd-tooltip-text alliance-tooltip">
                    「 塑膠袋功能 」將顯示於購車第一步驟，提供消費者選擇。
                    <img src="/static/img/plastic-select-sample-img.png" />
                  </span>
                </span>
              </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="plasticOption" value="1" v-model="plasticSelect">開啟（此功能需於菜單上架塑膠袋商品方可支援）
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="plasticOption" value="0" v-model="plasticSelect">關閉
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              塑膠袋數量可自行調整
              <span class="nd-tooltip">
                <i class="fa fa-question-circle" aria-hidden="true"></i>
                <span
                  class="nd-tooltip-text"
                  v-text="'消費者可否在購物車中自行調整塑膠袋的數量'"
                />
              </span>
            </span>
            <div>
              <div class=" text-left flex align-center">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="plasticAmountAdjustable" value="1" v-model="plasticAmountAdjustable">開啟
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="plasticAmountAdjustable" value="0" v-model="plasticAmountAdjustable">關閉
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              塑膠袋單位(幾份商品一個塑膠袋)
            </span>
            <input class="form-control" placeholder="" type="text" v-model.number.trim="storeInfo.plastic_unit">
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
          <span class="input-group-addon">
            預設勾選塑膠袋
          </span>
            <div>
              <multiselect
                v-model="deliveryWayPlastic"
                placeholder="選擇取餐方式"
                label="label"
                track-by="value"
                :options="deliveryInfo"
                :multiple="true"
                :allow-empty="true"
              />
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
    <!-- End 塑膠袋設定 -->

    <!-- 出單機設定 -->
    <div class="box-body form" v-show="storeMethod === 10">
      <div><h3>出單機設定</h3></div>
      <br />
      <div class="row" v-if="printerStoreList.length">
        <div class="col-sm-12 table-responsive p-x-0">
          <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
            <thead>
            <tr role="row">
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機名稱(ID)</th>
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定名稱(ID)</th>
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">類型</th>
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">辨識碼</th>
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機啟用</th>
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定機啟用</th>
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
              <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
            </tr>
            </thead>
            <tbody>
            <tr class="even" role="row" v-for="(printer, index) in printerStoreList">
              <!-- cloumn 0 -->
              <td class="sorting_1">{{index + 1}}</td>
              <td>
                出單機{{printer.printer_id}}號 ({{printer.printer_id}})
              </td>
              <td>
                {{printer.binding_name}} ({{printer.binding_id}})
              </td>
              <td>{{printerType(printer.printer_type)}}</td>
              <td>{{printer.printer_identity}}</td>
              <td>
                <span v-if="printer.printer_is_enabled" class="label label-success">啟用</span>
                <span v-if="!printer.printer_is_enabled"  class="label label-danger">未啟用</span>
              </td>
              <td>
                <span v-if="printer.binding_is_enabled" class="label label-success">啟用</span>
                <span v-if="!printer.binding_is_enabled"  class="label label-danger">未啟用</span>
              </td>
              <td>
                <button class="btn btn-default" data-toggle="modal" data-target="#editModal" @click="getCurrent(printer)"><i class="fa fa-pencil"></i></button>
              </td>
              <td>
                <button class="btn btn-danger" data-toggle="modal" data-target="#delModal" @click="getCurrent(printer)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
          <br>
        </div>
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>方式
        </span>
          <div class="form-group">
            <select class="form-control" v-model="printerSelect">
              <option :value="1">新增</option>
              <option :value="2">使用現有</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <div v-if="printerSelect === 1">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>識別碼
        </span>
          <input class="form-control" placeholder="" type="text" v-model="printerInfo.identity" maxlength="45">
        </div>
        <br />
      </div>
      <div v-if="printerSelect === 1">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>類型
        </span>
          <div class="form-group">
            <select class="form-control" v-model="printerInfo.type">
              <option :value="1">W牌出單機(1)</option>
              <option :value="2">F牌出單機(2)</option>
              <option :value="3">F牌貼紙機(3)</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <div v-if="printerSelect === 2">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>選擇出單機
        </span>
          <div class="form-group">
            <select class="form-control" v-model="isPrinterSelect">
              <option :value="printer.printer_id" v-for="printer in printerList">{{printer.printer_identity}}</option>
            </select>
          </div>
        </div>
      </div>
      <!-- 綁定按鈕 -->
      <button class="btn btn-success" v-if="info && storeMethod === 10" @click="checkPrinter">
        綁定
      </button>
      <br>
      <hr class="m-t-20">
      <br>
      <div v-if="printerLayoutSetting.length">
        <div><h3>出單機列印格式設定</h3></div>
        <br />
        <div class="row">
          <div class="col-sm-12 table-responsive p-x-0">
            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
              <thead>
              <tr role="row">
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">列印格式</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">觸發類型</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟用</th>
              </tr>
              </thead>
              <tbody>
              <tr class="even" role="row" v-for="(printer, index) in printerLayoutSetting">
                <!-- cloumn 0 -->
                <td class="sorting_1">{{index + 1}}</td>
                <td>
                  {{printer.layout_name}}
                </td>
                <td>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" :name="'triggerType' + index" :value="1" v-model="printer.trigger_type">手動
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" :name="'triggerType' + index" :value="2" v-model="printer.trigger_type">自動
                    </label>
                  </div>
                  <!-- <span v-if="printer.printer_is_enabled" class="label label-success">啟用</span>
                  <span v-if="!printer.printer_is_enabled"  class="label label-danger">未啟用</span> -->
                </td>
                <td>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" :name="'isEnable' + index" :value="1" v-model="printer.is_enabled">啟用
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" :name="'isEnable' + index"  :value="0" v-model="printer.is_enabled">未啟用
                    </label>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <br>
          </div>
        </div>
      </div>
    </div>
    <!-- End 出單機設定 -->

    <!-- 網址設定 -->
    <div class="box-body form" v-show="storeMethod === 11 && $route.name !== 'crStore'">
      <div><h3>網址設定</h3></div>
      <br />
      <div class="text-left"><span class="text-red">＊</span> 若開啟內用-桌邊掃碼取餐類型，門市可利用網址設定功能，新增桌號並獲取各桌獨立網址，將該網址轉為QRCode後即可運用於提供給顧客做桌邊掃碼點餐。</div>
      <div class="table-responsive m-b-15">
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>入口</td>
              <td>桌號
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text center">
                    限10字以內，僅限英數大小寫不可符號，桌號間請使用「，」分隔。
                  </span>
                </span>
              </td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <select class="form-control" v-model="tableNumberUrl.type">
                  <option v-for="item in enterType" :key="`enter-${item.value}`" :value="item.value">{{item.name}}</option>
                </select>
              </td>
              <td>
                <textarea v-model.trim="tableNumberUrl.text" rows="3" class="form-control inline-block" placeholder="範例：A01,A02,A03..."></textarea>
              </td>
              <td>
                <div @click="exportUrl" class="btn btn-default btn-table-title">匯出網址</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- End 網址設定 -->

    <!-- 計費方式設定 -->
    <div class="box-body form" v-show="storeMethod === 12">
      <div><h3>計費方式設定</h3></div>
      <br />
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>選擇計費方式
        </span>
          <div class="form-group">
            <select class="form-control" v-model="orderCommissionSetting.type">
              <option :value="1">系統費</option>
              <option :value="2">系統費+資訊服務費抽成</option>
              <option :value="3">資訊服務費抽成</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <!-- 資訊服務抽成設定 - Start -->
      <div v-if="orderCommissionSetting.type > 1" class="text-left">
        <div>
          <button
            class="btn btn-success"
            @click="orderCommissionSetting.item_list.push(JSON.parse(JSON.stringify(commissionItemList)))"
          >
            新增資訊服務費抽成設定
          </button>
        </div>
        <div
          v-for="(item, pIndex) in orderCommissionSetting.item_list"
          :key="pIndex"
          :class="['process-time-block', { 'm-t-10': pIndex !== 0 }, { 'overlap': showOverlapErrorIndex.includes(pIndex) }]"
        >
          <div class="text-right m-b-10">
            <!-- 刪除按鈕 -->
            <button
              class="btn btn-danger"
              @click="removeListItem(orderCommissionSetting.item_list, pIndex)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>資訊服務費抽成%
                <span
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="請勿輸入空格"
                >
                  <i class="fa fa-question-circle" aria-hidden="true" />
                </span>
              </span>
              <input class="form-control" placeholder="輸入數字" type="number" maxlength="2" v-model="item.ratio">
              <span class="input-addon-icon">
                %
              </span>
            </div>
            <br>
            <div class="input-group">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>取貨方式
              </span>
              <div class="form-group">
                <select class="form-control" v-model="item.delivery_type">
                  <option :value="0">全部</option>
                  <option
                    v-for="delivery in supportDeliveryOption"
                    :key="`takeType${delivery.value}`"
                    :value="delivery.value"
                  >
                    {{ delivery.label }}
                  </option>
                </select>
              </div>
            </div>
            <br>
            <div class="table-row">
              <div class="table-cell">
                <span class="text-red">＊ </span>抽成生效日
                <span
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="系統依據該日期開始計算到資訊服務費抽成報表"
                >
                  <i class="fa fa-question-circle" aria-hidden="true" />
                </span>
              </div>
              <div class="table-from">
                <date-picker
                  v-model="item.start_time"
                  class="hide-date-icon"
                  :show-second="false"
                  type="datetime"
                  valueType="format"
                  format="YYYY-MM-DD HH:mm"
                  input-class="form-control"
                  placeholder="新增日期 (格式為：YYYY-MM-DD HH:mm)"
                  :clearable="false"
                  :disabled-time="notBeforeTodayAddTwoMins"
                  :disabled-date="notBeforeToday"
                />
              </div>
            </div>
            <div class="table-row p-t-10">
              <div class="table-cell">
                <span class="text-red">＊ </span>抽成結束日
                <span
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="系統依據該日期停止計算到資訊服務費抽成報表"
                >
                  <i class="fa fa-question-circle" aria-hidden="true" />
                </span>
              </div>
              <div class="table-from">
                <date-picker
                  v-model="item.end_time"
                  class="hide-date-icon"
                  :show-second="false"
                  type="datetime"
                  valueType="format"
                  format="YYYY-MM-DD HH:mm"
                  input-class="form-control"
                  placeholder="新增日期 (格式為：YYYY-MM-DD HH:mm)"
                  :clearable="false"
                  :disabled-time="notBeforeTodayAddTwoMins"
                  :disabled-date="notBeforeToday"
                />
              </div>
            </div>
          </div>
        </div>
        <br>
      </div>
      <!-- 資訊服務抽成設定 - End -->

      <!-- 門市獨立產出抽成對帳表 -->
      <div v-if="orderCommissionSetting.type !== 1">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            <span>門市獨立產出抽成對帳表</span>
            <span
              data-toggle="tooltip"
              data-placement="bottom"
              title="適用於門市獨立簽約的類型"
            >
              <i class="fa fa-question-circle" aria-hidden="true" />
            </span>
          </span>

          <div class="flex align-center h-34">
            <div class="radio inline-block">
              <label>
                <input type="radio" name="independent" :value="1" v-model.number="orderCommissionSetting.has_independent_report">
                是
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input type="radio" name="independent" :value="0" v-model.number="orderCommissionSetting.has_independent_report">
                否
              </label>
            </div>
          </div>
        </div>
        <div v-show="!orderCommissionSetting.has_independent_report" class="process-time-block">
          <div class="text-left m-b-15">
            <button
              data-toggle="modal"
              data-target="#leaveModal"
              class="btn btn-default"
            >
              前往修改
            </button>
          </div>

          <!-- 額度計算 -->
          <div class="input-group m-b-15">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>額度計算
            </span>
            <div class="flex align-center m-l-15 h-34">
              {{ orderCommissionSetting.brand_setting.quota_type === 1 ? '品牌總' : '每間門市' }}額度
              <span
                class="m-l-5"
                data-toggle="tooltip"
                data-placement="bottom"
                :title="orderCommissionSetting.brand_setting.quota_type === 1 ? '整個品牌的作廢訂單總額度，非單一門市值。' : '每間門市都有指定的作廢額度。例如 : 當額度設定為 5 筆時，每間門市都有 5 筆的作廢額度。'"
              >
                <i class="fa fa-question-circle" aria-hidden="true" />
              </span>
            </div>
          </div>
          <!-- End 額度計算 -->

          <!-- 每月作廢訂單額度 -->
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>每月作廢訂單額度（筆）
            </span>

            <!-- 品牌作廢訂單額度 -->
            <div class="flex align-center m-l-15 h-34">
              {{ brandInvalidQuota }}
            </div>
          </div>
          <!-- End 每月作廢訂單額度 -->
        </div>
        <br />
      </div>
      <!-- End 門市獨立產出抽成對帳表 -->

      <!-- 門市每月作廢訂單額度 -->
      <div v-show="orderCommissionSetting.has_independent_report" class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>門市每月作廢訂單額度（筆）
        </span>
        <input
          class="form-control"
          type="number"
          maxlength="10"
          v-model="orderCommissionSetting.allow_invalid_order_quota"
        />
      </div>
      <!-- End 門市每月作廢訂單額度 -->
    </div>
    <!-- End 計費方式設定 -->

    <!-- 物流設定 -->
    <div
      class="box-body form"
      v-show="storeMethod === 13"
    >
      <div>
        <h3>物流設定</h3>
      </div>
      <br />
      <!--
        扣款對象 顯示邏輯
        1. 編輯門市時
        2. 已與米特串接
      -->
      <div v-if="$route.name === 'upStore' && storeInfo.shipping_info && storeInfo.shipping_info.mete_store_id">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊</span>
          扣款對象
        </span>
          <div class="form-group">
            <div class="form-group text-left">
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="brand"
                    :value="2"
                    v-model="pay_party"
                    :disabled="true"
                  />
                  品牌
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input
                    type="radio"
                    name="brand"
                    :value="1"
                    v-model="pay_party"
                    :disabled="true"
                  />
                  門市
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div>
        <table class="table table-bordered table-striped dataTable">
          <thead class="bg-primary">
            <tr>
              <td>配送物流</td>
              <td>開啟狀態</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(vendor, index) in supportShippingVendor"
              :key="index"
            >
              <td>
                {{ vendor.vendor_code | shippingVendorName }}
              </td>
              <td>
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input
                        type="radio"
                        :value="1"
                        v-model="vendor.is_enable"
                        @input="reload = true"
                      />
                      啟用
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input
                        type="radio"
                        :value="0"
                        v-model="vendor.is_enable"
                        @input="reload = true"
                      />
                      不啟用
                    </label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- End 物流設定 -->

    <!-- 服務費設定 -->
    <div
      v-show="storeMethod === 14"
      class="box-body form"
    >
      <h3 v-text="'服務費設定'" />
      <br />
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            <span v-text="'服務費說明'" />
            <span class="nd-tooltip">
              <ion-icon name="help-circle" />
              <span
                class="nd-tooltip-text"
                v-text="'填寫資訊會顯示在前台畫面中。例本店收取服務費10%。'"
              />
            </span>
          </span>
          <input
            class="form-control"
            placeholder="服務費說明設定"
            type="text"
            v-model="storeInfo.service_fee_description"
            maxlength="100"
          />
        </div>
      </div>
    </div>
    <!-- End 服務費設定 -->

    <!-- 特殊需求 -->
    <div class="box-body form" v-show="storeMethod === 15">
      <div v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
        <div>
          <h3>特殊需求</h3>
          <div>請確認POS端是否支援此功能</div>
        </div>
        <br/>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊</span>
              自選吸管或餐具功能
              <span class="nd-tooltip">
                <i class="fa fa-question-circle" aria-hidden="true"></i>
                <span class="nd-tooltip-text alliance-tooltip">
                  「 自選吸管或餐具功能 」 將顯示於購車第一步驟，提供消費者選擇。
                  <img src="/static/img/straw-option-sample-img.png"/>
                </span>
              </span>
            </span>
            <div class="flex align-center h-34">
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="showTablewareStrawOption" :value="1" v-model.number="showTablewareStrawOption">開啟
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="showTablewareStrawOption" :value="0" v-model.number="showTablewareStrawOption">關閉
                </label>
              </div>
            </div>
          </div>
          <br/>
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>預設吸管或餐具選項
            </span>
            <div class="flex align-center h-34">
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="setTablewareStrawDefaultVal" :value="1" v-model.number="setTablewareStrawDefaultVal">開啟
                </label>
              </div>
              <div class="radio inline-block">
                <label>
                  <input type="radio" name="setTablewareStrawDefaultVal" :value="0" v-model.number="setTablewareStrawDefaultVal">關閉
                </label>
              </div>
            </div>
          </div>
          <br/>
        </div>
      </div>
    </div>
    <!-- End 特殊需求 -->

    <div class="box-footer text-center" v-if="![9, 11].includes(storeMethod)">
      <button class="btn btn-default" v-if="(!info && storeMethod === 1) || info" @click="goToStoreTable()">
        取消
      </button>
      <button class="btn btn-default" v-if="!info && storeMethod !== 1" @click="goStep(-1)">
        上一步
      </button>
      <button class="btn btn-success" v-if="!info && storeMethod !== crStep[crStep.length - 1]" @click="goStep(1)">
        下一步
      </button>
      <button class="btn btn-success" v-else-if="!info" @click="checkBeforeSend('cr')" :class="{ 'disabled': loading }" :disabled="loading">
        新增
      </button>

      <template v-if="info">
        <button v-if="addressChanged" data-toggle="modal" data-target="#addressModal" class="btn btn-success">
          修改
        </button>
        <button v-else="!addressChanged" class="btn btn-success" @click="checkBeforeSend('up')">
          修改
        </button>
      </template>
    </div>

    <br />

    <m-modal
      class="text-left"
      :option="delOption"
      @trigger="trigger"
    />
    <m-modal
      class="text-left"
      :option="editOption"
      :selectChange="selectChange"
      :selectOptions="selectOptions"
      @trigger="trigger"
      @selectOnChange="selectOnChange"
      @inputOnChange="inputOnChange"
    />
    <m-modal
      class="text-left"
      :option="leaveOption"
      @trigger="trigger"
    />
    <m-modal
      class="text-left"
      :option="addressOption"
      @trigger="trigger"
    />
    <!-- 統一編號不一致提醒 -->
    <m-modal
      class="text-left"
      :option="einOption"
      @trigger="trigger"
    >
      <template slot="body">
        <div class="row ein-row">
          <div class="col-sm-6 ein-col">
            <div class="ein-card">
              <div class="ein-card-title">門市基本資訊</div>
              <div class="ein-card-item">
                <span class="ein-card-dot">・</span>
                統一編號
                <span class="label label-primary">{{ einCheckStoreEin || '無' }}</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 ein-col">
            <div class="ein-card">
              <div class="ein-card-title">付款方式</div>
              <div class="ein-card-item">
                <span class="ein-card-dot">・</span>
                金流帳戶統一編號
              </div>
              <ol class="ein-card-list">
                <li
                  v-for="(trade, index) in einCheckList"
                  :key="index"
                >
                  {{ trade.name }}
                  <span class="label label-primary">{{ trade.ein || '無' }}</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
        <p class="ein-message">
          您設定的統編不一致，將可能影響款項對帳作業，請問是否仍要儲存？
        </p>
      </template>
    </m-modal>
    <!-- End 統一編號不一致提醒 -->
  </div>
</div>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import { mapGetters } from 'vuex'

// components
import matcherModal from '../../../elements/Modal.vue'
import ImgUploadTemp from './ImgUploadTemp.vue'
import downloadFile from '../../../../assets/js/down-load-file.js'
import ShippingForm from './ShippingForm.vue'
import DeliveryLimit from './DeliveryLimit.vue'
import chooseStoreModal from '@/components/elements/chooseStoreModal.vue'

// date time picker
import VueTimepicker from 'vue2-timepicker'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      storeOption: {
        id: 'copyModal'
      },
      delExceptionOption: {
        id: 'delExceptionModal',
        title: '批次刪除排除商品',
        body: '確認批次刪除所選排除商品？',
        btns: [
          {
            name: '取消',
            event: 'close'
          },
          {
            name: '確定',
            event: 'delExceptionProduct'
          }
        ]
      },
      optionsList: [],
      deliveryExceptionProductSelect: false,
      deliveryExceptionProductSelectAll: false,
      deliveryExceptionProductList: [],
      loading: false,
      originAddress: {
        city_code: 0,
        area_code: 0,
        address_short: ''
      },
      crStep: [1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 14, 15], // 新增門市時顯示的 tab
      showCalendar: false,
      bindingClassList: [],
      mealTagList: [],
      posBrief: [],
      storeName: '',
      storeDes: '',
      adRowNum: 2,
      groupList: [],
      areaTimes: 0,
      cityAreaList: [],
      areaOption: [],
      cityOption: [],
      imgLogoOption: [],
      imgBgOption: [],
      storeBrief: [],
      groupSelect: 0,
      imgLogoSelect: '',
      imgBgSelect: '',
      copyStoreSelect: 99,
      copyBannerTypeList: [],
      areaSelect: 99,
      citySelect: 99,
      posSelect: 99,
      posTypeSelect: 10,
      storeTypeSelect: 0, // 門市類型
      statusSelect: 2, // 營業狀態
      orderStatusSelect: 20, // 接單狀態
      isVisibleSelect: 1,
      isStickerSelect: 0,
      barcodeSelect: 0,
      hasInvoicePaperSelect: 1, // 開放紙本發票
      hasInvoiceCarrierSelect: 0, // 開放電子載具
      invoiceRemark: '', // 發票備註
      hasInvoiceNpobnaSelect: 0, // 開放愛心捐贈發票
      isInvoiceException: 0, // 店家是否開立發票
      apiTypeSelect: 2, // API服務類型
      showMenuIconSelect: 0, // 飲料溫度顯示(冷 熱 無溫度)
      plasticSelect: 0, // 購物車顯示塑膠袋，預設關閉
      plasticAmountAdjustable: 0, // 塑膠袋數量可自行調整
      deliveryNeedSelect: 0,
      isSearchSelect: 0, // 首頁是否搜尋的到店家
      roundingTypeSelect: 1, // 金額進位
      couponFormSelect: 1,
      showProdSettingSelect: 1,
      isPosAccount: 0,
      isCopy: 0,
      img: {
        width: 0,
        height: 0
      },
      bgImg: {
        width: 0,
        height: 0
      },
      tradeInfo: [],
      takeTimeInfo: [
        {take_type: 1, prepare_time_seg: 15, take_time_seg: 0},
        {take_type: 2, prepare_time_seg: 15, take_time_seg: 0},
        {take_type: 3, prepare_time_seg: 30, take_time_seg: 0},
        {take_type: 4, prepare_time_seg: 15, take_time_seg: 0},
        {take_type: 5, prepare_time_seg: 15, take_time_seg: 0},
        {take_type: 21, prepare_time_seg: 3, take_time_seg: 0}
      ],
      openingInfo: [
        {week_day: 1, start: '08:00', end: '22:00'},
        {week_day: 2, start: '08:00', end: '22:00'},
        {week_day: 3, start: '08:00', end: '22:00'},
        {week_day: 4, start: '08:00', end: '22:00'},
        {week_day: 5, start: '08:00', end: '22:00'},
        {week_day: 6, start: '08:00', end: '22:00'},
        {week_day: 7, start: '08:00', end: '22:00'}
      ],
      deliveryWaysInfo: [
        {take_type: 1, is_support: 1, is_enable: 1, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: ''},
        {take_type: 2, is_support: 1, is_enable: 0, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: ''},
        {take_type: 3, is_support: 1, is_enable: 1, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: ''},
        {take_type: 4, is_support: 0, is_enable: 0, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: ''},
        {take_type: 5, is_support: 0, is_enable: 0, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: ''},
        {take_type: 21, is_support: 1, is_enable: 0, distance_m: 0, price: 0, is_default: 0, is_allow_guest_order: 1, memo: '', pickup_memo: ''}
      ],
      deliveryOther: [],
      storeInfo: {
        address_remark: '',
        address_short: '',
        allow_copy_menu: 1,
        allow_update_menu: 1,
        area_code: '',
        auto_reject_order_m: 15, // 自動拒單時間
        auto_reject_order_reserve_m: 60,
        bg_image_name: '',
        binding_class: false,
        binding_class_ids: [],
        binding_meal_tag_ids: [],
        bl_name: '',
        branch_code: '',
        brand_name: '',
        city_code: '',
        comment: '',
        custom_sticker_max_length: 10,
        delivery_stage_limit_type: 1,
        description: '',
        ein: '',
        email: '',
        food_business_no: '',
        image_name: '',
        introduction: '',
        is_close_allow_order: 1,
        is_off_allow_order: 1,
        is_preparing_allow_order: 1,
        is_support_custom_remark: 0,
        max_delivery_distance_m: '',
        meat_origin_description: '',
        membership_provider_parent_id: -1,
        menu_ab_block_type: 1,
        menu_expand_type: 1,
        menu_layout_type: 1,
        menu_stop_sale_today_type: 1,
        menu_stop_sale_type: 2,
        name: '',
        name_short: '',
        one_order_max_money: 10000,
        order_end_time_m: 0,
        order_start_day: 0,
        order_start_time_m: 0,
        order_status_reason: '',
        order_tolerance_day: 0,
        photo_name: '',
        plastic_unit: 6,
        pos_branch_code: '',
        search_description: '',
        show_menu_product_icon: 0, // 菜單產品圖示顯示
        show_menu_zero_money: 0,
        tel: '',
        tel2: '',
        to_store_pay_max_money: 10000,
        youtube_video_code: ''
      },
      // 2022-08-15 #165900186
      copyInfo: {
        menuStore: false,
        menuStoreId: null,
        productAlias: false,
        productAliasStoreId: null,
        productDescription: false,
        productDescriptionStoreId: null,
        productImage: false,
        productImageStoreId: null
      },
      posAccount: {
        account: '',
        password: ''
      },
      // 2019-02-26 新增
      deliveryInfo: [
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        // {label: '外帶', value: 4},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      menuLayout: [
        {label: '文字，選項方塊 (飲料店用)', value: 1},
        {label: '圖文，商品描述為點擊後', value: 2},
        {label: '圖文，商品描述在下方', value: 3},
        {label: '圖文，商品描述在下方，外層大圖', value: 31},
        {label: '文字，選項條列式 (餐廳用)', value: 4}
      ],
      deliveryWayPlastic: [],
      offdaySetting: {
        date: [],
        weekDay: [],
        monthDay: [],
        options: {
          date: [
            {label: '無指定', value: 0}
          ],
          weekDay: [
            {label: '無指定', value: 0},
            {label: '週日', value: 1},
            {label: '週一', value: 2},
            {label: '週二', value: 3},
            {label: '週三', value: 4},
            {label: '週四', value: 5},
            {label: '週五', value: 6},
            {label: '週六', value: 7}
          ],
          month: [
            {label: '無指定', value: 0},
            {label: '一月', value: 1},
            {label: '二月', value: 2},
            {label: '三月', value: 3},
            {label: '四月', value: 4},
            {label: '五月', value: 5},
            {label: '六月', value: 6},
            {label: '七月', value: 7},
            {label: '八月', value: 8},
            {label: '九月', value: 9},
            {label: '十月', value: 10},
            {label: '十一月', value: 11},
            {label: '十二月', value: 12}
          ],
          monthDay: [
            {label: '無指定', value: 0}
          ]
        }
      },
      processTimeList: [],
      deliveryTypeOption: [
        {label: '所有', value: 0},
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        // {label: '外帶', value: 4},
        // {label: '吧台', value: 5},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      storeMethod: 1,
      printerStoreList: [],
      printerInfo: {
        identity: '',
        type: 1
      },
      printerSelect: 1,
      isPrinterSelect: '',
      printerList: [],
      delOption: {
        id: 'delModal',
        title: '刪除店家綁定',
        body: '確定刪除?<br>刪除此店家綁定！',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delBinding'
          }
        ]
      },
      selectChange: '',
      addressOption: {
        id: 'addressModal',
        title: '地址修改提醒',
        body: '如有開通米特物流服務，修改地址後請同步通知米特物流窗口。',
        btns: [
          {
            name: '確定',
            event: 'saveAddress'
          }
        ],
        footerTextAlign: 'right'
      },
      // 統一編號不一致提醒
      einOption: {
        id: 'einModal',
        title: '統一編號不一致',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'saveEin'
          }
        ],
        footerTextAlign: 'right'
      },
      einCheckList: [], // 彈窗顯示的已支援付款方式金流帳戶統一編號
      einCheckStoreEin: '', // 彈窗顯示的門市基本資訊統一編號
      einConfirmed: false, // 使用者已確認統一編號不一致仍要儲存
      einConfirmType: 'up', // 統一編號提醒後要續行的儲存類型
      originEin: '', // 門市基本資訊統一編號原始值 (判斷是否變更)
      originTradeEin: {}, // 付款方式原始支援狀態與金流帳戶統一編號 (判斷是否變更)
      editOption: {
        id: 'editModal',
        title: '編輯店家綁定',
        body: '編輯店家綁定！',
        input: {
          name: '綁定名稱'
        },
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'editBinding'
          }
        ]
      },
      selectOptions: {
        name: '綁定啟用',
        options: [
          {text: '啟用', value: 1},
          {text: '不啟用', value: 0}
        ]
      },
      leave: false, // 前往品牌設定
      leaveOption: {
        id: 'leaveModal',
        title: '提醒',
        body: '您即將離開此頁面!<br>請先確認上方計費方式設定已填寫完成後，再前往修改。',
        btns: [
          {
            name: '取消'
          },
          {
            name: '儲存並前往修改',
            event: 'save'
          }
        ]
      },
      current: {},
      change: {
        is_enabled: 1,
        binding_name: ''
      },
      tradeList: [],
      exceptionTradeList: [],
      exceptionCalendar: [],
      disModeSelect: 13, // 距離計算模式
      reload: false,
      // 出單機layout
      printerLayoutList: [],
      printerLayoutSetting: [],
      selectDate: {
        'currentDate': '',
        'selectedDate': false,
        'selectedDateTime': false,
        'selectedHour': '00',
        'selectedMinute': '00',
        'selectedDatesItem': '',
        'selectedDates': [],
        'dateRange': { 'start': '', 'end': '' },
        'multipleDateRange': []
      },
      remarkMaxlength: 100,
      specialDayRemarkMaxlength: 15,
      tableNumberUrl: {
        text: '',
        type: 1
      },
      enterType: [], // 網址設定平台 options
      // 隱藏外帶(4) & 吧檯(5) 的取餐方式
      hideDeliveryType: [4, 5],
      // 桌邊掃碼 default
      tableNumber: {
        default_login_type: 1,
        is_cash_pay_after_meal: 0,
        is_table_no_editable: 0,
        is_table_no_required: 0,
        sub_delivery_type: 1,
        show_table_no: 1,
        type: 21
      },
      // 計費方式設定
      brandInvalidQuota: 0, // 品牌每月可作廢的訂單額度
      orderCommissionSetting: {
        has_independent_report: 0, // 門市是否有獨立報表
        allow_invalid_order_quota: 2, // 每月可作廢的訂單額度 (預設 2 筆)
        type: 1, // 收費設定 (1:系統費 2:系統+資訊 3:資訊服務費抽成)
        item_list: [] // 資訊服務費細項設定
      },
      showOverlapErrorIndex: [], // 資訊服務費細項設定錯誤位置
      commissionItemList: { // 細項設定預設
        delivery_type: 0,
        start_time: null,
        end_time: null,
        ratio: null, // 抽成比例 (5=5%)
        rounding_type: 3 // 進位方式 (固定: 四捨五入)
      },
      repeatPosAccountList: [],
      posList: [
        {
          account: '',
          password: '',
          pos_vendor_id: 99,
          role_type: 10,
          remark: '',
          is_active: 1,
          vaildSingleAccount: true
        }
      ], // pos 帳號列表
      copyPostList: [], // 未變更的post帳號列表
      realPostList: [], // 最後要送出的post帳號列表
      // 物流
      pay_party: 1, // 扣款對象 1:門市 2:品牌
      supportShippingVendorList: [], // 支援的物流列表(後端傳入)
      shippingVendorInfo: [ // 初始物流資訊
        // {
        //   vendor_code: 'mete-mix',
        //   is_enable: 0,
        //   custom_config: {
        //     is_advance_money: 0,
        //     is_allow_cash_payment_order: 0,
        //     exec_start_time_m: 0
        //   }
        // }
      ],
      membershipGroupType: 0, // 會員卡制度
      providerId: 0, // 會員卡ID
      urlRedirection: {
        new_store_id: 0,
        new_store_info: [],
        stores: []
      },
      showTablewareStrawOption: 0, // default 隱藏 "自選吸管或餐具功能" 欄位
      setTablewareStrawDefaultVal: 0, // default 關閉 "預設吸管或餐具選項"
      showSpecialDayCalendar: false,
      selectSpecialDay: [], // 特殊日期表陣列
      tempSpecialDayCalendar: { // 特殊日期選擇器
        'currentDate': '',
        'selectedDate': false,
        'selectedDateTime': false,
        'selectedHour': '00',
        'selectedMinute': '00',
        'selectedDatesItem': '',
        'selectedDates': [],
        'dateRange': { 'start': '', 'end': '' },
        'multipleDateRange': []
      }
    }
  },
  methods: {
    async copyStore (storeList) {
      // 同步多門市商品別名或商品描述設定
      let data = {
        sync_store_ids: storeList.join(',')
      }
      const url = 'store/' + this.$route.params.store_id + '/syncDeliveryExceptionProduct'
      await this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '新增成功',
            text: '新增成功',
            duration: 1000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    handleProductSelect (item) {
      this.reload = true
      item.vendor_custom_id = item.search_result.id
      item.product_name = item.search_result.name
      item.product_type = item.search_result.type
    },
    async getMenuId () {
      // 取得該店 Menu id
      const url = 'onlineMenu/list?page=1&size=1&store_id=' + this.$route.params.store_id
      await this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const result = response.data.menu_list
            ? response.data.menu_list[0]
              ? response.data.menu_list[0].id
              : null
            : null
          if (result) {
            this.getProductInfoList(result)
          }
        }
      })
    },
    async getProductInfoList (menuId) {
      // 取得該店商品列表 (商品名 + 料號)
      const url = 'onlineMenu/' + menuId + '/productBrief'
      await this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.optionsList = []
          const menu = response.data.brief
          menu.category_list.forEach((category) => {
            category.child_list.forEach((prod) => {
              if (this.optionsList.findIndex(x => x.id === prod.vendor_custom_id) < 0) {
                const data = {
                  name: prod.name,
                  id: prod.vendor_custom_id,
                  type: prod.type
                }
                this.optionsList.push(data)
              }
            })
          })
        }
      })
    },
    addProductItem (type) {
      this.deliveryExceptionProductList.push({ product_name: '', vendor_custom_id: '', product_type: 0, is_enabled: 1, item_type: type, delivery_type: 3, selected: false })
    },
    deleteProductItem (index) {
      this.deliveryExceptionProductList.splice(index, 1)
    },
    batchDeleteProduct () {
      this.deliveryExceptionProductSelect = false
    },
    selectAllProducts () {
      this.deliveryExceptionProductSelectAll = !this.deliveryExceptionProductSelectAll
      this.deliveryExceptionProductList = this.deliveryExceptionProductList.map(item => {
        return {
          ...item,
          selected: this.deliveryExceptionProductSelectAll
        }
      })
    },
    checkPosSingleAccount (item, index) {
      const vaildAccount = this.copyPostList.filter(x => x.pos_account_id === item.pos_account_id)
      if ((item.pos_account_id && vaildAccount[0].account !== item.account) || !item.pos_account_id) {
        var url = '/pos/list?account_full=' + item.account + '&page=1&size=20'
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            if (response.data.list && response.data.list.length > 0) {
              item.vaildSingleAccount = false
            } else {
              item.vaildSingleAccount = true
            }
          }
        })
      }
    },
    changeTab (index) {
      if (this.$route.name === 'upStore') {
        this.storeMethod = Number(index)
      }
    },
    async cheakAllPostAccount () {
      this.realPostList.forEach(async (item, index) => {
        await this.checkPosSingleAccount(item, index)
      })
    },
    updatePosAccount (storeId) {
      this.realPostList.forEach(async x => {
        let method = 'post'
        let url = '/pos'
        if (x.pos_account_id) {
          method = 'put'
          url += '/' + x.pos_account_id
        }
        let data = {
          ...x,
          brand_id: this.$route.params.brand_id,
          store_id: storeId
        }
        await this.getDataH(method, url, data, (response) => {
          if (this.$route.name === 'upStore') {
            this.getPosAccountList()
          }
        })
      })
    },
    deletePosAccount (index) {
      this.posList.splice(index, 1)
    },
    newPosAccount () {
      this.posList.push(
        {
          account: '',
          password: '',
          pos_vendor_id: 99,
          role_type: 10,
          remark: '',
          is_active: 1,
          vaildSingleAccount: true
        }
      )
    },
    goStep (step) {
      // 切換上一步、下一步
      const sIndex = this.crStep.indexOf(this.storeMethod)
      if (step > 0) {
        this.storeMethod = this.crStep[sIndex + 1]
        this.checkBeforeSend()
      } else {
        this.storeMethod = this.crStep[sIndex - 1]
      }
    },
    notBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    notBeforeTodayAddTwoMins (date) {
      return date < new Date(moment().set('second', 0).add(5, 'm').toString())
    },
    checkCommission () {
      // 計費方式欄位防呆
      const itemList = this.orderCommissionSetting.item_list
      if (this.orderCommissionSetting.allow_invalid_order_quota === '') {
        return '請輸入每月作廢訂單額度(筆)'
      } else if (this.orderCommissionSetting.type > 1) {
        if (!itemList.length) {
          return '請增加資訊服務費抽成設定'
        } else {
          // 判斷抽成詳細設定
          this.showOverlapErrorIndex = []
          for (let i = 0; i < itemList.length; i++) {
            const startTime = itemList[i].start_time
            const endTime = itemList[i].end_time
            if (itemList[i].ratio === '') {
              this.showOverlapErrorIndex = [i]
              return '請輸入資訊服務費抽成%'
            } else if (!startTime || !endTime) {
              this.showOverlapErrorIndex = [i]
              return `請輸入抽成${!startTime ? '生效' : '結束'}時間`
            } else if (moment(endTime).isBefore(startTime)) {
              this.showOverlapErrorIndex = [i]
              return '結束時間小於開始時間，請重新選擇!'
            } else if (i > 0) {
              // 若目前設定的取餐方式與之前的相同或包含，則比對時間是否有重複
              for (let j = (i - 1); j >= 0; j--) {
                // delivery_type = 0 為全部
                if (itemList[i].delivery_type === 0 || itemList[j].delivery_type === 0 || itemList[i].delivery_type === itemList[j].delivery_type) {
                  const lastStartTime = itemList[j].start_time
                  const lastEndTime = itemList[j].end_time
                  if (this.dateRangeOverlaps(startTime, endTime, lastStartTime, lastEndTime)) {
                    this.showOverlapErrorIndex.push(j)
                    this.showOverlapErrorIndex.push(i)
                  }
                }
              }
            }
          }
          if (this.showOverlapErrorIndex.length) {
            return `時間重覆設定，請確認!`
          }
        }
      }
      return false
    },
    setCommissionQuery () {
      // 設定計算方式 API 參數
      let query = JSON.parse(JSON.stringify(this.orderCommissionSetting))
      if (!this.orderCommissionSetting.item_list.length) {
        delete query['item_list']
      } else if (this.orderCommissionSetting.type === 1) {
        // 系統費則無門市獨立報表與資訊服務費細項
        delete query['item_list']
        query['has_independent_report'] = 0
      } else {
        // 生效時間加上 00 / 結束時間加上 59
        query.item_list.forEach(item => {
          item.start_time = `${item.start_time}:00`
          item.end_time = `${item.end_time}:59`
        })
      }
      return query
    },
    dateRangeOverlaps (startA, endA, startB, endB) {
      // 判斷時間是否重複
      if (startA === endA && startB === endB) {
        return startA === startB
      } else if (startA === endA && startB !== endB) {
        return startA >= startB && startA <= endB
      } else if (startA !== endA && startB === endB) {
        return startB >= startA && startB <= endA
      } else {
        return (startA <= endB && startB < endA)
      }
    },
    calendarSelected (val) {
      // 驗證日期是否在允許的範圍內
      const selectedDate = moment(val.date, 'DD/MM/YYYY')
      const minDate = moment(this.calendarLimits.min, 'DD/MM/YYYY')
      const maxDate = moment(this.calendarLimits.max, 'DD/MM/YYYY')

      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        return
      }

      let formatDay = moment(val.date, 'D/M/YYYY').format('YYYY-MM-DD')
      if (!val.isMarked) {
        const oDate = {label: formatDay, value: formatDay}
        this.offdaySetting.date.push(oDate)
      } else {
        var index = this.offdaySetting.date.findIndex(e => e.value === formatDay)
        this.offdaySetting.date.splice(index, 1)
      }
    },
    specialDayCalendarSelected (rowIndex, val) {
      // 驗證日期是否在允許的範圍內
      const selectedDate = moment(val.date, 'DD/MM/YYYY')
      const minDate = moment(this.calendarLimits.min, 'DD/MM/YYYY')
      const maxDate = moment(this.calendarLimits.max, 'DD/MM/YYYY')

      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        return
      }

      let formatDay = moment(val.date, 'DD/MM/YYYY').format('YYYY-MM-DD')

      if (!val.isMarked) {
        const oDate = {label: formatDay, value: formatDay}
        this.selectSpecialDay[rowIndex].calendar_list.push(oDate)
      } else {
        var index = this.selectSpecialDay[rowIndex].calendar_list.findIndex(e => e.value === formatDay)
        if (index > -1) {
          this.selectSpecialDay[rowIndex].calendar_list.splice(index, 1)
        }
      }
      // 更新日曆顯示
      this.$nextTick(() => {
        const selectedDates = this.selectSpecialDay[rowIndex].calendar_list.map(item => {
          const date = moment(item.value, 'YYYY-MM-DD').format('D/M/YYYY')
          return { date: date, dateTime: false, hour: '00', minute: '00' }
        })
        this.tempSpecialDayCalendar.selectedDates = selectedDates.slice()
      })
    },
    removeTag (type, rowIndex, val) {
      let formatday = moment(val.value, 'YYYY-MM-DD').format('D/M/YYYY')

      if (type === 'date') {
        if (this.selectDate.selectedDates) {
          let index = this.selectDate.selectedDates.findIndex(e => e.date === formatday)
          if (index > -1) {
            this.selectDate.selectedDates.splice(index, 1)
          }
        }
      } else if (type === 'specialDay') {
        let index = this.selectSpecialDay[rowIndex].calendar_list.findIndex(e => e.value === val.value)
        if (index > -1) {
          this.selectSpecialDay[rowIndex].calendar_list.splice(index, 1)
        }
      }
    },
    openSpecialDayCalendar (rowIndex) {
      // 依 calendar_list 更新日曆
      const selectedDates = this.selectSpecialDay[rowIndex].calendar_list.map(item => {
        return { date: moment(item.value, 'YYYY-MM-DD').format('D/M/YYYY'), dateTime: false, hour: '00', minute: '00' }
      })
      this.tempSpecialDayCalendar.selectedDates = selectedDates.slice()
      this.selectSpecialDay[rowIndex].showSpecialDayCalendar = true
      this.removeMultiselectWrapper()
    },
    removeListItem (list, index) {
      list.splice(index, 1)
    },
    openDateCalendar () {
      this.showCalendar = true
      this.removeMultiselectWrapper()
    },
    removeMultiselectWrapper () {
      this.$nextTick(() => {
        // 只刪除 calendar-multiselect 相關的 wrapper
        const calendarMultiselects = document.querySelectorAll('.calendar-multiselect')
        calendarMultiselects.forEach(multiselect => {
          const wrappers = multiselect.querySelectorAll('.multiselect__content-wrapper')
          wrappers.forEach(wrapper => {
            wrapper.remove()
          })
        })
      })
    },
    validateTimeRange (item, startTimeKey = 'start_time', endTimeKey = 'end_time') {
      // 從 item 中取得對應的時間欄位
      const startTime = item[startTimeKey]
      const endTime = item[endTimeKey]

      // 若任何一個為空值，就先不驗證
      if (!startTime || !endTime) {
        return true
      }

      const startTimeTrimmed = startTime.trim()
      const endTimeTrimmed = endTime.trim()

      const startMoment = moment(startTimeTrimmed, 'HH:mm', true)
      const endMoment = moment(endTimeTrimmed, 'HH:mm', true)

      // 打烊時間需 > 營業時間
      if (startMoment.isSameOrAfter(endMoment)) {
        this.$notify({
          title: '提醒',
          text: '結束時間必須晚於開始時間',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        item[endTimeKey] = ''
        return false
      }
      return true
    },
    clearProcess (process) {
      process.end_value = ''
      process.start_value = ''
    },
    addItemTime (process) {
      var item = {
        start_time: '',
        end_time: '',
        process_time: ''
      }
      process.item_list.push(item)
    },
    addProcessTime () {
      var process = {
        month: 0,
        value_type: 1,
        start_value: '',
        end_value: '',
        delivery_type: 1,
        item_list: [
          {
            start_time: '',
            end_time: '',
            process_time: ''
          }
        ]
      }
      this.processTimeList.push(process)
    },
    addExCalendar () {
      var calendar = {
        delivery_type: 1,
        date_type: [],
        week_day: [],
        month_day: []
      }
      this.exceptionCalendar.push(calendar)
    },
    addExDate (exCalendar) {
      var date = {
        date: '',
        start_time: '',
        end_time: ''
      }
      exCalendar.date_type.push(date)
    },
    addExWeekDay (exCalendar) {
      var weekDay = {
        day: 1,
        start_time: '',
        end_time: ''
      }
      exCalendar.week_day.push(weekDay)
    },
    addExMonthDay (exCalendar) {
      var monthDay = {
        day: '',
        start_time: '',
        end_time: ''
      }
      exCalendar.month_day.push(monthDay)
    },
    addStartMonthDayTag (newTag, id) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    addEndMonthDayTag (newTag, id) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    addDateTag (newTag) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.date.push(tag)
      // this.offdaySetting.date.push(tag)
    },
    addMonthDayTag (newTag) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    addSpecialDay () {
      var calendar = {
        showSpecialDayCalendar: false,
        calendar_list: [],
        start_time: '',
        end_time: '',
        remark: ''
      }
      this.selectSpecialDay.push(calendar)
    },
    returnNum (e) {
      var charCode = (e.which) ? e.which : e.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault()
      } else {
        return true
      }
    },
    getMealTagList (callback) {
      var self = this
      var url = '/mealTag/listBrief?is_visible=1'
      self.mealTagList = []
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.list.forEach(function (tag) {
            const obj = {
              label: tag.name,
              value: tag.tag_id
            }
            self.mealTagList.push(obj)
          })
          callback()
        }
      })
    },
    getBindingClassList () {
      var self = this
      var url = 'brand/' + self.$route.params.brand_id + '/storeClassList'
      self.bindingClassList = []
      self.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.list.forEach(function (bindingClass) {
            const obj = {
              label: bindingClass.name,
              value: bindingClass.id
            }
            self.bindingClassList.push(obj)
          })
        }
      })
    },
    init () {
      const self = this
      this.getMealTagList(function () {
        self.getTradeTypeList()
      })
      if (this.$route.name !== 'upStore') this.getGroupList()
      this.getCityAreaList()
      if (this.getRoleType === 99) this.getPosBrief()
      if (this.getRoleType === 99 || this.getRoleType === 30) this.getBrandImgList()
      // else this.storeMethod = 3
      this.getStoreBrief()
      this.getBrandInfo()
      if (this.$route.name === 'upStore' && this.getRoleType === 99) {
        this.getPosAccountList()
      }
      if (this.$route.name === 'crStore' && this.getRoleType === 99) {
        this.getBindingClassList()
        this.getMembershipType()
      }
      this.getShippingVendorList()
      this.getMenuId()
    },
    getMembershipType () {
      var url = '/membership/provider/list/?brand_id=' + this.$route.params.brand_id + '&page=1&size=20'
      this.getDataH('get', url, null, (response) => {
        this.membershipGroupType = response.data.list[0].meta.membership_group_type
        this.providerId = response.data.list[0].id
      })
    },
    getPosAccountList () {
      var url = '/pos/list/?brand_id=' + this.$route.params.brand_id + '&store_id=' + this.$route.params.store_id + '&page=1&size=20'
      this.getDataH('get', url, null, (response) => {
        this.isPosAccount = response.data.list.length > 0 ? 1 : 0
        this.posList = response.data.list.map(x => {
          return {
            ...x,
            vaildSingleAccount: true
          }
        })
        this.copyPostList = JSON.parse(JSON.stringify(this.posList))
      })
    },
    addAdRow () {
      this.adRowNum = this.adRowNum + 1
    },
    delAdRow () {
      this.adRowNum = this.adRowNum - 1
    },
    getGroupList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroupListBrief'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.groupList = response.data.list
          if (self.groupList.length) self.groupSelect = self.groupList[0].id
        }
      })
    },
    getPrinterLayoutList () {
      var self = this
      var url = '/platform/printerLayoutList'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerLayoutList = response.data.list
          self.printerLayoutList.forEach(function (layout) {
            const obj = {
              trigger_type: 1,
              layout_type: layout.layout_type,
              layout_name: layout.name,
              is_enabled: 1
            }
            if (layout.is_enabled) {
              self.printerLayoutSetting.push(obj)
            }
          })
        }
      })
    },
    getTradeTypeList () {
      var self = this
      var url = '/platform/tradeTypeList?new_version=1'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = []
          var list = response.data.list
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid) {
              var option = {
                name: list[i].name,
                trade_type_id: parseInt(list[i].id, 10),
                is_support: parseInt(list[i].id, 10) === 1 ? 1 : 0,
                is_enable: 0,
                remark: '',
                ein: '',
                check_offline: list[i].check_offline
              }
              if (i === 0) option.is_enable = 1
              if (list[i].meta !== null) {
                option.meta = {
                  use_key: 0,
                  use_offline_key: 0,
                  key: {},
                  group: { online: {}, offline: {} }
                }

                if (list[i].meta.keys) {
                  list[i].meta.keys.forEach(key => {
                    option.meta.key[key] = ''
                    if (key.includes('offline')) option.meta.group.offline[key] = list[i][key]
                    else option.meta.group.online[key] = list[i][key]
                  })
                }

                if (list[i].meta.group) {
                  ['online', 'offline'].forEach(type => {
                    list[i].meta.group[type].forEach(key => {
                      option.meta.group[type][key] = ''
                    })
                  })
                }
              }
              if (list[i].custom_config !== null) {
                option.custom_config = {
                  use_key: 0,
                  key: {}
                }
                list[i].custom_config.keys.forEach(function (key) {
                  option.custom_config.key[key] = ''
                })
              }
              self.tradeInfo.push(option)
              var option2 = {
                label: list[i].name,
                value: parseInt(list[i].type, 10),
                trade_type_id: parseInt(list[i].id, 10)
              }
              self.tradeList.push(option2)
            }
          }
          if (self.$route.name === 'upStore') self.getStoreInfo()
        }
        if (self.$route.name !== 'upStore') self.getPrinterLayoutList()
      })
    },
    getCityAreaList () {
      var self = this
      var url = '/platform/cityAreaList'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.cityAreaList = response.data.list
          for (var i = 0; i < self.cityAreaList.length; i++) {
            var option = {name: self.cityAreaList[i].name, value: self.cityAreaList[i].city_code}
            self.cityOption.push(option)
            if (i === 0) self.citySelect = self.cityAreaList[i].city_code
          }
          // self.groupList = response.data.list
        }
      })
    },
    getShippingVendorList () {
      const url = '/platform/shippingVendorList?type=2&is_visable=1'
      this.getData('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.supportShippingVendorList = response.data.list
          // 新增門市時，使用後端預設值帶入
          if (this.$route.name === 'crStore' && this.getRoleType === 99) {
            this.shippingVendorInfo = response.data.list
              .map(item => {
                let obj = {}
                item.custom_config.forEach(config => {
                  obj[config.attribute] = config.default
                })
                return {
                  vendor_code: item.vendor_code,
                  is_enable: 0,
                  custom_config: obj
                }
              })
          }
        }
      })
    },
    checkDefault (type) {
      for (var i = 0; i < this.deliveryWaysInfo.length; i++) {
        if (this.deliveryWaysInfo[i].take_type !== type) {
          this.deliveryWaysInfo[i].is_default = 0
        }
      }
    },
    checkOtherDelivery () {
      for (var i = 0; i < this.deliveryOther.length; i++) {
        if (i === 0) {
          this.deliveryOther[i].price = this.deliveryWaysInfo[2].price
        }
      }
    },
    checkDelivery () {
      for (var i = 0; i < this.deliveryOther.length; i++) {
        if (i === 0) {
          this.deliveryWaysInfo[2].price = this.deliveryOther[i].price
        }
      }
    },
    getWeekDayName (weekDay) {
      if (weekDay === 1) return '星期日'
      else if (weekDay === 2) return '星期一'
      else if (weekDay === 3) return '星期二'
      else if (weekDay === 4) return '星期三'
      else if (weekDay === 5) return '星期四'
      else if (weekDay === 6) return '星期五'
      else if (weekDay === 7) return '星期六'
    },
    onPhotoFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0], 4) // 底圖照片
      }
    },
    onFileChange (e) {
      this.imgLogoSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0], 1)
      }
    },
    createImage (file, method) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        if (method === 1) {
          self.storeInfo.image = img.src
          self.storeInfo.image_name = img.src
        } else if (method === 4) self.storeInfo.photo_name = img.src
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          self.checkImgSize(null, method)
        }
      }
      reader.readAsDataURL(file)
    },
    checkImgSize (type, method) {
      var self = this
      if ((this.img.width !== 200 || this.img.height !== 200) && this.img.width !== 0 && this.img.height !== 0 && method === 1) {
        this.$notify({
          title: '提醒',
          text: 'LOGO尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if ((this.img.width !== 800 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && method === 3) {
        this.$notify({
          title: '提醒',
          text: '底圖照片寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (type === 'cr') {
        this.createdBrand()
      } else if (type === 'up') {
        if ($('#brand-img-load')[0].files[0]) this.updatedIcon()
        else this.updatedBrand()
      }
    },
    onBgChange (e) {
      this.imgBgSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      let imgSize = Math.round(files[0].size / 1000)
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        // this.createBgImage(files[0])
      }
    },
    createBgImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        if (self.storeInfo.bg_image) self.storeInfo.bg_image = img.src
        self.storeInfo.bg_image_name = img.src
        img.onload = () => {
          self.bgImg.width = img.width
          self.bgImg.height = img.height
          self.checkBgImgSize()
        }
      }
      reader.readAsDataURL(file)
    },
    checkBgImgSize (type) {
      var self = this
      if ((this.bgImg.width !== 625 || this.bgImg.height !== 300) && this.bgImg.width !== 0 && this.bgImg.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.bgImg.width + 'x' + self.bgImg.height + '，請上傳625x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (type === 'cr') {
        // this.createdBrand()
      } else if (type === 'up') {
        // if ($('#brand-img-load')[0].files[0]) this.updatedIcon()
        // else this.updatedBrand()
      }
    },
    getPosBrief () {
      this.posBrief = []
      var self = this
      var url = '/pos/vendorBriefList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var pList = response.data.list
          for (let i = 0; i < pList.length; i++) {
            let obj = {label: pList[i].name, value: pList[i].pos_vendor_id}
            self.posBrief.push(obj)
            if (i === pList.length - 1) {
              self.posSelect = pList[i].pos_vendor_id
            }
          }
        }
      })
    },
    getStoreBrief () {
      this.storeBrief = []
      const url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?list_sort=name ASC'
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          if (this.getRoleType === 99 && this.info) this.getPrinterStoreList()
          const sList = res.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            this.storeBrief.push(obj)
            if (i === 0) this.copyStoreSelect = sList[i].store_id
          }
          this.$store.commit('SET_BRAND_ID', Number(this.$route.params.brand_id))
          this.$store.commit('SET_STORE_ID', Number(this.$route.params.store_id))
          this.$store.commit('SET_STORES', res.data.list)
          this.urlRedirection.stores = res.data.list
        }
      })
    },
    verityPos () {
      if (this.posList.filter(x => x.account === '' || x.password === '').length > 0) {
        return false
      }
      return true
    },
    verityTel () {
      var e = $(this.$refs.tel)
      this.storeInfo.tel = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9-#()\s]*/))
      }
    },
    verityTel2 () {
      var e = $(this.$refs.tel2)
      this.storeInfo.tel2 = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9-#()\s]*/))
      }
    },
    verityEin () {
      var e = $(this.$refs.ein)
      this.storeInfo.ein = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    // 金流帳戶統一編號僅可輸入數字
    verityTradeEin (index) {
      this.reload = true
      let ein = this.tradeInfo[index].ein || ''
      this.$set(this.tradeInfo[index], 'ein', ein.replace(/\D/g, ''))
    },
    /**
     * 線上/線下 key 是否有填寫 (以本次送出的狀態為準)
     * 本次有輸入內容即為已填寫；原本已設定且未點編輯/未移除也算已填寫
     * 點過編輯或移除但內容全空 (送出後為移除先前設定) 視為未填寫
     */
    isTradeMetaKeyFilled (trade) {
      if (!trade.meta) return false
      return ['online', 'offline'].some(lineType => {
        let useKey = lineType === 'online' ? 'use_key' : 'use_offline_key'
        let deleteKey = lineType === 'online' ? 'delete_key' : 'delete_offline_key'
        let group = (trade.meta.group && trade.meta.group[lineType]) || {}
        if (Object.keys(group).some(name => !!group[name])) return true
        return parseInt(trade.meta[useKey], 10) === 1 && !parseInt(trade.meta[deleteKey], 10)
      })
    },
    /**
     * 該付款方式的金流三個欄位 (線上 key、線下 key、金流帳戶統一編號) 是否任一有填寫
     */
    isTradeEinFieldFilled (trade) {
      // 金流帳戶統一編號有填寫
      if (trade.ein) return true
      // 線上/線下 key 有填寫
      if (this.isTradeMetaKeyFilled(trade)) return true
      // custom_config 型金流 (如 LINE Pay、信用卡付款(TAPPAY)) 的 key 有填寫
      let customKey = (trade.custom_config && trade.custom_config.key) || {}
      return Object.keys(customKey).some(name => !!customKey[name])
    },
    /**
     * 需檢核金流帳戶統一編號的付款方式
     * 條件：該付款方式有金流帳戶 (現金付款無 meta/custom_config 不檢核)
     *      且三個欄位 (線上 key、線下 key、金流帳戶統一編號) 任一有填寫
     * 三個欄位皆未填寫 (含本次全部清空) 者不檢核，不限「支援與否」與「開啟狀態」
     */
    getEinCheckTradeList () {
      return this.tradeInfo.filter(trade => {
        if (!trade.meta && !trade.custom_config) return false
        return this.isTradeEinFieldFilled(trade)
      })
    },
    /**
     * custom_config 型金流 (如 LINE Pay、信用卡付款(TAPPAY)) 的 key 內容
     * 此類金流輸入 key 不會變更 use_key，需直接比對 key 內容才能判斷是否重新設定
     * 空值統一正規化為空字串 (載入為 null、清空後為 '')，避免輸入後又刪除被誤判為修改
     */
    getTradeCustomKeyState (trade) {
      if (!trade.custom_config) return ''
      let key = trade.custom_config.key || {}
      let state = {}
      Object.keys(key).sort().forEach(name => {
        state[name] = key[name] || ''
      })
      return JSON.stringify(state)
    },
    /**
     * 記錄付款方式的原始金流帳戶統一編號與金流 key 設定狀態 (判斷送出時是否有修改)
     */
    snapshotTradeEin () {
      let origin = {}
      this.tradeInfo.forEach(trade => {
        origin[trade.trade_type_id] = {
          ein: trade.ein || '',
          use_key: trade.meta ? parseInt(trade.meta.use_key, 10) || 0 : 0,
          use_offline_key: trade.meta ? parseInt(trade.meta.use_offline_key, 10) || 0 : 0,
          custom_key: this.getTradeCustomKeyState(trade)
        }
      })
      this.originTradeEin = origin
    },
    /**
     * 線上/線下 key 本次是否有修改 (原始值與送出值比對)
     * use_key 為 2 僅代表點過編輯或輸入框有異動，需再看實際送出的內容才算修改：
     * 有填值 = 設定新 key；全部清空 = 移除先前設定 (原本未設定則等於沒異動)
     */
    isTradeMetaKeyChanged (trade, origin) {
      if (!trade.meta) return false
      return ['online', 'offline'].some(lineType => {
        let useKey = lineType === 'online' ? 'use_key' : 'use_offline_key'
        if (parseInt(trade.meta[useKey], 10) !== 2) return false
        let group = (trade.meta.group && trade.meta.group[lineType]) || {}
        let isEmpty = Object.keys(group).every(name => !group[name])
        return !isEmpty || parseInt(origin[useKey], 10) === 1
      })
    },
    /**
     * 該付款方式本次是否有修改統一編號或金流 key (原始值與送出值比對)
     * 僅檢核統一編號與線上/線下 key，「支援與否」「開啟狀態」「備註」變更皆不視為修改
     */
    isTradeEinChanged (trade) {
      // 找不到原始資料視為原始未填值/未設定
      let origin = this.originTradeEin[trade.trade_type_id] || {}
      // 金流帳戶統一編號有修改
      if ((origin.ein || '') !== (trade.ein || '')) return true
      // 線上/線下 key 有修改
      if (this.isTradeMetaKeyChanged(trade, origin)) return true
      // custom_config 型金流的 key 有修改
      return (origin.custom_key || '') !== this.getTradeCustomKeyState(trade)
    },
    /**
     * 檢查是否需彈出統一編號不一致提醒
     * @param method 目前所在的 tab (storeMethod)
     * @param type cr: 新增 up: 編輯/更新
     */
    needEinConfirm (method, type) {
      // 僅 admin 觸發
      if (this.getRoleType !== 99) return false
      // 非儲存動作不檢核 (新增流程切換上一步/下一步時 type 為 undefined)
      if (type !== 'cr' && type !== 'up') return false
      // 已確認過不一致仍要儲存
      if (this.einConfirmed) {
        this.einConfirmed = false
        return false
      }
      // 新增門市：最後一步建立時才檢核；更新：僅「基本資訊」與「付款方式」兩個 tab
      if (type === 'up' && method !== 1 && method !== 4) return false
      // 更新「基本資訊」時，僅在統一編號有變更 (含無→有、有→無) 才檢核
      if (type === 'up' && method === 1 && (this.storeInfo.ein || '') === (this.originEin || '')) return false

      let storeEin = this.storeInfo.ein || ''
      // 金流帳戶統一編號與門市統一編號不同即提醒 (含單邊未填值；雙方皆未填值視為一致)
      // 三個欄位皆未填寫的付款方式已由 getEinCheckTradeList 排除，故全部清空時不會提醒
      let diffList = this.getEinCheckTradeList().filter(trade => (trade.ein || '') !== storeEin)
      // 更新「付款方式」時，只列出本次有修改統一編號或金流 key 的付款方式，未變更的不顯示
      if (type === 'up' && method === 4) diffList = diffList.filter(trade => this.isTradeEinChanged(trade))
      if (!diffList.length) return false

      this.einCheckStoreEin = storeEin
      this.einCheckList = diffList.map(trade => ({ name: trade.name, ein: trade.ein || '' }))
      return true
    },
    verityOneOrderMaxMoney () {
      var e = $(this.$refs.oneOrderMaxMoney)
      this.storeInfo.one_order_max_money = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityStorePayMaxMoney () {
      var e = $(this.$refs.storePayMaxMoney)
      this.storeInfo.to_store_pay_max_money = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityRejectTime () {
      var e = $(this.$refs.rejectTime)
      this.storeInfo.auto_reject_order_m = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityStartTime () {
      var e = $(this.$refs.startTime)
      this.storeInfo.order_start_time_m = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityEndTime () {
      var e = $(this.$refs.endTime)
      this.storeInfo.order_end_time_m = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityFoodBusinessNo () {
      const pattern = /^[A-Z]{1}-[1-2]{1}\d{8}-\d{5}-\d{1}$/
      let temp = false
      if (this.storeInfo.food_business_no && !pattern.test(this.storeInfo.food_business_no)) {
        temp = false
      } else {
        temp = true
      }
      return temp
    },
    isPureNumber (val) {
      return /^\d+$/.test(val)
    },
    /**
     * 送出前檢查欄位
     * @param type cr: 新增 up: 編輯/更新
     */
    async checkBeforeSend (type) {
      let all = this.getInput
      let title = '提醒'
      let msg = ''
      let prepareTimeError = false
      let processTimeListError = false
      let checkMondayError = false
      let checkDeliveryExceptionProductList = false

      let deliveryExceptionList = this.deliveryExceptionProductList.filter(item => item.vendor_custom_id === '' || item.product_name === '')
      if (deliveryExceptionList.length > 0) {
        checkDeliveryExceptionProductList = true
      }
      for (var cal = 0; cal < this.exceptionCalendar.length; cal++) {
        for (var monthDay = 0; monthDay < this.exceptionCalendar[cal].month_day.length; monthDay++) {
          var r = this.exceptionCalendar[cal].month_day[monthDay].day
          if (!this.isPureNumber(r)) {
            checkMondayError = true
          }
          if (this.exceptionCalendar[cal].month_day[monthDay].day < 1 || this.exceptionCalendar[cal].month_day[monthDay].day > 31) {
            // 月份日期不可小於 1 或大於 31
            checkMondayError = true
          }
        }
      }

      for (var i = 0; i < this.takeTimeInfo.length; i++) {
        if (!this.takeTimeInfo[i].prepare_time_seg.toString()) {
          if (this.takeTimeInfo[i].take_type !== 3) this.takeTimeInfo[i].prepare_time_seg = 15
          else this.takeTimeInfo[i].prepare_time_seg = 30
        } else if (this.takeTimeInfo[i].prepare_time_seg < 3) {
          // 準備時間不可低於 3 分鐘
          prepareTimeError = true
        }
        if (!this.takeTimeInfo[i].take_time_seg.toString()) this.takeTimeInfo[i].take_time_seg = 0
      }
      // 時段製作時間未填寫完整 Error 判斷
      processTimeListError = this.processTimeList.some(item => {
        return (typeof item.month !== 'object') || (typeof item.delivery_type !== 'object')
      })
      for (var j = 0; j < this.deliveryWaysInfo.length; j++) {
        if (!this.deliveryWaysInfo[j].distance_m.toString()) this.deliveryWaysInfo[j].distance_m = 0
        if (!this.deliveryWaysInfo[j].price.toString()) this.deliveryWaysInfo[j].price = 0
      }
      for (var k = 0; k < this.deliveryOther.length; k++) {
        if (!this.deliveryOther[k].distance_m.toString()) this.deliveryOther[k].distance_m = 0
        if (!this.deliveryOther[k].price.toString()) this.deliveryOther[k].price = 0
      }
      var method = this.storeMethod
      var isUp = this.info

      if (!all.name && ((method === 1 && isUp) || !isUp)) {
        msg = '請輸入店家名稱'
        this.storeMethod = 1
      } else if (!all.name_short && ((method === 1 && isUp) || !isUp)) {
        msg = '請輸入店家縮寫'
        this.storeMethod = 1
      } else if (!all.address_short && ((method === 1 && isUp) || !isUp)) {
        msg = '請輸入地址'
        this.storeMethod = 1
      } else if (this.storeInfo.membership_provider_parent_id < 0 && method === 3 && this.membershipGroupType === 2) {
        msg = '請選擇是否開通會員卡。'
        this.storeMethod = 2
      } else if (!all.order_start_day && ((method === 3 && isUp) || !isUp)) {
        msg = '請輸入預訂開始日'
        this.storeMethod = 3
      } else if (!all.order_tolerance_day && ((method === 3 && isUp) || !isUp)) {
        msg = '請輸入預訂結束日'
        this.storeMethod = 3
      } else if (!all.auto_reject_order_reserve_m && ((method === 3 && isUp) || !isUp)) {
        msg = '請輸入自動拒絕預約單時間'
        this.storeMethod = 3
      } else if (!all.plastic_unit && ((method === 8 && isUp) || !isUp)) {
        msg = '請輸入塑膠袋單位'
        this.storeMethod = 8
      } else if (!all.address_short && ((method === 1 && isUp) || !isUp)) {
        msg = '請輸入地址'
        this.storeMethod = 1
      } else if (!all.tel && ((method === 1 && isUp) || !isUp)) {
        msg = '請至少輸入一筆電話'
        this.storeMethod = 1
      } else if (!all.custom_sticker_max_length && ((method === 2 && isUp) || !isUp)) {
        msg = '請輸入單筆訂單最高上限之金額'
        this.storeMethod = 2
      } else if (!all.one_order_max_money && ((method === 2 && isUp) || !isUp)) {
        msg = '請輸入單筆訂單最高上限之金額'
        this.storeMethod = 2
      } else if (!all.auto_reject_order_m && ((method === 3 && isUp) || !isUp)) {
        msg = '請輸入自動拒單時間'
        this.storeMethod = 3
      } else if (parseInt(all.auto_reject_order_m, 10) > 1440 && ((method === 3 && isUp) || !isUp)) {
        msg = '自動拒單時間須小於或等於1440分鐘'
        this.storeMethod = 3
      } else if (!all.order_start_time_m && ((method === 3 && isUp) || !isUp)) {
        msg = '請輸入距營業時間方可訂購之時間'
        this.storeMethod = 3
      } else if (parseInt(all.order_start_time_m, 10) > 1440 && ((method === 3 && isUp) || !isUp)) {
        msg = '距營業時間方可訂購之時間須小於或等於1440分鐘'
        this.storeMethod = 3
      } else if (!all.order_end_time_m && ((method === 3 && isUp) || !isUp)) {
        msg = '請輸入距打烊時間為最後訂購之時間'
        this.storeMethod = 3
      } else if (parseInt(all.order_end_time_m, 10) > 1440 && ((method === 3 && isUp) || !isUp)) {
        msg = '距打烊時間為最後訂購之時間須小於或等於1440分鐘'
        this.storeMethod = 3
      } else if ((method === 5 || !isUp) && prepareTimeError) {
        msg = '準備時間不可低於 3 分鐘'
        this.storeMethod = 5
      } else if ((method === 5 || !isUp) && processTimeListError) {
        msg = '請填好完整時段製作時間'
        this.storeMethod = 5
      } else if (method === 6 && checkDeliveryExceptionProductList) {
        msg = '商品名稱或料號不得為空值'
        this.storeMethod = 6
      } else if ((method === 6 || !isUp) && checkMondayError) {
        msg = '每月幾號不可填入小於 1 或大於 31 的數字'
        this.storeMethod = 6
      } else if ((method === 12 || !isUp) && this.checkCommission() !== false) {
        msg = this.checkCommission()
        this.storeMethod = 12
      } else if (this.isPosAccount === 1 && method === 2) {
        if (this.posList.length < 1) {
          msg = '請至少新增一個帳號'
          this.storeMethod = 2
        }
        if (!this.verityPos()) {
          msg = '請填好完整POS資訊'
          this.storeMethod = 2
        }
        if (this.repeatPosAccountList.length > 0 || this.posList.filter((x) => !x.vaildSingleAccount).length > 0) {
          msg = 'POS帳號不能重複'
          this.storeMethod = 2
        }
      } else if (method === 2 && this.copyInfo.menuStore && !this.copyInfo.menuStoreId) {
        msg = '請選擇複製店家的菜單'
        this.storeMethod = 2
      } else if (method === 2 && this.copyInfo.productAlias && !this.copyInfo.productAliasStoreId) {
        msg = '請選擇複製店家的別名/描述/警語'
        this.storeMethod = 2
      } else if (method === 2 && this.copyInfo.productImage && !this.copyInfo.productImageStoreId) {
        msg = '請選擇複製店家的圖片庫'
        this.storeMethod = 2
      } else if (method === 1 && !this.verityFoodBusinessNo()) {
        title = '食品業者登錄字號格式錯誤'
        msg = '請輸入格式正確的 19 碼字串，需包含英文、數字與「-」'
        this.storeMethod = 1
      }

      this.tradeInfo.forEach(payment => {
        if (!payment.meta) return

        ['online', 'offline'].forEach(lineType => {
          if (msg) return

          let keys = Object.keys(payment.meta.group[lineType])
          let emptyKeys = []

          keys.forEach(key => {
            let value = payment.meta.group[lineType][key]
            if (!value) emptyKeys.push(key)
          })

          if (!emptyKeys.length || emptyKeys.length === keys.length) return

          msg = `請輸入 ${emptyKeys[0]}`
          this.storeMethod = 4
        })
      })

      // 金流帳戶統一編號與門市統一編號核對
      if (!msg && this.needEinConfirm(method, type)) {
        this.einConfirmType = type
        window.$('#einModal').modal('show')
        return
      }

      this.getToast(msg, type, title)
    },
    getToast (msg, type, title = '提醒') {
      if (msg) {
        this.$notify({
          title: title,
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.createdStore()
        else if (type === 'up' && this.storeMethod === 1) this.updatedLogoImg()
        else if (type === 'up') this.updatedStore()
      }
    },
    getBrandInfo () {
      // 取得品牌每月可作廢的訂單額度
      const url = '/brand/' + this.$route.params.brand_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.brandInvalidQuota = response.data.brand_info.order_commission_setting.allow_invalid_order_quota
        }
      })
    },
    getBrandImgList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list
          for (var i = 0; i < logoList.length; i++) {
            var option = {name: logoList[i].image_name, value: logoList[i].image_url}
            self.imgLogoOption.push(option)
          }
        }
      })
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3'
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list
          for (var j = 0; j < bgList.length; j++) {
            var option2 = {name: bgList[j].image_name, value: bgList[j].image_url}
            self.imgBgOption.push(option2)
          }
        }
      })
    },
    async createdStore () {
      const self = this
      const sInfo = this.storeInfo
      var info = this.getInput
      // 新增門市前先驗證運費設定
      let shippingComponent = this.$refs.shippingInfo
      if (shippingComponent && shippingComponent.feeTypeSelect !== null) {
        try {
          await shippingComponent.checkShipping(info.max_delivery_distance_m)
        } catch (e) {
          return
        }
      }
      this.loading = true
      var data = new FormData()
      var brandId = parseInt(this.$route.params.brand_id, 10)
      var name = info.name
      var addressShort = info.address_short
      var tel = info.tel
      var oneOrderMaxMoney = parseInt(info.one_order_max_money, 10)
      var toStorePayMaxMoney = parseInt(info.to_store_pay_max_money, 10)
      var orderStartTimeM = info.order_start_time_m
      var orderEndTimeM = info.order_end_time_m
      var autoRejectOrderM = info.auto_reject_order_m
      var orderStartDay = info.order_start_day
      var orderToleranceDay = info.order_tolerance_day
      var autoRejectOrderReserveM = info.auto_reject_order_reserve_m
      var plasticUnit = info.plastic_unit
      data.append('brand_id', brandId)
      data.append('store_group_id', parseInt(this.groupSelect, 10))
      data.append('name', name)
      data.append('city_code', parseInt(this.citySelect, 10))
      data.append('area_code', parseInt(this.areaSelect, 10))
      data.append('address_short', addressShort)
      data.append('tel', tel)
      data.append('store_type', parseInt(this.storeTypeSelect, 10))
      data.append('status', parseInt(this.statusSelect, 10))
      data.append('order_status', parseInt(this.orderStatusSelect, 10))
      data.append('is_visible', parseInt(this.isVisibleSelect, 10))
      data.append('barcode_type', parseInt(this.barcodeSelect, 10))
      data.append('one_order_max_money', oneOrderMaxMoney)
      data.append('to_store_pay_max_money', toStorePayMaxMoney)
      data.append('order_start_time_m', orderStartTimeM)
      data.append('order_end_time_m', orderEndTimeM)
      data.append('has_invoice_paper', this.hasInvoicePaperSelect)
      data.append('has_invoice_carrier', this.hasInvoiceCarrierSelect)
      data.append('has_invoice_npoban', this.hasInvoiceNpobnaSelect)
      data.append('is_invoice_exception', this.isInvoiceException)
      data.append('invoice_remark', this.invoiceRemark)
      data.append('auto_reject_order_m', autoRejectOrderM)
      data.append('is_search', self.isSearchSelect)
      // 2018-01-15 新增
      data.append('api_type', parseInt(this.apiTypeSelect, 10))
      data.append('order_start_day', orderStartDay)
      data.append('order_tolerance_day', orderToleranceDay)
      data.append('auto_reject_order_reserve_m', autoRejectOrderReserveM)
      data.append('plastic_unit', plasticUnit)
      data.append('plastic_option', parseInt(this.plasticSelect, 10))
      data.append('delivery_need_plastic', parseInt(this.deliveryNeedSelect, 10))
      data.append('show_menu_icon', parseInt(this.showMenuIconSelect, 10))
      // 2019-02-26 新增
      data.append('is_off_allow_order', sInfo.is_off_allow_order)
      data.append('is_preparing_allow_order', sInfo.is_preparing_allow_order)
      data.append('is_close_allow_order', sInfo.is_close_allow_order)
      data.append('show_menu_product_icon', sInfo.show_menu_product_icon)
      data.append('menu_layout_type', sInfo.menu_layout_type)
      // 2019-04-26 新增
      data.append('rounding_type', self.roundingTypeSelect)
      data.append('coupon_form', self.couponFormSelect)
      // 2019-05-06 新增
      data.append('menu_expand_type', sInfo.menu_expand_type)
      // 2019-05-14 新增
      data.append('order_status_reason', sInfo.order_status_reason)
      // 2019-06-12 新增
      data.append('menu_stop_sale_type', sInfo.menu_stop_sale_type)
      // 2023-11-22 新增
      data.append('menu_stop_sale_today_type', sInfo.menu_stop_sale_today_type)
      // 菜單0元顯示
      data.append('show_menu_zero_money', sInfo.show_menu_zero_money)
      // 開通門市會員卡
      if (sInfo.membership_provider_parent_id && this.membershipGroupType === 2) {
        data.append('membership_provider_parent_id', sInfo.membership_provider_parent_id)
      }
      // 2019-07-18 新增
      data.append('distance_service_model', self.disModeSelect)
      // 2019-07-25 新增
      data.append('is_support_custom_sticker', self.isStickerSelect)
      // 2020-04-21
      if (info.introduction) data.append('introduction', info.introduction)
      if (info.youtube_video_code) data.append('youtube_video_code', info.youtube_video_code)
      // 2020-04-28
      const ids = sInfo.binding_meal_tag_ids.map(item => item.value)
      if (sInfo.binding_meal_tag_ids.length) data.append('binding_meal_tag_ids', JSON.stringify(ids))
      data.append('delivery_stage_limit_type', sInfo.delivery_stage_limit_type)
      // 2020-05-14
      data.append('show_product_setting', this.showProdSettingSelect)

      // 2022-08-15，複製店家的菜單、別名、描述/警語、圖片庫
      if (this.copyInfo.menuStore && this.copyInfo.menuStoreId) {
        data.append('copy_menu_store_id', this.copyInfo.menuStoreId.value)
      } // 店家菜單
      if (this.copyInfo.productAlias && this.copyInfo.productAliasStoreId) {
        data.append('copy_product_alias_store_id', this.copyInfo.productAliasStoreId.value)
      } // 店家別名
      if (this.copyInfo.productDescription && this.copyInfo.productDescriptionStoreId) {
        data.append('copy_product_description_store_id', this.copyInfo.productDescriptionStoreId.value)
      } // 店家描述/警語
      if (this.copyInfo.productImage && this.copyInfo.productImageStoreId) {
        data.append('copy_product_image_store_id', this.copyInfo.productImageStoreId.value)
      } // 店家圖片庫
      // End 2022-08-15，複製店家的菜單、別名、描述/警語、圖片庫

      // 2022-02-06，門市群組功能，門市綁定的門市群組ID列表
      const bindingClassIds = sInfo.binding_class_ids.map(item => item.value)
      if (sInfo.binding_class && sInfo.binding_class_ids.length) data.append('binding_class_ids', JSON.stringify(bindingClassIds))
      // End 2022-02-06，門市群組功能，門市綁定的門市群組ID列表

      // 2023-04-18
      if (typeof sInfo.allow_copy_menu !== 'undefined' && sInfo.allow_copy_menu !== null) data.append('allow_copy_menu', sInfo.allow_copy_menu) // 門市菜單庫是否可被覆蓋 (0)不可、(1)可以
      if (typeof sInfo.allow_update_menu !== 'undefined' && sInfo.allow_update_menu !== null) data.append('allow_update_menu', sInfo.allow_update_menu) // 門市是否可編輯門市菜單庫 (0)不可、(1)可以
      // End 2023-04-18

      // 2023-04-21，新增物流設定
      data.append('store_shipping_vendor', JSON.stringify(this.supportShippingVendor))
      // 新增紅配綠菜單分類顯示
      data.append('menu_expand_type', sInfo.menu_expand_type)

      // 付款方式與取餐金額
      var newETradeList = []
      this.exceptionTradeList.forEach(function (eTrade) {
        var obj = eTrade
        if (!obj.start_money) obj.start_money = null
        if (!obj.end_money) obj.end_money = null
        newETradeList.push(obj)
      })
      if (newETradeList.length) data.append('delivery_exception_trade_setting', JSON.stringify(newETradeList))
      // 店家排除時段設定
      var newECalendarList = {}
      this.exceptionCalendar.forEach(function (eCalendar) {
        var obj = {
          date_type: eCalendar.date_type,
          week_day: eCalendar.week_day,
          month_day: eCalendar.month_day
        }
        newECalendarList[eCalendar.delivery_type] = obj
      })
      data.append('delivery_exception_calendar_setting', JSON.stringify(newECalendarList))
      // 更改某時段製作時間
      var newTimeList = []
      this.processTimeList.forEach(function (item) {
        var process = {
          month: item.month.value,
          value_type: item.value_type,
          start_value: item.start_value.value,
          end_value: item.end_value.value,
          delivery_type: item.delivery_type.value,
          item_list: item.item_list
        }
        newTimeList.push(process)
      })
      if (newTimeList.length) data.append('process_time_setting', JSON.stringify(newTimeList))
      // 塑膠袋預設勾選
      var dWayPlastic = []
      this.deliveryWayPlastic.forEach(function (delivery) {
        dWayPlastic.push(delivery.value)
      })
      if (dWayPlastic.length) data.append('delivery_way_plastic_selected', JSON.stringify(dWayPlastic))
      // 公休
      var offday = {
        date: [],
        week_day: [],
        month_day: []
      }
      this.offdaySetting.date.forEach(function (date) {
        offday.date.push(date.value)
      })
      this.offdaySetting.weekDay.forEach(function (weekDay) {
        offday.week_day.push(weekDay.value)
      })
      this.offdaySetting.monthDay.forEach(function (monthDay) {
        offday.month_day.push(monthDay.value)
      })
      data.append('offday_setting', JSON.stringify(offday))
      // 店家營業時間
      let openingTimes = []
      for (let i = 0; i < this.openingInfo.length; i++) {
        const obj = this.openingInfo[i]
        let openTime = {
          week_day: obj.week_day,
          start_time: obj.start + ':00',
          end_time: obj.end + ':59'
        }
        openingTimes.push(openTime)
      }
      data.append('opening_times', JSON.stringify(openingTimes))
      // 營業時間 - 特殊日期
      if (this.selectSpecialDay.length > 0) {
        let specialTimes = []
        this.selectSpecialDay.forEach(item => {
          const obj = {
            calendar_list: item.calendar_list.map(date => ({usage_type: 1, usage_date: date.value})),
            start_time: item.start_time + ':00',
            end_time: item.end_time + ':59',
            remark: item.remark
          }
          specialTimes.push(obj)
        })
        data.append('order_time_setting', JSON.stringify(specialTimes))
      } else {
        data.append('order_time_setting', '')
      }
      // 店家取餐方式與門檻
      let deliveryWays = []
      let memoList = []
      var isSupport = 1
      var isEnable = 1
      for (let k = 0; k < this.deliveryWaysInfo.length; k++) {
        let option = {
          take_type: parseInt(this.deliveryWaysInfo[k].take_type, 10),
          is_support: parseInt(this.deliveryWaysInfo[k].is_support, 10),
          is_enable: parseInt(this.deliveryWaysInfo[k].is_enable, 10),
          distance_m: parseInt(this.deliveryWaysInfo[k].distance_m, 10),
          price: parseInt(this.deliveryWaysInfo[k].price, 10),
          is_default: parseInt(this.deliveryWaysInfo[k].is_default, 10),
          is_allow_guest_order: parseInt(this.deliveryWaysInfo[k].is_allow_guest_order, 10)
        }
        if (option.take_type === 3) {
          isSupport = parseInt(this.deliveryWaysInfo[k].is_support, 10)
          isEnable = parseInt(this.deliveryWaysInfo[k].is_enable, 10)
        }
        deliveryWays.push(option)
        memoList.push({
          take_type: parseInt(this.deliveryWaysInfo[k].take_type, 10),
          memo: this.deliveryWaysInfo[k].memo || '',
          pickup_memo: this.deliveryWaysInfo[k].pickup_memo || ''
        })
      }
      for (let j = 0; j < this.deliveryOther.length; j++) {
        let option2 = {
          take_type: parseInt(this.deliveryOther[j].take_type, 10),
          is_support: parseInt(this.deliveryOther[j].is_support, 10),
          is_enable: parseInt(this.deliveryOther[j].is_enable, 10),
          distance_m: parseInt(this.deliveryOther[j].distance_m, 10),
          price: parseInt(this.deliveryOther[j].price, 10),
          is_allow_guest_order: parseInt(this.deliveryOther[j].is_allow_guest_order, 10)
        }
        if (option2.take_type === 3) {
          option2.is_support = isSupport
          option2.is_enable = isEnable
        }
        if (this.deliveryOther[j].distance_m && (this.deliveryOther[j].price || j === 0)) {
          deliveryWays.push(option2)
        }
      }
      data.append('delivery_ways', JSON.stringify(deliveryWays))
      data.append('delivery_way_memo', JSON.stringify(memoList))
      // 店家製作與取餐時間
      let takeTimeInfo = []
      for (let k = 0; k < this.takeTimeInfo.length; k++) {
        let option3 = {
          take_type: parseInt(this.takeTimeInfo[k].take_type, 10),
          prepare_time_seg: parseInt(this.takeTimeInfo[k].prepare_time_seg, 10),
          take_time_seg: parseInt(this.takeTimeInfo[k].take_time_seg, 10)
        }
        takeTimeInfo.push(option3)
      }
      data.append('take_time_seg', JSON.stringify(takeTimeInfo))
      // 店家交付方式自訂設定
      let deliveryCustomArr = []
      let tableConfigObj = {
        type: null,
        config: {}
      }
      Object.keys(this.tableNumber).forEach(item => {
        if (item === 'type') {
          tableConfigObj.type = this.tableNumber[item]
        } else {
          tableConfigObj.config[item] = this.tableNumber[item]
        }
      })
      deliveryCustomArr.push(tableConfigObj)
      data.append('delivery_way_custom_config', JSON.stringify(deliveryCustomArr))
      // 店家付款方式
      let tradeInfo = []
      for (let l = 0; l < this.tradeInfo.length; l++) {
        let option4 = {
          trade_type_id: parseInt(this.tradeInfo[l].trade_type_id, 10),
          is_enable: parseInt(this.tradeInfo[l].is_enable, 10),
          is_support: parseInt(this.tradeInfo[l].is_support, 10),
          remark: this.tradeInfo[l].remark
        }
        // 金流帳戶統一編號 (admin only)
        if (this.getRoleType === 99 && (this.tradeInfo[l].meta || this.tradeInfo[l].custom_config)) {
          // 空值需傳 null 清空，傳空字串後端會回統一編號格式錯誤
          option4.ein = this.tradeInfo[l].ein || null
        }
        // 建立憑證
        if (this.tradeInfo[l].meta) {
          option4.meta = JSON.parse(JSON.stringify(this.tradeInfo[l].meta))
          delete option4.meta.key

          let lineTypes = ['online', 'offline']
          lineTypes.forEach(type => {
            let useKey = type === 'online' ? 'use_key' : 'use_offline_key'
            let deleteKey = type === 'online' ? 'delete_key' : 'delete_offline_key'
            let keys = Object.keys(option4.meta.group[type])
            let isEmpty = keys.every(key => !option4.meta.group[type][key])

            if (option4.meta[useKey] === 2) { // 表示編輯過
              option4.meta[useKey] = 1
              option4.meta[deleteKey] = isEmpty ? 1 : 0
            } else {
              option4.meta[useKey] = 0
              option4.meta[deleteKey] = 0
              delete option4.meta.group[type]
            }
          })

          let isEmptyGroup = !Object.keys(option4.meta.group).length
          if (isEmptyGroup) delete option4.meta
        }

        if (this.tradeInfo[l].custom_config) {
          option4.custom_config = {
            use_key: 0,
            key: this.tradeInfo[l].custom_config.key
          }
          let vIndex = 0
          let sumIndex = 0
          for (let tKey in this.tradeInfo[l].custom_config.key) {
            if (this.tradeInfo[l].custom_config.key[tKey]) vIndex++
            sumIndex++
          }
          if (vIndex === sumIndex) option4.custom_config.use_key = 1
          else delete option4.custom_config
        }
        tradeInfo.push(option4)
      }
      data.append('trade_types', JSON.stringify(tradeInfo))
      var branchCode = info.branch_code
      var posBranchCode = info.pos_branch_code
      var nameShort = info.name_short
      var description = info.description
      var comment = info.comment
      var ein = info.ein
      var blName = info.bl_name
      var tel2 = info.tel2
      var email = info.email
      var searchDescription = info.search_description
      if (info.branch_code) data.append('branch_code', branchCode)
      if (info.pos_branch_code) data.append('pos_branch_code', posBranchCode)
      if (info.name_short) data.append('name_short', nameShort)
      if (info.description) data.append('description', description)
      if (info.comment) data.append('comment', comment)
      if (info.ein) data.append('ein', ein)
      if (info.bl_name) data.append('bl_name', blName)
      if (info.tel2) data.append('tel2', tel2)
      if (info.email) data.append('email', email)
      if (info.search_description) data.append('search_description', searchDescription)
      if (info.address_remark) data.append('address_remark', info.address_remark)
      if (info.max_delivery_distance_m) data.append('max_delivery_distance_m', info.max_delivery_distance_m)
      if (info.shipping_description) data.append('shipping_description', info.shipping_description)
      if (info.is_support_custom_remark) data.append('is_support_custom_remark', info.is_support_custom_remark)
      // icon 圖片
      if (this.storeInfo.image_name.indexOf('http') > -1 && this.imgLogoSelect) data.append('image_name', this.imgLogoSelect)
      else if ($('#brand-img-load')[0].files[0]) {
        data.append('image_file', $('#brand-img-load')[0].files[0])
        var imgPath = $('#brand-img-load')[0].files[0]
        var imgName = imgPath.name.replace(/\.(jpg|gif|png)$/, '')
        data.append('image_name', imgName)
      }

      // 2020-04-21 新增
      if ($('#brand-photo-load')[0].files[0]) {
        data.append('photo_file', $('#brand-photo-load')[0].files[0])
        var imgPath2 = $('#brand-photo-load')[0].files[0]
        var imgName2 = imgPath2.name.replace(/\.(jpg|gif|png)$/, '')
        data.append('photo_name', imgName2)
      }
      // 計費方式設定 2022-08-17 新增

      // 門市訂單收費設定
      const query = this.setCommissionQuery()
      data.append('order_commission_setting', JSON.stringify(query))
      // End 門市訂單收費設定

      // 圖片
      // 複製指定店家所有有效的廣告內容
      if (parseInt(this.isCopy, 10) === 1) data.append('copy_banner_store_id', this.copyStoreSelect)
      // 要複製的廣告類型，未傳參數時預設為所有
      if (parseInt(this.isCopy, 10) === 1) {
        this.copyBannerTypeList.forEach((i) => {
          data.append('copy_banner_type_list[]', i)
        })
      }

      // 2023-03-14 新增
      if (info.custom_sticker_max_length) data.append('custom_sticker_max_length', info.custom_sticker_max_length)
      // 2023-05-31 新增「服務費設定」
      if (sInfo.service_fee_description) data.append('service_fee_description', sInfo.service_fee_description)

      // 2024-04-24 食品業者登錄字號
      if (info.food_business_no) data.append('food_business_no', info.food_business_no)
      // 2024-04-24 肉品產地說明
      if (info.meat_origin_description) data.append('meat_origin_description', info.meat_origin_description)

      // 2024-09-24 塑膠袋數量可自行調整
      data.append('is_plastic_amount_adjustable', self.plasticAmountAdjustable)
      // 運送例外商品設定
      data.append('delivery_exception_product_setting', this.deliveryExceptionProductList)
      // 做到這邊，複製指定店家所有有效的廣告內容還沒做
      if (data) {
        const url = '/store'
        this.getDataH('post', url, data, async (response) => {
          if (response.data.status === 200) {
            this.loading = false
            this.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            if (!response.data.has_latlng) {
              this.$notify({
                title: '提醒',
                text: '經緯度未設定，請再檢查地址是否正確！',
                duration: 3000,
                type: 'warning',
                width: 400
              })
            }
            // 新增門市成功後，送出運費設定 (因為運費設定需要 store_id)
            if (shippingComponent && shippingComponent.feeTypeSelect !== null && response.data.new_store_id) {
              try {
                await shippingComponent.upShippingFee(response.data.new_store_id)
              } catch (e) {}
            }
            if (parseInt(this.isPosAccount, 10) === 1) {
              this.updatePosAccount(response.data.new_store_id)
            }
            if (this.leave) {
              // 前往品牌設定
              this.$router.push({ path: '/upBrand/' + this.$route.params.brand_id + '?tab=2' })
            } else {
              this.$router.push({ path: '/storeTable/' + this.$route.params.brand_id })
            }
          }
        }, (error) => {
          this.$notify({
            title: error.response.data.message,
            text: error.response.data.description,
            duration: 3000,
            type: 'danger',
            width: 400
          })
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    updatedLogoImg () {
      var data = new FormData()
      // icon 圖片
      if (this.imgLogoSelect) {
        data.append('image_name', this.imgLogoSelect)
        this.upImg(data, 1)
      } else if ($('#brand-img-load')[0].files[0]) {
        data.append('image_file', $('#brand-img-load')[0].files[0])
        var imgPath = $('#brand-img-load')[0].files[0]
        var imgName = imgPath.name.replace(/\.(jpg|gif|png)$/, '')
        data.append('image_name', imgName)
        this.upImg(data, 1)
      }
      if ($('#brand-photo-load')[0].files[0]) {
        data.append('image_file', $('#brand-photo-load')[0].files[0])
        var imgPath2 = $('#brand-photo-load')[0].files[0]
        var imgName2 = imgPath2.name.replace(/\.(jpg|gif|png)$/, '')
        data.append('image_name', imgName2)
        this.upImg(data, 4)
      }
      this.updatedStore()
    },
    upImg (data, type) {
      var self = this
      data.append('image_type', type)
      var url = '/store/' + this.$route.params.store_id + '/image'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            if (self.getRoleType === 99) self.updatedStore()
            else {
              self.$notify({
                title: response.data.message,
                text: response.data.description,
                duration: 3000,
                type: 'success',
                width: 400
              })
            }
          }
        })
      }
    },
    updatedBgImg () {
      var self = this
      var data = new FormData()
      //  圖片
      if (self.imgBgSelect) {
        data.append('image_name', self.imgBgSelect)
        self.upImg(data, 3)
      } else if ($('#bg-img-load')[0].files[0]) {
        data.append('image_file', $('#bg-img-load')[0].files[0])
        var bgPath = $('#bg-img-load')[0].files[0]
        var bgName = bgPath.name.replace(/\.(jpg|gif|png)$/, '')
        data.append('bg_image_name', bgName)
        self.upImg(data, 3)
      } else if (self.getRoleType === 99) self.updatedStore()
    },
    repeatPosAccount (account) {
      if (this.repeatPosAccountList.filter(x => x.account === account).length > 0) {
        return true
      }
      return false
    },
    async updatedStore () {
      var self = this
      var info = this.getInput
      var name = info.name
      var addressShort = info.address_short
      var tel = info.tel
      var oneOrderMaxMoney = parseInt(info.one_order_max_money, 10)
      var toStorePayMaxMoney = parseInt(info.to_store_pay_max_money, 10)
      var orderStartTimeM = info.order_start_time_m
      var orderEndTimeM = info.order_end_time_m
      var autoRejectOrderM = info.auto_reject_order_m
      var orderStartDay = info.order_start_day
      var orderToleranceDay = info.order_tolerance_day
      var autoRejectOrderReserveM = info.auto_reject_order_reserve_m
      var plasticUnit = info.plastic_unit
      var sInfo = this.storeInfo
      var method = this.storeMethod
      var data = {}
      if (method === 1) {
        data = {
          name: name,
          city_code: this.citySelect,
          area_code: this.areaSelect,
          address_short: addressShort,
          tel: tel,
          youtube_video_code: info.youtube_video_code,
          introduction: info.introduction
        }
        var branchCode = info.branch_code
        var posBranchCode = info.pos_branch_code
        var nameShort = info.name_short
        var description = info.description
        var comment = info.comment
        var ein = info.ein
        var blName = info.bl_name
        var tel2 = info.tel2
        var email = info.email
        var searchDescription = info.search_description
        if (info.branch_code) data.branch_code = branchCode
        if (info.pos_branch_code) data.pos_branch_code = posBranchCode
        if (info.name_short) data.name_short = nameShort
        if (info.description) data.description = description
        if (info.comment) data.comment = comment
        else data.comment = null
        if (info.ein) data.ein = ein
        else data.ein = null
        data.bl_name = blName
        if (info.tel2) data.tel2 = tel2
        data.email = email
        if (info.search_description) data.search_description = searchDescription
        if (info.address_remark || info.address_remark === '') data.address_remark = info.address_remark
        if (info.shipping_description) data.shipping_description = info.shipping_description
        const ids = this.storeInfo.binding_meal_tag_ids.map(item => item.value)
        if (ids) data.binding_meal_tag_ids = ids

        // 食品業者登錄字號
        if (info.food_business_no) data.food_business_no = info.food_business_no
        else data.food_business_no = null // 因為有格式驗證，傳遞空字串會出錯，要傳遞 null 清空資料

        // 肉品產地說明
        if (info.meat_origin_description) data.meat_origin_description = info.meat_origin_description
        else data.meat_origin_description = '' // 清空資料
      } else if (method === 2) {
        data = {
          store_type: parseInt(this.storeTypeSelect, 10),
          status: this.statusSelect,
          is_visible: this.isVisibleSelect,
          barcode_type: this.barcodeSelect,
          one_order_max_money: oneOrderMaxMoney,
          to_store_pay_max_money: toStorePayMaxMoney,
          has_invoice_paper: this.hasInvoicePaperSelect,
          has_invoice_carrier: this.hasInvoiceCarrierSelect,
          invoice_remark: this.invoiceRemark,
          has_invoice_npoban: this.hasInvoiceNpobnaSelect,
          is_invoice_exception: this.isInvoiceException,
          api_type: this.apiTypeSelect,
          show_menu_icon: this.showMenuIconSelect,
          show_menu_product_icon: sInfo.show_menu_product_icon,
          menu_layout_type: sInfo.menu_layout_type,
          rounding_type: self.roundingTypeSelect,
          coupon_form: self.couponFormSelect,
          menu_expand_type: sInfo.menu_expand_type,
          is_search: self.isSearchSelect,
          // 2019-06-12 新增
          menu_stop_sale_type: sInfo.menu_stop_sale_type,
          // 2023-11-22
          menu_stop_sale_today_type: sInfo.menu_stop_sale_today_type,
          // 菜單0元顯示
          show_menu_zero_money: sInfo.show_menu_zero_money,
          // 2019-07-18 新增
          distance_service_model: self.disModeSelect,
          is_support_custom_sticker: self.isStickerSelect,
          // 2020-04-28 新增
          delivery_stage_limit_type: sInfo.delivery_stage_limit_type,
          // 2020-04-28 新增
          show_product_setting: self.showProdSettingSelect,
          is_support_custom_remark: sInfo.is_support_custom_remark,
          // 2023-03-14 新增
          custom_sticker_max_length: sInfo.custom_sticker_max_length,
          // 2023-04-18
          allow_copy_menu: sInfo.allow_copy_menu, // 門市菜單庫是否可被覆蓋 (0)不可、(1)可以
          allow_update_menu: sInfo.allow_update_menu, // 門市是否可編輯門市菜單庫 (0)不可、(1)可以
          // 2023-05-30 新增「網址跳轉設定」
          new_store_id: this.urlRedirection.new_store_id,
          // 紅配綠菜單分類顯示
          menu_ab_block_type: sInfo.menu_ab_block_type
        }
      } else if (method === 3) {
        data = {
          order_status: this.orderStatusSelect,
          order_start_time_m: orderStartTimeM,
          order_end_time_m: orderEndTimeM,
          auto_reject_order_m: autoRejectOrderM,
          order_start_day: orderStartDay,
          order_tolerance_day: orderToleranceDay,
          auto_reject_order_reserve_m: autoRejectOrderReserveM,
          is_preparing_allow_order: sInfo.is_preparing_allow_order,
          is_close_allow_order: sInfo.is_close_allow_order,
          order_status_reason: sInfo.order_status_reason
        }
      } else if (method === 4) {
        // 店家付款方式
        let tradeInfo = []
        for (let l = 0; l < this.tradeInfo.length; l++) {
          let option4 = {
            trade_type_id: parseInt(this.tradeInfo[l].trade_type_id, 10),
            is_enable: parseInt(this.tradeInfo[l].is_enable, 10),
            is_support: parseInt(this.tradeInfo[l].is_support, 10),
            remark: this.tradeInfo[l].remark
          }
          // 金流帳戶統一編號 (admin only)
          if (this.getRoleType === 99 && (this.tradeInfo[l].meta || this.tradeInfo[l].custom_config)) {
            // 空值需傳 null 清空，傳空字串後端會回統一編號格式錯誤
            option4.ein = this.tradeInfo[l].ein || null
          }
          // 建立憑證
          if (this.tradeInfo[l].meta) {
            option4.meta = JSON.parse(JSON.stringify(this.tradeInfo[l].meta))
            delete option4.meta.key

            let lineTypes = ['online', 'offline']
            lineTypes.forEach(type => {
              let useKey = type === 'online' ? 'use_key' : 'use_offline_key'
              let deleteKey = type === 'online' ? 'delete_key' : 'delete_offline_key'
              let keys = Object.keys(option4.meta.group[type])
              let isEmpty = keys.every(key => !option4.meta.group[type][key])

              if (option4.meta[useKey] === 2) { // 表示編輯過
                option4.meta[useKey] = 1
                option4.meta[deleteKey] = isEmpty ? 1 : 0
              } else {
                option4.meta[useKey] = 0
                option4.meta[deleteKey] = 0
                delete option4.meta.group[type]
              }
            })

            let isEmptyGroup = !Object.keys(option4.meta.group).length
            if (isEmptyGroup) delete option4.meta
          }

          if (this.tradeInfo[l].custom_config) {
            option4.custom_config = {
              use_key: 0,
              delete_key: 0,
              key: this.tradeInfo[l].custom_config.key
            }

            let vIndex = 0
            let sumIndex = 0

            for (let cKey in this.tradeInfo[l].custom_config.key) {
              if (this.tradeInfo[l].custom_config.key[cKey]) vIndex++
              else if (this.tradeInfo[l].custom_config.key[cKey] === '') {
                vIndex++
                this.tradeInfo[l].custom_config.key[cKey] = null
              }
              sumIndex++
            }

            if (vIndex === sumIndex) option4.custom_config.use_key = 1
            else if (this.tradeInfo[l].custom_config.delete_key) {
              option4.custom_config.delete_key = 1
              option4.custom_config.use_key = 1
            } else if (this.tradeInfo[l].custom_config.d_use_key) delete option4.custom_config
            else if (!this.tradeInfo[l].custom_config.use_key) delete option4.custom_config
          }
          tradeInfo.push(option4)
        }
        data.trade_types = JSON.stringify(tradeInfo)
        // 現金付款設定
        let customConfig = data.delivery_way_custom_config || []
        customConfig.push({
          type: 21,
          config: {
            is_cash_pay_after_meal: this.tableNumber.is_cash_pay_after_meal
          }
        })
        data.delivery_way_custom_config = JSON.stringify(customConfig)
        // 付款方式與取餐金額
        var newETradeList = []
        this.exceptionTradeList.forEach(function (eTrade) {
          var obj = eTrade
          if (!obj.start_money) obj.start_money = null
          if (!obj.end_money) obj.end_money = null
          newETradeList.push(obj)
        })
        data.delivery_exception_trade_setting = newETradeList
      } else if (method === 5) {
        // 更改某時段製作時間
        var newTimeList = []
        this.processTimeList.forEach(function (item) {
          var process = {
            month: item.month.value,
            value_type: item.value_type,
            start_value: item.start_value.value,
            end_value: item.end_value.value,
            delivery_type: item.delivery_type.value,
            item_list: item.item_list
          }
          newTimeList.push(process)
        })
        if (newTimeList.length) data['process_time_setting'] = JSON.stringify(newTimeList)
        else data['process_time_setting'] = []
        // 店家製作與取餐時間
        let takeTimeInfo = []
        for (let k = 0; k < this.takeTimeInfo.length; k++) {
          let option3 = {
            take_type: parseInt(this.takeTimeInfo[k].take_type, 10),
            prepare_time_seg: parseInt(this.takeTimeInfo[k].prepare_time_seg, 10),
            take_time_seg: parseInt(this.takeTimeInfo[k].take_time_seg, 10)
          }
          takeTimeInfo.push(option3)
        }
        data.take_time_seg = JSON.stringify(takeTimeInfo)
      } else if (method === 6) {
        // 店家取餐方式與門檻
        let deliveryWays = []
        let memoList = []
        var isSupport = 1
        var isEnable = 1

        // 更新運費設定
        let shippingComponent = this.$refs.shippingInfo
        if (shippingComponent) {
          let shippingSetSuccess = false
          await shippingComponent.checkShipping(info.max_delivery_distance_m)
            .then(async () => {
              await shippingComponent.upShippingFee()
              shippingSetSuccess = true
            })
            .catch(() => {
              shippingSetSuccess = false
            })
          if (!shippingSetSuccess) return
        }

        for (let k = 0; k < this.deliveryWaysInfo.length; k++) {
          let option = {
            take_type: parseInt(this.deliveryWaysInfo[k].take_type, 10),
            is_support: parseInt(this.deliveryWaysInfo[k].is_support, 10),
            is_enable: parseInt(this.deliveryWaysInfo[k].is_enable, 10),
            distance_m: parseInt(this.deliveryWaysInfo[k].distance_m, 10),
            price: parseInt(this.deliveryWaysInfo[k].price, 10),
            is_default: parseInt(this.deliveryWaysInfo[k].is_default, 10),
            is_allow_guest_order: parseInt(this.deliveryWaysInfo[k].is_allow_guest_order, 10)
          }
          if (option.take_type === 3) {
            isSupport = parseInt(this.deliveryWaysInfo[k].is_support, 10)
            isEnable = parseInt(this.deliveryWaysInfo[k].is_enable, 10)
          }
          deliveryWays.push(option)
          memoList.push({
            take_type: parseInt(this.deliveryWaysInfo[k].take_type, 10),
            memo: this.deliveryWaysInfo[k].memo || '',
            pickup_memo: this.deliveryWaysInfo[k].pickup_memo || ''
          })
        }
        for (let j = 0; j < this.deliveryOther.length; j++) {
          let option2 = {
            take_type: parseInt(this.deliveryOther[j].take_type, 10),
            is_support: parseInt(this.deliveryOther[j].is_support, 10),
            is_enable: parseInt(this.deliveryOther[j].is_enable, 10),
            distance_m: parseInt(this.deliveryOther[j].distance_m, 10),
            price: parseInt(this.deliveryOther[j].price, 10),
            is_allow_guest_order: parseInt(this.deliveryOther[j].is_allow_guest_order, 10)
          }
          if (option2.take_type === 3) {
            option2.is_support = isSupport
            option2.is_enable = isEnable
          }
          if (this.deliveryOther[j].distance_m && (this.deliveryOther[j].price || j === 0)) {
            deliveryWays.push(option2)
          }
        }
        data.delivery_ways = JSON.stringify(deliveryWays)
        data.delivery_way_memo = JSON.stringify(memoList)
        // 外送最大距離
        if (info.max_delivery_distance_m) data.max_delivery_distance_m = info.max_delivery_distance_m
        else data.max_delivery_distance_m = null
        // 桌號設定
        let customConfig = data.delivery_way_custom_config || []
        customConfig.push({
          type: 21,
          config: {
            default_login_type: this.tableNumber.default_login_type,
            is_table_no_required: this.tableNumber.is_table_no_required,
            is_table_no_editable: this.tableNumber.is_table_no_editable,
            show_table_no: this.tableNumber.show_table_no,
            sub_delivery_type: this.tableNumber.sub_delivery_type
          }
        })
        data.delivery_way_custom_config = JSON.stringify(customConfig)
        // 店家排除時段設定
        var newECalendarList = {}
        this.exceptionCalendar.forEach(function (eCalendar) {
          var obj = {
            date_type: eCalendar.date_type,
            week_day: eCalendar.week_day,
            month_day: eCalendar.month_day
          }
          newECalendarList[eCalendar.delivery_type] = obj
        })
        data.delivery_exception_calendar_setting = newECalendarList
        // 運送例外商品設定
        data.delivery_exception_product_setting = this.deliveryExceptionProductList
      } else if (method === 7) {
        data = {
          is_off_allow_order: sInfo.is_off_allow_order
        }
        // 店家營業時間
        let openingTimes = []
        for (let i = 0; i < this.openingInfo.length; i++) {
          const obj = this.openingInfo[i]
          let openTime = {
            week_day: obj.week_day,
            start_time: obj.start + ':00',
            end_time: obj.end + ':59'
          }
          openingTimes.push(openTime)
        }
        data.opening_times = JSON.stringify(openingTimes)
        // 營業時間 - 特殊日期
        if (this.selectSpecialDay.length > 0) {
          let specialTimes = []
          this.selectSpecialDay.forEach(item => {
            const obj = {
              calendar_list: item.calendar_list.map(date => ({usage_type: 1, usage_date: date.value})),
              start_time: item.start_time + ':00',
              end_time: item.end_time + ':59',
              remark: item.remark
            }
            specialTimes.push(obj)
          })
          data.order_time_setting = JSON.stringify(specialTimes)
        } else {
          data.order_time_setting = ''
        }
        // 公休
        var offday = {
          date: [],
          week_day: [],
          month_day: []
        }
        this.offdaySetting.date.forEach(function (date) {
          offday.date.push(date.value)
        })
        this.offdaySetting.weekDay.forEach(function (weekDay) {
          offday.week_day.push(weekDay.value)
        })
        this.offdaySetting.monthDay.forEach(function (monthDay) {
          offday.month_day.push(monthDay.value)
        })
        data['offday_setting'] = JSON.stringify(offday)
      } else if (method === 8) {
        data = {
          plastic_unit: plasticUnit,
          plastic_option: this.plasticSelect,
          delivery_need_plastic: this.deliveryNeedSelect,
          is_plastic_amount_adjustable: this.plasticAmountAdjustable
        }
        // 塑膠袋預設勾選
        var dWayPlastic = []
        this.deliveryWayPlastic.forEach(function (delivery) {
          if (delivery.value) {
            dWayPlastic.push(delivery.value)
          }
        })
        data['delivery_way_plastic_selected'] = dWayPlastic
      } else if (method === 10) {
        data = {
          printer_layout_setting: []
        }
        this.printerLayoutSetting.forEach(function (layoutSetting) {
          const obj = {
            layout_type: layoutSetting.layout_type,
            trigger_type: layoutSetting.trigger_type,
            is_enabled: layoutSetting.is_enabled
          }
          data.printer_layout_setting.push(obj)
        })
        data.printer_layout_setting = JSON.stringify(data.printer_layout_setting)
      } else if (method === 12) {
        const query = this.setCommissionQuery()
        data['order_commission_setting'] = JSON.stringify(query)
      } else if (method === 13) {
        data = {
          store_shipping_vendor: this.supportShippingVendor
        }
        if (sInfo.shipping_info.mete_store_id) data.pay_party = this.pay_party
      } else if (method === 14) {
        data['service_fee_description'] = sInfo.service_fee_description
      } else if (method === 15) {
        // 特殊需求
        data = {
          store_special_item_setting: []
        }
        const obj = {
          type: 1,
          sub_type: 1,
          is_show: this.showTablewareStrawOption,
          default_value: this.setTablewareStrawDefaultVal
        }
        data.store_special_item_setting.push(obj)
        data.store_special_item_setting = JSON.stringify(data.store_special_item_setting)
      }

      if (method === 2 && parseInt(this.isPosAccount, 10) === 1) {
        this.updatePosAccount(this.$route.params.store_id)
      }
      if (data) {
        const url = '/store/' + this.$route.params.store_id
        const self = this
        this.getDataH('put', url, data, (response) => {
          if (response.data.status === 200) {
            this.$notify({
              title: response.data.message,
              text: '店家資訊更新成功！',
              duration: 1000,
              type: 'success',
              width: 400
            })
            if (!response.data.has_latlng && method === 1 && this.getRoleType === 99) {
              this.$notify({
                title: '提醒',
                text: '經緯度未設定，請再檢查地址是否正確！',
                duration: 1000,
                type: 'warning',
                width: 400
              })
            }
            // 統一編號已儲存，更新原始值避免重複提醒
            if (method === 1) this.originEin = this.storeInfo.ein || ''
            if (method === 4) this.snapshotTradeEin()
            if (this.leave) {
              // 前往品牌設定
              this.$router.push({ path: '/upBrand/' + this.$route.params.brand_id + '?tab=2' })
            } else if (this.reload) {
              window.location.reload()
            }
          }
        }, (error) => {
          const status = (error && error.response && error.response.data && error.response.data.status) || ''
          let title = '更新失敗'
          let text = error.response.data.description || '發生不明錯誤！請聯絡客服或等24小時候再試。'
          if (status === 1799) {
            title = '發票設定錯誤'
            text = '店家已設定開立發票，請至少開放任一發票類型 (紙本發票、電子載具、愛心捐贈發票)'
          } else if ([1738, 1748].includes(status)) {
            text = '店家時間更新失敗！日期／時間格式不符'
          } else if (status === 17024) {
            title = '填寫資料有缺少'
            text = '請將必填欄位填寫完整'
          }
          self.$notify({
            title,
            text,
            duration: 3000,
            type: 'danger',
            width: '570px'
          })
        })
      }
    },
    getStoreInfo () {
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/info'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          let sInfo = response.data.info
          self.storeInfo = {
            allow_copy_menu: sInfo.allow_copy_menu, // 門市菜單庫是否可被覆蓋 (0)不可、(1)可以
            allow_update_menu: sInfo.allow_update_menu, // 門市是否可編輯門市菜單庫 (0)不可、(1)可以
            branch_code: sInfo.branch_code,
            pos_branch_code: sInfo.pos_branch_code,
            name: sInfo.name,
            name_short: sInfo.name_short,
            description: sInfo.description,
            comment: sInfo.comment,
            ein: sInfo.ein,
            bl_name: sInfo.bl_name,
            address_short: sInfo.address,
            tel: sInfo.tel,
            tel2: sInfo.tel2,
            email: sInfo.email,
            one_order_max_money: sInfo.one_order_max_money,
            to_store_pay_max_money: sInfo.to_store_pay_max_money,
            order_start_time_m: sInfo.order_start_time_m,
            order_end_time_m: sInfo.order_end_time_m,
            auto_reject_order_m: sInfo.auto_reject_order_m,
            image_name: sInfo.image,
            bg_image_name: sInfo.bg_image,
            city_code: sInfo.city_code,
            search_description: sInfo.search_description,
            order_start_day: sInfo.order_start_day,
            order_tolerance_day: sInfo.order_tolerance_day,
            auto_reject_order_reserve_m: sInfo.auto_reject_order_reserve_m,
            plastic_unit: sInfo.plastic_unit,
            is_off_allow_order: sInfo.is_off_allow_order,
            is_preparing_allow_order: sInfo.is_preparing_allow_order,
            is_close_allow_order: sInfo.is_close_allow_order,
            show_menu_product_icon: sInfo.show_menu_product_icon,
            menu_ab_block_type: sInfo.menu_ab_block_type,
            menu_layout_type: sInfo.menu_layout_type,
            address_remark: sInfo.address_remark,
            menu_expand_type: sInfo.menu_expand_type,
            max_delivery_distance_m: sInfo.max_delivery_distance_m,
            order_status_reason: sInfo.order_status_reason,
            brand_name: sInfo.brand_name,
            menu_stop_sale_type: sInfo.menu_stop_sale_type,
            menu_stop_sale_today_type: sInfo.menu_stop_sale_today_type,
            show_menu_zero_money: sInfo.show_menu_zero_money,
            photo_name: sInfo.photo,
            youtube_video_code: sInfo.youtube_video_code,
            introduction: sInfo.introduction,
            binding_class: false,
            binding_class_ids: [],
            binding_meal_tag_ids: [],
            delivery_stage_limit_type: sInfo.delivery_stage_limit_type,
            new_store_info: sInfo.new_store_info,
            service_fee_description: sInfo.service_fee_description,
            shipping_info: sInfo.shipping_info,
            food_business_no: sInfo.food_business_no,
            meat_origin_description: sInfo.meat_origin_description
          }
          self.originAddress = {
            city_code: sInfo.city_code,
            area_code: sInfo.area_code,
            address_short: sInfo.address
          }
          self.originEin = sInfo.ein || ''
          self.citySelect = sInfo.city_code
          self.storeInfo.area_code = sInfo.area_code
          self.storeTypeSelect = sInfo.store_type
          self.statusSelect = sInfo.status
          self.barcodeSelect = sInfo.barcode_type
          self.orderStatusSelect = sInfo.order_status
          self.isVisibleSelect = sInfo.is_visible
          self.hasInvoicePaperSelect = sInfo.has_invoice_paper
          self.hasInvoiceCarrierSelect = sInfo.has_invoice_carrier
          self.hasInvoiceNpobnaSelect = sInfo.has_invoice_npoban
          self.invoiceRemark = sInfo.invoice_remark
          self.isInvoiceException = sInfo.is_invoice_exception
          self.apiTypeSelect = sInfo.api_type
          self.showMenuIconSelect = sInfo.show_menu_icon
          self.plasticSelect = sInfo.plastic_option
          self.plasticAmountAdjustable = sInfo.is_plastic_amount_adjustable
          self.deliveryNeedSelect = sInfo.delivery_need_plastic
          self.isSearchSelect = sInfo.is_search
          self.roundingTypeSelect = sInfo.rounding_type
          self.couponFormSelect = sInfo.coupon_form
          self.disModeSelect = sInfo.distance_service_model
          self.isStickerSelect = sInfo.is_support_custom_sticker
          self.showProdSettingSelect = sInfo.show_product_setting
          self.storeInfo.is_support_custom_remark = sInfo.is_support_custom_remark || 0
          self.storeInfo.membership_provider_parent_id = sInfo.membership_provider_parent_id || -1
          self.storeInfo.custom_sticker_max_length = sInfo.custom_sticker_max_length || 0
          self.exceptionTradeList = []
          self.deliveryExceptionProductList = sInfo.delivery_exception_product_info.map(item => {
            return {
              ...item,
              updated: true // 用來標記是否已存於db的資料
            }
          })
          // 物流
          self.shippingVendorInfo = sInfo.shipping_info.store_shipping_vendor
          self.pay_party = sInfo.shipping_info.pay_party
          // 計費方式設定
          if (sInfo.order_commission_setting.item_list && sInfo.order_commission_setting.item_list.length) {
            // 移除秒數
            sInfo.order_commission_setting.item_list.forEach(item => {
              item.start_time = moment(item.start_time).format('YYYY-MM-DD HH:mm')
              item.end_time = moment(item.end_time).format('YYYY-MM-DD HH:mm')
            })
          }
          self.orderCommissionSetting = sInfo.order_commission_setting || {}
          if (sInfo.meal_tag_info) {
            sInfo.meal_tag_info.forEach(function (setting) {
              var obj = {value: setting.tag_id, label: setting.name}
              const hasTag = self.mealTagList.find(function (mealTag) { return mealTag.value === setting.tag_id })
              if (hasTag) {
                self.storeInfo.binding_meal_tag_ids.push(obj)
              }
            })
          }
          if (sInfo.delivery_exception_trade_info) {
            for (var key in sInfo.delivery_exception_trade_info) {
              let value = sInfo.delivery_exception_trade_info[key]
              value.forEach(function (item) {
                var obj = item
                obj.trade_type = parseInt(key, 10)
                self.exceptionTradeList.push(obj)
              })
            }
          }
          self.exceptionCalendar = []
          if (sInfo.delivery_exception_calendar_info) {
            for (var cKey in sInfo.delivery_exception_calendar_info) {
              let cValue = sInfo.delivery_exception_calendar_info[cKey]
              cValue.delivery_type = parseInt(cKey, 10)
              if (cValue.date_type.length || cValue.month_day.length || cValue.week_day.length) self.exceptionCalendar.push(cValue)
            }
          }
          self.processTimeList = []
          if (sInfo.process_time_info) {
            sInfo.process_time_info.forEach(function (item) {
              var process = {
                month: self.offdaySetting.options.month.find(function (month) { return item.month === month.value }),
                value_type: item.value_type,
                delivery_type: self.deliveryTypeOption.find(function (delivery) { return delivery.value === item.delivery_type }),
                item_list: item.item_list
              }
              if (item.value_type === 1) {
                var sObj = {label: item.start_value, value: item.start_value}
                if (sObj.value !== 0) {
                  self.offdaySetting.options.monthDay.push(sObj)
                  process.start_value = sObj
                } else {
                  process.start_value = self.offdaySetting.options.monthDay.find(function (monthDay) { return monthDay.value === 0 })
                }
                var eObj = {label: item.end_value, value: item.end_value}
                if (eObj.value !== 0) {
                  self.offdaySetting.options.monthDay.push(eObj)
                  process.end_value = eObj
                } else {
                  process.end_value = self.offdaySetting.options.monthDay.find(function (monthDay) { return monthDay.value === 0 })
                }
              } else {
                process.start_value = self.offdaySetting.options.weekDay.find(function (monthDay) { return monthDay.value === item.start_value })
                process.end_value = self.offdaySetting.options.weekDay.find(function (monthDay) { return monthDay.value === item.end_value })
              }
              self.processTimeList.push(process)
            })
          }
          // 店家付款方式
          for (let i = 0; i < sInfo.trade_info.length; i++) {
            var option = {
              trade_type_id: sInfo.trade_info[i].trade_type_id,
              is_support: sInfo.trade_info[i].is_support,
              is_enable: sInfo.trade_info[i].is_enable,
              use_key: sInfo.trade_info[i].use_key,
              use_offline_key: sInfo.trade_info[i].use_offline_key,
              custom_config: sInfo.trade_info[i].custom_config,
              remark: sInfo.trade_info[i].remark || '',
              ein: sInfo.trade_info[i].ein || ''
            }

            self.tradeInfo.find(function (o) {
              if (o.trade_type_id === option.trade_type_id) {
                o.is_enable = option.is_enable
                o.is_support = option.is_support
                self.$set(o, 'remark', option.remark)
                self.$set(o, 'ein', option.ein)
                if (o.meta) {
                  o.meta.use_key = option.use_key
                  self.$set(o.meta, 'delete_key', 0)
                  o.meta.use_offline_key = option.use_offline_key
                  self.$set(o.meta, 'delete_offline_key', 0)
                }

                if (o.custom_config) {
                  o.custom_config.use_key = option.use_key
                  self.$set(o.custom_config, 'delete_key', 0)
                  for (let co in o.custom_config.key) {
                    for (let oc in option.custom_config) {
                      if (co === oc) {
                        o.custom_config.key[co] = option.custom_config[oc]
                      }
                    }
                  }
                }
              }
            })
          }
          // 記錄付款方式統一編號原始值，避免未修改時仍提醒不一致
          self.snapshotTradeEin()
          // 製作/取餐時間
          self.takeTimeInfo = []
          sInfo.take_time_info.forEach(function (takeTime) {
            self.takeTimeInfo.push(takeTime)
          })
          // 2019-02-26 新增
          // 塑膠袋預設
          if (sInfo.delivery_way_plastic_selected) {
            sInfo.delivery_way_plastic_selected.forEach(function (delivery) {
              let deliveryMatch = self.deliveryInfo.find(function (info) { return delivery === info.value })
              if (deliveryMatch !== undefined) {
                self.deliveryWayPlastic.push(deliveryMatch)
              }
            })
          }
          // 公休時間
          sInfo.offday_info.date.forEach(date => {
            var ary = date.split('-')
            var formatday = [Number(ary[2]), Number(ary[1]), ary[0]].join('/')
            const oDate = {label: date, value: date}
            self.offdaySetting.date.push(oDate)
            self.offdaySetting.options.date.push(oDate)
            const obj = { 'date': formatday, 'dateTime': false, 'hour': '00', 'minute': '00' }
            self.selectDate.selectedDates.push(obj)
          })
          sInfo.offday_info.month_day.forEach(function (monthDay) {
            const mDay = {label: monthDay, value: monthDay}
            self.offdaySetting.monthDay.push(mDay)
            self.offdaySetting.options.monthDay.push(mDay)
          })
          sInfo.offday_info.week_day.forEach(function (weekDay) {
            self.offdaySetting.weekDay.push(self.offdaySetting.options.weekDay.find(function (wDay) { return weekDay === wDay.value }))
          })
          // 店家取餐門檻
          self.deliveryWaysInfo = []
          self.deliveryOther = []
          let deliveryTimes = 0
          var otherDelivery
          sInfo.delivery_info.forEach(function (delivery) {
            if (delivery.delivery_type === 3) {
              deliveryTimes++
              otherDelivery = sInfo.delivery_info.filter(function (e) {
                return e.delivery_type === 3
              })
            }
            var dOption = {
              take_type: delivery.delivery_type,
              is_support: delivery.is_support,
              is_enable: delivery.is_enable,
              distance_m: delivery.order_min_distance_m,
              price: delivery.order_min_price,
              is_default: delivery.is_default,
              is_allow_guest_order: delivery.is_allow_guest_order,
              memo: '',
              pickup_memo: ''
            }
            if (sInfo.delivery_memo && sInfo.delivery_memo.length) {
              sInfo.delivery_memo.forEach(x => {
                if (x.delivery_type === delivery.delivery_type) {
                  dOption.memo = x.memo
                  dOption.pickup_memo = x.pickup_memo || ''
                }
              })
            }
            if (delivery.delivery_type !== 3 || (delivery.delivery_type === 3 && deliveryTimes === 1)) {
              self.deliveryWaysInfo.push(dOption)
            }
          })
          if (otherDelivery) {
            otherDelivery.splice(0, 1)
            for (let k = 0; k < otherDelivery.length; k++) {
              var oOption = {
                take_type: otherDelivery[k].delivery_type,
                is_support: otherDelivery[k].is_support,
                is_enable: otherDelivery[k].is_enable,
                distance_m: otherDelivery[k].order_min_distance_m,
                price: otherDelivery[k].order_min_price,
                is_allow_guest_order: otherDelivery[k].is_allow_guest_order
              }
              self.deliveryOther.push(oOption)
            }
          }
          // 營業時間
          self.openingInfo = []
          for (var o = 0; o < sInfo.opening_info.length; o++) {
            let startTime = sInfo.opening_info[o].start_time.split(':')
            let endTime = sInfo.opening_info[o].end_time.split(':')
            let wOption = {
              week_day: sInfo.opening_info[o].week_day,
              start: `${startTime[0]}:${startTime[1]}`,
              end: `${endTime[0]}:${endTime[1]}`
            }
            self.openingInfo.push(wOption)
          }
          // 營業時間 - 特殊日期
          sInfo.order_time_setting.forEach(item => {
            const calendarList = item.calendar_list ? item.calendar_list.map(cal => ({
              label: cal.usage_date,
              value: cal.usage_date
            })) : []
            const obj = {
              setting_id: item.setting_id,
              calendar_list: calendarList,
              start_time: item.start_time.substring(0, 5),
              end_time: item.end_time.substring(0, 5),
              remark: item.remark,
              showSpecialDayCalendar: false
            }
            self.selectSpecialDay.push(obj)
          })

          // 出單機layout
          self.printerLayoutSetting = []
          sInfo.printer_layout_info.forEach(function (layout) {
            const obj = layout
            if (!obj.trigger_type) obj.trigger_type = 1
            self.printerLayoutSetting.push(obj)
          })
          // 下單平台 Domain
          self.enterType = []
          sInfo.order_web_domain.forEach(item => {
            self.enterType.push({
              name: self.intranceName(item.type),
              value: item.type,
              url: item.url
            })
          })
          // 店家交付方式自訂設定
          // 桌邊點餐
          const tableInfo = sInfo.delivery_way_custom_config ? sInfo.delivery_way_custom_config[21] ? sInfo.delivery_way_custom_config[21] : {} : {}
          if (tableInfo && Object.keys(tableInfo).length) {
            Object.keys(tableInfo).forEach(key => {
              if (self.tableNumber && typeof self.tableNumber[key] !== 'undefined' && self.tableNumber[key] !== null) {
                self.tableNumber[key] = Number(tableInfo[key].store_value)
              }
            })
          }

          // 特殊需求:新增餐具吸管
          if (sInfo.store_special_item_setting && sInfo.store_special_item_setting.length) {
            let item = sInfo.store_special_item_setting[0]
            self.showTablewareStrawOption = item.is_show
            self.setTablewareStrawDefaultVal = item.default_value
          }

          // End 桌邊點餐

          // 網址跳轉設定
          const temp = {
            store_id: sInfo.new_store_info.id,
            name: sInfo.new_store_info.name
          }
          self.urlRedirection.new_store_info.push(temp)
          // End 網址跳轉設定

          self.$emit('update:store-info', self.storeInfo)
        }
      })
    },
    intranceName (type) {
      switch (type) {
        case 1:
          return '你訂平台'
        case 2:
          return '專屬網址'
        case 3:
          return 'LINE'
      }
    },
    goToStoreTable () {
      this.$router.go(-1)
      // this.$router.push('/storeTable/' + this.$route.params.brand_id)
    },
    getPrinterStoreList () {
      var self = this
      var url = '/printer/storePrinterList/' + this.$route.params.store_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerStoreList = response.data.list
          self.getPrinterList()
        }
      })
    },
    getPrinterList () {
      var self = this
      var data = {
        page: 1,
        size: 20
      }
      var url = '/printer/list?page=' + data.page + '&size=' + data.size
      if (this.searchResult) url = url + '&identity=' + this.searchResult
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerList = response.data.list
          if (self.printerList.length) self.isPrinterSelect = self.printerList[0].printer_id
          self.printerInfo = {
            identity: '',
            type: 1
          }
        }
      })
    },
    checkPrinter () {
      var msg = ''
      if (!this.printerInfo.identity && this.printerSelect === 1) {
        msg = '請輸入辨識碼'
      }
      this.getToast2(msg)
    },
    getToast2 (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (this.printerSelect === 1) this.addPrinter()
        else this.crPrinterStore(this.isPrinterSelect)
      }
    },
    addPrinter () {
      var self = this
      var url = '/printer'
      var info = this.printerInfo
      var data = {
        type: info.type,
        identity: info.identity
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.crPrinterStore(response.data.printer_id)
        }
      })
    },
    crPrinterStore (printerId) {
      var self = this
      var url = '/printer/storePrinter'
      var data = {
        printer_id: printerId,
        store_id: this.$route.params.store_id
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getPrinterStoreList()
        }
      })
    },
    printerType (type) {
      switch (type) {
        case 1: return 'W牌出單機(1)'
        case 2: return 'F牌出單機(2)'
        case 3: return 'F牌貼紙機(3)'
      }
    },
    selectOnChange (value) {
      this.change.binding_is_enabled = value
    },
    inputOnChange (value) {
      this.change.binding_name = value
    },
    trigger (event) {
      const type = this.$route.name.indexOf('up') > -1 ? 'up' : 'cr'
      if (event === 'delBinding') {
        this.delBinding()
      } else if (event === 'editBinding') {
        this.editBinding()
      } else if (event === 'save') {
        this.leave = true
        this.checkBeforeSend(type)
      } else if (event === 'saveAddress') {
        if (type === 'up') {
          this.originAddress = {
            city_code: this.storeInfo.city_code,
            area_code: this.storeInfo.area_code,
            address_short: this.storeInfo.address_short
          }
        }
        this.checkBeforeSend(type)
      } else if (event === 'saveEin') {
        // 統一編號不一致，使用者確認仍要儲存
        this.einConfirmed = true
        this.checkBeforeSend(this.einConfirmType)
      } else if (event === 'delExceptionProduct') {
        this.delExceptionProduct()
      }
    },
    delExceptionProduct () {
      let selectID = this.deliveryExceptionProductSelectItems.map(item => item.id)
      let data = {
        delivery_exception_product_setting: this.deliveryExceptionProductList.filter(item => !selectID.includes(item.id))
      }
      const url = '/store/' + this.$route.params.store_id
      this.getDataH('put', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          window.location.reload()
        }
      })
    },
    delBinding () {
      var self = this
      var url = '/printer/storePrinter/' + this.current.binding_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getPrinterStoreList()
        }
      })
    },
    editBinding () {
      var self = this
      var url = '/printer/storePrinter/' + this.current.binding_id
      var data = {
        is_enabled: this.change.binding_is_enabled
      }
      if (this.current.binding_name) data['name'] = this.change.binding_name
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.change = {
            is_enabled: 1,
            binding_name: ''
          }
          self.getPrinterStoreList()
        }
      })
    },
    getCurrent (obj) {
      this.current = obj
      this.editOption.body = '編輯出單機' + obj.printer_identity + '綁定'
      this.selectChange = obj.binding_is_enabled
      this.change = {
        is_enabled: obj.binding_is_enabled,
        binding_name: obj.binding_name
      }
    },
    clickClose (type, notSupport, val, index) {
      if (type === 'deliveryWays') {
        if (parseInt(val, 10) === 1) {
          this.$refs.pickupWarnModal.click()
          this.$nextTick(() => {
            // 支援與開啟狀態都必須為 1
            this.deliveryWaysInfo[index].is_enable = 1
            this.deliveryWaysInfo[index].is_support = 1
          })
        } else if (notSupport) {
          this.deliveryWaysInfo[index].is_enable = 0
          this.deliveryWaysInfo[index].is_support = 0
        }
      } else if (type === 'tradeType') {
        if (parseInt(val, 10) === 1) {
          this.$nextTick(() => {
            // 支援與開啟狀態都必須為 1
            this.tradeInfo[index].is_enable = 1
            this.tradeInfo[index].is_support = 1
          })
        }
      }
    },
    addExceptionTrade () {
      var obj = {
        delivery_type: 0,
        start_money: '',
        end_money: '',
        trade_type: 1
      }
      this.exceptionTradeList.push(obj)
    },
    exportUrl () {
      // 輸出桌號網址 csv
      if (this.tableNumberUrl.text) {
        const arr = this.tableNumberUrl.text.split(/,|\n|，/) // 依 , (全形與半形)與 \n (換行符號) 切割字串
        const csvFile = [
          ['入口', '桌號', '網址']
        ]
        arr.forEach(number => {
          const numberWithTrim = number.trim() // 去除前後空白
          if (numberWithTrim) {
            let row = []
            this.enterType.forEach(x => {
              if (x.value === this.tableNumberUrl.type) {
                let xUrl
                switch (window.location.hostname) {
                  case 'beta-nd-ecms-dev.nidin.shop':
                    xUrl = 'https://beta-nd-nl-package.nidin.shop'
                    break
                  default:
                    xUrl = x.url
                    break
                }
                let url = `${xUrl}/onSite/${this.$route.params.store_id}/store?tableNo=${numberWithTrim}`
                // 輸出 => [入口, 桌號, 網址]
                row.push(x.name, numberWithTrim, url)
                csvFile.push(row)
              }
            })
          }
        })
        if (csvFile.length > 1) {
          let data = csvFile.map(e => e.join(',')).join('\n')
          downloadFile(data, '桌號網址.csv', 'text/csv;charset=utf-8', new Uint8Array([0xEF, 0xBB, 0xBF]))
        }
      }
    },
    setTakeTime (type = '', item = {}) {
      // 10 的倍數加減
      let timeSeg = 0
      const val = item.take_time_seg
      if (type === 'add') {
        timeSeg = (Math.floor(val / 10) * 10) + 10
      } else if (type === 'minus' && val > 10) {
        timeSeg = (Math.ceil(val / 10) * 10) - 10
      }
      item.take_time_seg = timeSeg
    },
    clickOutsideCloseCalendar (event) {
      // 檢查點擊的地方是否在某日曆 item 上 或是 multiselect 內
      const calendarContainers = document.querySelectorAll('.calendar-container')
      calendarContainers.forEach((container, index) => {
        if (!container.contains(event.target)) {
          if (this.selectSpecialDay[index]) {
            this.selectSpecialDay[index].showSpecialDayCalendar = false
          }
        }
      })

      // 公休日期日曆
      const offDayCalendarContainers = document.querySelectorAll('.calendar-container')
      let clickedOutsideOffDayCalendar = true
      offDayCalendarContainers.forEach((container) => {
        if (container.contains(event.target)) {
          clickedOutsideOffDayCalendar = false
        }
      })
      if (clickedOutsideOffDayCalendar) {
        this.showCalendar = false
      }
    }
  },
  created () {
    if (!this.hasCommissionPermission) {
      this.crStep = this.crStep.filter(item => {
        return item !== 12
      })
    }
    this.init()
  },
  mounted () {
    if (this.$route.query['store-method']) {
      this.changeTab(this.$route.query['store-method'])
    }

    // 監聽 DOM，只對 class = calendar-multiselect 的 multiselect 移除 multiselect__content-wrapper 欄位
    const observer = new MutationObserver(() => {
      const calendarMultiselects = document.querySelectorAll('.calendar-multiselect')
      calendarMultiselects.forEach(multiselect => {
        // 只找與當前 calendar-multiselect 直接相關的 wrapper
        const directWrappers = multiselect.querySelectorAll('.multiselect__content-wrapper')
        directWrappers.forEach(wrapper => {
          wrapper.remove()
        })
      })
    })

    // 監聽 document.body 的變化
    observer.observe(document.body, {
      childList: true, // 監聽子元素列表的添加/刪除
      subtree: true // 監聽整個深層的樹形結構（所有層級）元素
    })
    // 監聽點擊事件，關閉日曆
    document.addEventListener('click', this.clickOutsideCloseCalendar)
  },
  beforeDestroy () {
    // 移除點擊事件監聽
    document.removeEventListener('click', this.clickOutsideCloseCalendar)
  },
  components: {
    'img-upload': ImgUploadTemp,
    'date-time-picker': datetimePicker,
    'shipping-form': ShippingForm,
    'm-modal': matcherModal,
    VueTimepicker,
    DatePicker,
    'delivery-limit': DeliveryLimit,
    'choose-store-modal': chooseStoreModal
  },
  computed: {
    ...mapGetters(['getRoleType', 'getRestricted', 'getDenyList']),
    // 公休時間不提供「無指定」(value 0)，選到會導致無法儲存
    offdayWeekDayOptions () {
      return this.offdaySetting.options.weekDay.filter(item => item.value)
    },
    offdayMonthDayOptions () {
      return this.offdaySetting.options.monthDay.filter(item => item.value)
    },
    checkInput () {
      return this.$parent.checkInput
    },
    checkDeliveryExceptionProductList () {
      // 是否可以複製排除商品到其他店家
      let list = this.deliveryExceptionProductList.filter(item => !item.id)
      if (this.deliveryExceptionProductList.length > 0 && list.length > 0) {
        return false
      }
      return true
    },
    calendarLimits () {
      return {
        min: moment().format('DD/MM/YYYY'),
        max: '31/12/2126'
      }
    },
    deliveryExceptionProductSelectItems () {
      return this.deliveryExceptionProductList.filter(item => item.selected)
    },
    /**
     * 檢查是否地址有變動
     * @description 檢查地址是否有變動，當基本資訊分頁籤，且地址有變動；回傳地址變動為 true 的布林值
     * @returns {Boolean} 是否地址有變動
     */
    addressChanged () {
      let sameCityCode = this.originAddress.city_code === this.citySelect
      let sameAreaCode = this.originAddress.area_code === this.areaSelect
      let sameAddressShort = this.originAddress.address_short === this.storeInfo.address_short
      const isAddressChanged = !sameCityCode || !sameAreaCode || !sameAddressShort
      return this.storeMethod === 1 && isAddressChanged
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    getInput () {
      const sInfo = this.storeInfo
      for (let key in sInfo) {
        if (!sInfo[key] && typeof sInfo[key] === 'object') sInfo[key] = ''
      }
      return {
        address_remark: this.checkInput(sInfo.address_remark),
        address_short: this.checkInput(sInfo.address_short.toString()),
        allow_copy_menu: this.checkInput(sInfo.allow_copy_menu),
        allow_update_menu: this.checkInput(sInfo.allow_update_menu),
        area_code: this.checkInput(sInfo.area_code.toString()),
        auto_reject_order_m: this.checkInput(sInfo.auto_reject_order_m.toString()),
        auto_reject_order_reserve_m: this.checkInput(sInfo.auto_reject_order_reserve_m.toString()),
        bg_image_name: this.checkInput(sInfo.bg_image_name.toString()),
        bl_name: this.checkInput(sInfo.bl_name.toString()),
        branch_code: this.checkInput(sInfo.branch_code.toString()),
        brand_name: this.checkInput(sInfo.brand_name.toString()),
        city_code: this.checkInput(sInfo.city_code.toString()),
        comment: this.checkInput(sInfo.comment.toString()),
        custom_sticker_max_length: this.checkInput(sInfo.custom_sticker_max_length),
        delivery_stage_limit_type: this.checkInput(sInfo.delivery_stage_limit_type),
        description: this.checkInput(sInfo.description.toString()),
        ein: this.checkInput(sInfo.ein.toString()),
        email: this.checkInput(sInfo.email.toString()),
        food_business_no: this.checkInput(sInfo.food_business_no.toString()),
        image_name: this.checkInput(sInfo.image_name.toString()),
        introduction: this.checkInput(sInfo.introduction.toString()),
        is_close_allow_order: this.checkInput(sInfo.is_close_allow_order),
        is_off_allow_order: this.checkInput(sInfo.is_off_allow_order),
        is_preparing_allow_order: this.checkInput(sInfo.is_preparing_allow_order),
        is_support_custom_remark: this.checkInput(sInfo.is_support_custom_remark),
        max_delivery_distance_m: this.checkInput(sInfo.max_delivery_distance_m.toString()),
        meat_origin_description: this.checkInput(sInfo.meat_origin_description.toString()),
        membership_provider_parent_id: this.checkInput(sInfo.membership_provider_parent_id),
        menu_ab_block_type: this.checkInput(sInfo.menu_ab_block_type),
        menu_expand_type: this.checkInput(sInfo.menu_expand_type),
        menu_layout_type: this.checkInput(sInfo.menu_layout_type),
        menu_stop_sale_today_type: this.checkInput(sInfo.menu_stop_sale_today_type),
        menu_stop_sale_type: this.checkInput(sInfo.menu_stop_sale_type),
        name: this.checkInput(sInfo.name.toString()),
        name_short: this.checkInput(sInfo.name_short.toString()),
        one_order_max_money: this.checkInput(sInfo.one_order_max_money.toString()),
        order_end_time_m: this.checkInput(sInfo.order_end_time_m.toString()),
        order_start_day: this.checkInput(sInfo.order_start_day.toString()),
        order_start_time_m: this.checkInput(sInfo.order_start_time_m.toString()),
        order_status_reason: this.checkInput(sInfo.order_status_reason),
        order_tolerance_day: this.checkInput(sInfo.order_tolerance_day.toString()),
        photo_name: this.checkInput(sInfo.photo_name.toString()),
        plastic_unit: this.checkInput(sInfo.plastic_unit.toString()),
        pos_branch_code: this.checkInput(sInfo.pos_branch_code.toString()),
        search_description: this.checkInput(sInfo.search_description.toString()),
        shipping_description: this.checkInput(sInfo.shipping_description),
        show_menu_product_icon: this.checkInput(sInfo.show_menu_product_icon),
        show_menu_zero_money: this.checkInput(sInfo.show_menu_zero_money),
        tel: this.checkInput(sInfo.tel.toString()),
        tel2: this.checkInput(sInfo.tel2.toString()),
        to_store_pay_max_money: this.checkInput(sInfo.to_store_pay_max_money.toString()),
        youtube_video_code: this.checkInput(sInfo.youtube_video_code)
      }
    },
    showTableNumber () {
      // 桌邊點餐開啟才顯示桌號設定
      const table = this.deliveryWaysInfo.find(item => {
        return item.take_type === 21
      })
      return table ? Number(table.is_enable) : 0
    },
    isEnableOnSite () {
      return Number(this.deliveryWaysInfo.find(i => i.take_type === 21).is_enable)
    },
    supportDeliveryOption () {
      // 支援的取餐方式
      let result = []
      this.deliveryWaysInfo.forEach(delivery => {
        if (parseInt(delivery.is_support, 10) === 1) {
          const data = this.deliveryTypeOption.find(option => {
            return option.value === delivery.take_type
          })
          if (data) result.push(data)
        }
      })
      return result
    },
    hasCommissionPermission () {
      // 擁有抽成對帳系統功能權限
      return this.getRestricted.includes(900)
    },
    supportShippingVendor () {
      // 支援的物流
      // is_visable = 1 才可顯示
      let result = []
      this.supportShippingVendorList.forEach(vendor => {
        const data = this.shippingVendorInfo.find(option => {
          return option.vendor_code === vendor.vendor_code && vendor.is_visable === 1
        })
        if (data) result.push(data)
      })
      return result
    },
    shippingInfo () {
      if (!this.deliveryWaysInfo) return {}
      return this.deliveryWaysInfo[2] || {}
    },
    hasInvoiceSelected () {
      return this.hasInvoiceCarrierSelect === 1 || this.hasInvoicePaperSelect === 1 || (this.getRoleType === 99 && this.hasInvoiceNpobnaSelect === 1)
    }
  },
  watch: {
    hasInvoiceCarrierSelect (val) {
      // 愛心載具跟電子載具同開同關
      this.hasInvoiceNpobnaSelect = val
    },
    posList: {
      handler: async function (list) {
        const set = new Set()
        this.realPostList = []
        this.repeatPosAccountList = list.filter(item => set.has(JSON.stringify(item.account)) ? true : (set.add(JSON.stringify(item.account)), false))
        this.realPostList = list.filter((item, index) => this.copyPostList[index] === undefined || JSON.stringify(item) !== JSON.stringify(this.copyPostList[index]))
        await this.cheakAllPostAccount()
      },
      deep: true
    },
    citySelect () {
      var cityCode = parseInt(this.citySelect, 10)
      var cityElement = this.cityAreaList.find(function (e, i, o) {
        return e.city_code === cityCode
      })
      let areaList = cityElement.area_list
      this.areaOption = []
      for (var i = 0; i < areaList.length; i++) {
        var option = {name: areaList[i].name, value: areaList[i].area_code}
        this.areaOption.push(option)
        if (i === 0 && (this.$route.name !== 'upStore' || this.areaTimes)) {
          this.areaSelect = option.value.toString()
        } else this.areaTimes = 1
      }
    },
    'storeInfo.city_code' () {
      if (this.$route.name === 'upStore') this.areaSelect = this.storeInfo.area_code
    },
    imgLogoSelect () {
      var self = this
      if (self.imgLogoSelect) {
        let imgSrc = this.imgLogoOption.find(function (e) {
          return e.name === self.imgLogoSelect
        }).value
        this.storeInfo.image_name = imgSrc
      }
    },
    imgBgSelect () {
      var self = this
      if (self.imgBgSelect) {
        let imgSrc = this.imgBgOption.find(function (e) {
          return e.name === self.imgBgSelect
        }).value
        this.storeInfo.bg_image_name = imgSrc
      }
    },
    'tableNumber.sub_delivery_type' (val) {
      if (val === 1) {
        this.tableNumber.is_table_no_required = 0
        this.tableNumber.show_table_no = 0
      }
    },
    'copyInfo.productAlias' (val) {
      this.copyInfo.productDescription = val
      if (!val) {
        this.copyInfo.productAliasStoreId = null
      }
    },
    'copyInfo.productAliasStoreId' (val) {
      this.copyInfo.productDescriptionStoreId = val
    },
    hasInvoiceSelected (val) {
      if (val) {
        this.isInvoiceException = 0
      } else {
        this.isInvoiceException = 1
      }
    },
    shippingInfo: {
      deep: true,
      handler (val) {
        if (typeof val.is_enable === 'string') {
          val.is_enable = Number(val.is_enable)
        }
        if (typeof val.is_support === 'string') {
          val.is_support = Number(val.is_support)
        }
      }
    },
    /**
     * 外送金額
     * 第一段「滿{A}元即可外送」，需要與新增的第二段「滿{B}元可外送 {C}公尺以內」，{A}的直需要同步連動更改於{B}
     */
    deliveryWaysInfo: {
      deep: true,
      handler (val) {
        if (typeof this.deliveryOther[0] !== 'undefined' && this.deliveryOther[0] !== null) {
          this.deliveryOther[0].price = val[2].price
          if (!val[2].price) {
            val[2].price = 0
            this.deliveryOther[0].price = 0
          }
          this.deliveryOther[0].price = Number(this.deliveryOther[0].price)
          val[2].price = Number(val[2].price)
        }
      }
    },
    /** 更新「網址跳轉設定」門市 ID */
    'urlRedirection.new_store_info' (val, oldVal) {
      if (val && Array.isArray(val) && val.length) {
        this.urlRedirection.new_store_id = val[0].store_id
      } else {
        this.urlRedirection.new_store_id = 0
      }
    },
    storeMethod () {
      if (this.$route.name === 'upStore') {
        this.$router.replace({
          name: 'upStore',
          query: {
            'store-method': this.storeMethod
          },
          params: {
            brand_id: this.$route.params.brand_id,
            store_id: this.$route.params.store_id
          }
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  // 統一編號不一致提醒彈窗
  .ein-row
    display: flex
    flex-wrap: wrap
  .ein-col
    padding: 0 5px !important
  .ein-card
    height: 100%
    padding: 15px
    border-radius: 6px
    background-color: #f0f0f0
  .ein-card-title
    margin-bottom: 10px
    font-size: 16px
    font-weight: 600
  .ein-card-item
    line-height: 2
  .ein-card-dot
    margin-right: 2px
  .ein-card-list
    margin: 0
    padding-left: 32px
    line-height: 2
  .ein-tag
    display: inline-block
    padding: 2px 10px
    border-radius: 4px
    background-color: #5b9bd5
    color: #fff
  .ein-message
    margin: 15px 0 0
  .btn-close
    line-height: 1.1
  .w-300
    width: 300px
  .radio+.radio
    margin-top: initial
  .radio input:disabled ~ .radio-text--disabled
    opacity: 0.5
  .visibility-hidden
    visibility: hidden
  .cursor-none
    cursor: default
    &:hover
      color: #3c8dbc
      background-color: transparent
      border: 1px solid transparent
      margin-bottom: none
  .text-align-left
    text-align: left !important
  .calendar-container
    position: relative
    width: 100%
    min-width: 150px
  .calendar
    position: absolute
    z-index: 1001
    background: #fff
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1)
    max-width: 290px
  .calenderClose
    position: absolute
    z-index: 1000
    top: 300px
    left: 186px
  .specialDayCalendarTable-responsive
    min-height: 450px
    overflow-y: auto
  .sticky-header
    position: sticky
    top: 0
    z-index: 10
  .date-picker-cell
    width: 500px
    vertical-align: top
  .remark-cell
    width: 300px
    min-width: 300px
    vertical-align: top
  .multiselect
    white-space: normal !important
    word-wrap: break-word !important
    min-height: 38px
    width: 100%
  @media (max-width: 768px)
    .calendar-container
      max-width: 100%
      width: 100%
    .date-picker-cell
      width: auto
      max-width: 100%
    .remark-cell
      width: auto
      min-width: 200px

  .mr-auto
    margin-right: auto !important
  .ml-auto
    margin-left: auto !important
  .multiselect__content-wrapper
    z-index: 9999 !important
    position: absolute
  .deliveryExceptionInput
    min-height: 40px
    display: block
    border-radius: 5px
    border: 1px solid #e8e8e8
    background: #fff
    padding: 8px
  .deliveryExceptionInput::placeholder
    font-size: 14px
    color: #adadad

</style>



// WEBPACK FOOTER //
// StoreFormTemp.vue?8b58f24e